/* eslint-disable */
// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,add_pb_suffix,ts_nocheck,eslint_disable
// @generated from protobuf file "api/sale/service.proto" (package "rd.api.sale", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { TimestampRange } from "../../proto/timestamprange/models_pb";
import { Sale_Totals_AdditionalFee } from "../../txn/models_pb";
import { SaleProduct_TallyRow } from "../../txn/models_pb";
import { CCPRebateReportUpload } from "../../txn/models_pb";
import { SaleForm_CustomField } from "../../company/models_pb";
import { SaleCountBySource } from "../../txn/models_pb";
import { LedgerMethods_Method } from "../../ledger/models_pb";
import { OrderShipment_Status } from "../../txn/models_pb";
import { Order_Status } from "../../txn/models_pb";
import { AppliedCoupon } from "../../txn/models_pb";
import { DeliveryStop } from "../../txn/models_pb";
import { TierPrices } from "../../price/models_pb";
import { LedgerMethods } from "../../ledger/models_pb";
import { CreditHistoryLink } from "../../txn/models_pb";
import { Sale_Totals } from "../../txn/models_pb";
import { Product as Product$ } from "../../catalog/models_pb";
import { Inventories } from "../../product/models_pb";
import { Contacts_Contact } from "../../customer/models_pb";
import { TintColor } from "../../tintcolor/models_pb";
import { PurchaseOrder } from "../../customer/models_pb";
import { Location } from "../../company/models_pb";
import { Sale } from "../../txn/models_pb";
import { Product } from "../../product/models_pb";
import { SaleProduct_AdditionalFee } from "../../txn/models_pb";
import { RuleInformation } from "../../price/models_pb";
import { SaleTaxes } from "../../txn/models_pb";
import { TotalsLineItem } from "../../txn/models_pb";
import { FractionalMoney } from "../../proto/money/models_pb";
import { SaleProduct_Type } from "../../txn/models_pb";
import { TaxLine } from "../../txn/models_pb";
import { TaxRate } from "../../company/models_pb";
import { InitialDepositIntent } from "../../txn/models_pb";
import { DeliveryDetails } from "../../txn/models_pb";
import { DepositConfig } from "../../txn/models_pb";
import { Sale_ItemSet } from "../../txn/models_pb";
import { TenderSubmissionMetadata } from "../../txn/models_pb";
import { Money } from "../../proto/money/models_pb";
import { Address } from "../../proto/address/models_pb";
import { SaleProduct } from "../../txn/models_pb";
import { Decimal } from "../../proto/decimal/models_pb";
import { Sale_Status } from "../../txn/models_pb";
import { Timestamp } from "../../google/protobuf/timestamp_pb";
import { UUID } from "../../proto/uuid/models_pb";
/**
 * @generated from protobuf message rd.api.sale.UpsertSaleV3Req
 */
export interface UpsertSaleV3Req {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID customer_id = 2
     */
    customerId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID location_id = 5
     */
    locationId?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp quote_expires_at = 6
     */
    quoteExpiresAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.txn.Sale.Status status = 7
     */
    status: Sale_Status;
    /**
     * @generated from protobuf field: string notes = 8
     */
    notes: string;
    /**
     * @generated from protobuf field: string customer_purchase_order_name = 10
     */
    customerPurchaseOrderName: string;
    /**
     * @generated from protobuf field: repeated string customer_contact_id_strings = 11
     */
    customerContactIdStrings: string[];
    /**
     * @generated from protobuf field: repeated string additional_emails = 12
     */
    additionalEmails: string[];
    /**
     * @generated from protobuf field: string customer_contact_id_string = 13
     */
    customerContactIdString: string;
    /**
     * @generated from protobuf field: string stripe_reader_id = 15
     */
    stripeReaderId: string;
    /**
     * Deprecated: use tax_rate_ids.
     *
     * @generated from protobuf field: rd.proto.uuid.UUID tax_rate_id = 16
     */
    taxRateId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal card_surcharge_rate = 17
     */
    cardSurchargeRate?: Decimal;
    /**
     * @generated from protobuf field: string idempotency_key = 18
     */
    idempotencyKey: string;
    /**
     * @generated from protobuf field: repeated rd.txn.SaleProduct productsV2 = 19
     */
    productsV2: SaleProduct[];
    /**
     * @generated from protobuf field: string internal_notes = 20
     */
    internalNotes: string;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID printer_id = 21
     */
    printerId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.address.Address address = 22
     */
    address?: Address;
    /**
     * @generated from protobuf field: rd.proto.money.Money restock_fee_amount = 26
     */
    restockFeeAmount?: Money;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal restock_fee_percentage = 27
     */
    restockFeePercentage?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID fulfillment_location_id = 28
     */
    fulfillmentLocationId?: UUID;
    /**
     * @generated from protobuf field: bool is_delivery_fulfillment = 29
     */
    isDeliveryFulfillment: boolean;
    /**
     * @generated from protobuf field: rd.proto.money.Money additional_deposit = 30
     */
    additionalDeposit?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money discount_amount = 34
     */
    discountAmount?: Money;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal discount_rate = 35
     */
    discountRate?: Decimal;
    /**
     * @generated from protobuf field: rd.txn.TenderSubmissionMetadata return_tender_submission = 36
     */
    returnTenderSubmission?: TenderSubmissionMetadata;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp delivery_date = 37
     */
    deliveryDate?: Timestamp;
    /**
     * @generated from protobuf field: string customer_contact_name = 38
     */
    customerContactName: string;
    /**
     * @generated from protobuf field: repeated rd.txn.TenderSubmissionMetadata tender_submissions = 39
     */
    tenderSubmissions: TenderSubmissionMetadata[];
    /**
     * @generated from protobuf field: rd.txn.TenderSubmissionMetadata deposit_refund_tender_submission_metadata = 40
     */
    depositRefundTenderSubmissionMetadata?: TenderSubmissionMetadata;
    /**
     * @generated from protobuf field: map<string, rd.txn.Sale.ItemSet> item_sets_by_id = 41
     */
    itemSetsById: {
        [key: string]: Sale_ItemSet;
    };
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID designated_clerk_id = 42
     */
    designatedClerkId?: UUID;
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID tax_rate_ids = 43
     */
    taxRateIds: UUID[];
    /**
     * @generated from protobuf field: rd.txn.DepositConfig deposit_config = 44
     */
    depositConfig?: DepositConfig;
    /**
     * Principal deposit to refund (without surcharge).
     *
     * @generated from protobuf field: rd.proto.money.Money principal_to_refund = 45
     */
    principalToRefund?: Money;
    /**
     * Overrides the company's is_price_shown_on_will_call for the will-call
     * customer notification and ticket. UNDEFINED falls back to the company
     * setting.
     *
     * @generated from protobuf field: rd.api.sale.ShowPricesOption will_call_show_prices = 46
     */
    willCallShowPrices: ShowPricesOption;
    /**
     * @generated from protobuf field: rd.txn.DeliveryDetails delivery_details = 47
     */
    deliveryDetails?: DeliveryDetails;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID delivery_id = 48
     */
    deliveryId?: UUID;
    /**
     * user supplied deposit intent
     * only used behind generalized deposits close outs flag
     *
     * @generated from protobuf field: rd.txn.InitialDepositIntent initial_deposit_intent = 49
     */
    initialDepositIntent?: InitialDepositIntent;
    /**
     * Fan Builder coupons on this cart. They discount the sale, so they travel with the rest of the
     * cart state rather than needing a saved sale. Reporting them to CES is a separate step.
     *
     * @generated from protobuf field: rd.api.sale.SaleFanBuilderCoupons fan_builder_coupons = 50
     */
    fanBuilderCoupons?: SaleFanBuilderCoupons;
}
/**
 * @generated from protobuf message rd.api.sale.UpsertSaleV3Res
 */
export interface UpsertSaleV3Res {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: bool email_error = 2
     */
    emailError: boolean;
    /**
     * @generated from protobuf field: string signature_url = 3
     */
    signatureUrl: string;
    /**
     * @generated from protobuf field: bool show_linked_products_on_receipt = 4
     */
    showLinkedProductsOnReceipt: boolean; // whether or not to include linked sale products on receipt for special orders
}
/**
 * @generated from protobuf message rd.api.sale.CloseOutSaleReq
 */
export interface CloseOutSaleReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: map<string, rd.api.sale.CloseOutSaleReq.SaleProductToCloseOut> sale_products_to_close_out_by_id = 2
     */
    saleProductsToCloseOutById: {
        [key: string]: CloseOutSaleReq_SaleProductToCloseOut;
    };
    /**
     * @generated from protobuf field: string idempotency_key = 4
     */
    idempotencyKey: string;
    /**
     * @generated from protobuf field: repeated rd.txn.TenderSubmissionMetadata tender_submissions = 5
     */
    tenderSubmissions: TenderSubmissionMetadata[];
    /**
     * @generated from protobuf field: string stripe_reader_id = 6
     */
    stripeReaderId: string;
    /**
     * @generated from protobuf field: string sale_notes = 7
     */
    saleNotes: string;
    /**
     * @generated from protobuf field: string internal_notes = 8
     */
    internalNotes: string;
    /**
     * @generated from protobuf field: string customer_purchase_order_name = 9
     */
    customerPurchaseOrderName: string;
    /**
     * @generated from protobuf field: rd.proto.address.Address address = 10
     */
    address?: Address;
    /**
     * @generated from protobuf field: string customer_contact_id_string = 11
     */
    customerContactIdString: string;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID fulfillment_location_id = 12
     */
    fulfillmentLocationId?: UUID;
    /**
     * @generated from protobuf field: bool is_delivery_fulfillment = 13
     */
    isDeliveryFulfillment: boolean;
    /**
     * Deprecated: use tax_rate_ids.
     *
     * @generated from protobuf field: rd.proto.uuid.UUID tax_rate_id = 14
     */
    taxRateId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID printer_id = 15
     */
    printerId?: UUID;
    /**
     * @generated from protobuf field: rd.txn.TenderSubmissionMetadata return_tender_submission = 16
     */
    returnTenderSubmission?: TenderSubmissionMetadata;
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID tax_rate_ids = 17
     */
    taxRateIds: UUID[];
    /**
     * @generated from protobuf field: rd.proto.money.Money principal_to_redeem = 18
     */
    principalToRedeem?: Money;
    /**
     * @generated from protobuf field: rd.txn.DeliveryDetails delivery_details = 19
     */
    deliveryDetails?: DeliveryDetails;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID delivery_id = 20
     */
    deliveryId?: UUID;
    /**
     * @generated from protobuf field: bool add_delivery_details_to_original_sale = 21
     */
    addDeliveryDetailsToOriginalSale: boolean;
}
/**
 * @generated from protobuf message rd.api.sale.CloseOutSaleReq.SaleProductToCloseOut
 */
export interface CloseOutSaleReq_SaleProductToCloseOut {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal qty = 2
     */
    qty?: Decimal;
}
/**
 * @generated from protobuf message rd.api.sale.CloseOutSaleRes
 */
export interface CloseOutSaleRes {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID; // original sale ID
    /**
     * @generated from protobuf field: bool email_error = 2
     */
    emailError: boolean;
    /**
     * @generated from protobuf field: string signature_url = 3
     */
    signatureUrl: string;
}
/**
 * @generated from protobuf message rd.api.sale.CalculatePartialCloseoutTotalsReq
 */
export interface CalculatePartialCloseoutTotalsReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID sale_id = 1
     */
    saleId?: UUID;
    /**
     * @generated from protobuf field: map<string, rd.proto.decimal.Decimal> quantities_to_close_out_by_sale_product_id = 2
     */
    quantitiesToCloseOutBySaleProductId: {
        [key: string]: Decimal;
    };
    /**
     * @generated from protobuf field: bool is_card_surcharge_disabled = 4
     */
    isCardSurchargeDisabled: boolean;
    /**
     * @generated from protobuf field: bool is_card_payment = 5
     */
    isCardPayment: boolean;
    /**
     * @generated from protobuf field: rd.proto.money.Money principal_to_redeem = 6
     */
    principalToRedeem?: Money;
}
/**
 * @generated from protobuf message rd.api.sale.CalculatePartialCloseoutTotalsRes
 */
export interface CalculatePartialCloseoutTotalsRes {
    /**
     * @generated from protobuf field: rd.proto.money.Money subtotal = 1
     */
    subtotal?: Money;
    /**
     * @generated from protobuf field: map<string, rd.proto.money.Money> additional_fees_by_name = 2
     */
    additionalFeesByName: {
        [key: string]: Money;
    };
    /**
     * @generated from protobuf field: rd.proto.money.Money total = 3
     */
    total?: Money; // includes payment card surcharge, surcharge tax
    /**
     * @generated from protobuf field: rd.proto.money.Money payment_card_surcharge = 4
     */
    paymentCardSurcharge?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money payment_card_surcharge_tax = 5
     */
    paymentCardSurchargeTax?: Money;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal payment_card_surcharge_rate = 6
     */
    paymentCardSurchargeRate?: Decimal;
    /**
     * @generated from protobuf field: rd.company.TaxRate tax_rate = 7
     */
    taxRate?: TaxRate;
    /**
     * @generated from protobuf field: rd.proto.money.Money closeout_card_surcharge = 9
     */
    closeoutCardSurcharge?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money closeout_card_surcharge_tax = 10
     */
    closeoutCardSurchargeTax?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money remaining_total = 11
     */
    remainingTotal?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money total_due_today = 12
     */
    totalDueToday?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money discount_applied = 14
     */
    discountApplied?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money returned_card_surcharge = 15
     */
    returnedCardSurcharge?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money returned_card_surcharge_tax = 16
     */
    returnedCardSurchargeTax?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money min_principal_to_redeem = 17
     */
    minPrincipalToRedeem?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money max_principal_to_redeem = 18
     */
    maxPrincipalToRedeem?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money deposit_to_redeem = 19
     */
    depositToRedeem?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money deposit_surcharge_to_redeem = 20
     */
    depositSurchargeToRedeem?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money deposit_surcharge_tax_to_redeem = 21
     */
    depositSurchargeTaxToRedeem?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money restock_fee = 22
     */
    restockFee?: Money;
    /**
     * Per-rate base tax breakdown; the card fee taxes stay on the surcharge fields.
     *
     * @generated from protobuf field: repeated rd.txn.TaxLine base_taxes = 23
     */
    baseTaxes: TaxLine[];
    /**
     * surcharge taxes by rate id for the new card payment
     *
     * @generated from protobuf field: repeated rd.txn.TaxLine payment_surcharge_taxes = 24
     */
    paymentSurchargeTaxes: TaxLine[];
    /**
     * @generated from protobuf field: int32 loyalty_points_to_be_earned = 25
     */
    loyaltyPointsToBeEarned: number;
}
/**
 * @generated from protobuf message rd.api.sale.GetCartPricesReq
 */
export interface GetCartPricesReq {
}
/**
 * @generated from protobuf message rd.api.sale.GetCartPricesReq.CartProduct
 */
export interface GetCartPricesReq_CartProduct {
}
/**
 * @generated from protobuf message rd.api.sale.GetCartPricesRes
 */
export interface GetCartPricesRes {
}
/**
 * @generated from protobuf message rd.api.sale.GetCartPricesRes.AdditionalFeeTotal
 */
export interface GetCartPricesRes_AdditionalFeeTotal {
}
/**
 * @generated from protobuf message rd.api.sale.GetCartPricesRes.ProductPriceInformation
 */
export interface GetCartPricesRes_ProductPriceInformation {
}
/**
 * @generated from protobuf message rd.api.sale.SyncCartPricesReq
 */
export interface SyncCartPricesReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID location_id = 1
     */
    locationId?: UUID;
    /**
     * @generated from protobuf field: repeated rd.api.sale.SyncCartPricesReq.CartProduct cart = 2
     */
    cart: SyncCartPricesReq_CartProduct[];
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID customer_id = 3
     */
    customerId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID sale_id = 4
     */
    saleId?: UUID;
    /**
     * @generated from protobuf field: string stripe_reader_id = 5
     */
    stripeReaderId: string;
    /**
     * Deprecated: use tax_rate_ids.
     *
     * @generated from protobuf field: rd.proto.uuid.UUID tax_rate_id = 7
     */
    taxRateId?: UUID;
    /**
     * @generated from protobuf field: bool is_special_order_closeout = 9
     */
    isSpecialOrderCloseout: boolean;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal restock_fee_percentage = 10
     */
    restockFeePercentage?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.money.Money restock_fee_amount = 11
     */
    restockFeeAmount?: Money;
    /**
     * @generated from protobuf field: bool skip_card_reader_sync = 12
     */
    skipCardReaderSync: boolean;
    /**
     * @generated from protobuf field: rd.proto.money.Money additional_deposit = 13
     */
    additionalDeposit?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money discount_amount = 17
     */
    discountAmount?: Money;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal discount_rate = 18
     */
    discountRate?: Decimal;
    /**
     * Used for indicating deposit to refund while voiding a sale.
     *
     * @generated from protobuf field: rd.proto.money.Money deposit_refund_amount = 19
     */
    depositRefundAmount?: Money;
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID tax_rate_ids = 20
     */
    taxRateIds: UUID[];
    /**
     * @generated from protobuf field: rd.txn.DepositConfig deposit_config = 21
     */
    depositConfig?: DepositConfig;
    /**
     * Used for indicating principal deposit to refund (without surcharge)
     * in non void case.
     *
     * @generated from protobuf field: rd.proto.money.Money principal_to_refund = 22
     */
    principalToRefund?: Money;
    /**
     * @generated from protobuf field: bool separate_special_order_and_stock_totals = 23
     */
    separateSpecialOrderAndStockTotals: boolean;
    /**
     * @generated from protobuf field: bool is_additional_deposit = 24
     */
    isAdditionalDeposit: boolean;
    /**
     * @generated from protobuf field: bool is_refund_deposit = 25
     */
    isRefundDeposit: boolean;
    /**
     * @generated from protobuf field: bool is_initial_deposit = 26
     */
    isInitialDeposit: boolean;
    /**
     * user supplied deposit intent
     * only used behind generalized deposits close outs flag
     *
     * @generated from protobuf field: rd.txn.InitialDepositIntent initial_deposit_intent = 27
     */
    initialDepositIntent?: InitialDepositIntent;
    /**
     * @generated from protobuf field: rd.proto.address.Address address = 28
     */
    address?: Address;
    /**
     * Fan Builder coupons on the cart. They discount the total the cashier sees, so cart pricing has
     * to know about them before the sale is ever saved.
     *
     * @generated from protobuf field: rd.api.sale.SaleFanBuilderCoupons fan_builder_coupons = 29
     */
    fanBuilderCoupons?: SaleFanBuilderCoupons;
}
/**
 * @generated from protobuf message rd.api.sale.SyncCartPricesReq.CartProduct
 */
export interface SyncCartPricesReq_CartProduct {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID product_id = 1
     */
    productId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.money.Money product_edited_price = 3
     */
    productEditedPrice?: Money;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 5
     */
    id?: UUID;
    /**
     * @generated from protobuf field: bool is_special_orderable_v2 = 7
     */
    isSpecialOrderableV2: boolean;
    /**
     * @generated from protobuf field: rd.txn.SaleProduct.Type sale_product_type = 8
     */
    saleProductType: SaleProduct_Type;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID returned_from_sale_product_id = 9
     */
    returnedFromSaleProductId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal quantity_v2 = 10
     */
    quantityV2?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal quantity_returned_v2 = 11
     */
    quantityReturnedV2?: Decimal;
    /**
     * Optional unit-of-measure metadata for the cart line.
     * When provided, quantity_v2 should still represent the quantity in the
     * product's base unit; quantity_uom is the physical quantity in the selected unit of measure.
     *
     * @generated from protobuf field: rd.proto.uuid.UUID uom_id = 12
     */
    uomId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal quantity_uom = 13
     */
    quantityUom?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID uom_id_returned = 14
     */
    uomIdReturned?: UUID;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal quantity_returned_uom = 15
     */
    quantityReturnedUom?: Decimal;
    /**
     * @generated from protobuf field: bool is_taxed = 16
     */
    isTaxed: boolean;
    /**
     * @generated from protobuf field: bool is_taxed_edited = 17
     */
    isTaxedEdited: boolean;
    /**
     * @generated from protobuf field: repeated string disabled_additional_fee_ids = 18
     */
    disabledAdditionalFeeIds: string[];
    /**
     * @generated from protobuf field: rd.proto.money.FractionalMoney product_edited_price_fractional = 19
     */
    productEditedPriceFractional?: FractionalMoney;
    /**
     * @generated from protobuf field: bool is_price_edited = 20
     */
    isPriceEdited: boolean;
}
/**
 * @generated from protobuf message rd.api.sale.SyncCartPricesRes
 */
export interface SyncCartPricesRes {
    /**
     * @generated from protobuf field: rd.proto.money.Money subtotal = 1
     */
    subtotal?: Money;
    /**
     * @generated from protobuf field: map<string, rd.api.sale.SyncCartPricesRes.AdditionalFeeTotal> additional_fees_by_fee_id = 2
     */
    additionalFeesByFeeId: {
        [key: string]: SyncCartPricesRes_AdditionalFeeTotal;
    };
    /**
     * @generated from protobuf field: rd.proto.money.Money base_sales_tax = 3
     */
    baseSalesTax?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money total = 4
     */
    total?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money amount_to_refund = 8
     */
    amountToRefund?: Money;
    /**
     * @generated from protobuf field: rd.company.TaxRate tax_rate = 9
     */
    taxRate?: TaxRate;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal card_surcharge_rate = 10
     */
    cardSurchargeRate?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.money.Money card_surcharge = 11
     */
    cardSurcharge?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money card_surcharge_tax = 12
     */
    cardSurchargeTax?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money total_due_today = 13
     */
    totalDueToday?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money deposit_total = 15
     */
    depositTotal?: Money;
    /**
     * @generated from protobuf field: map<string, rd.api.sale.SyncCartPricesRes.ProductPriceInformation> prices_by_sale_product_id = 16
     */
    pricesBySaleProductId: {
        [key: string]: SyncCartPricesRes_ProductPriceInformation;
    };
    /**
     * @generated from protobuf field: rd.proto.money.Money total_returned_surcharge = 17
     */
    totalReturnedSurcharge?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money total_returned_surcharge_tax = 18
     */
    totalReturnedSurchargeTax?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money total_restock_fee = 20
     */
    totalRestockFee?: Money;
    /**
     * @generated from protobuf field: rd.api.sale.SyncCartPricesRes.SpecialOrderTotalsInfo special_order_totals_info = 21
     */
    specialOrderTotalsInfo?: SyncCartPricesRes_SpecialOrderTotalsInfo;
    /**
     * @generated from protobuf field: rd.proto.money.Money discount_applied = 22
     */
    discountApplied?: Money;
    /**
     * @generated from protobuf field: repeated rd.txn.TotalsLineItem combined_totals_line_items = 23
     */
    combinedTotalsLineItems: TotalsLineItem[];
    /**
     * @generated from protobuf field: repeated rd.txn.TotalsLineItem due_today_line_items = 24
     */
    dueTodayLineItems: TotalsLineItem[];
    /**
     * @generated from protobuf field: rd.api.sale.SyncCartPricesRes.StockAndReturnTotalsInfo stock_and_return_totals_info = 25
     */
    stockAndReturnTotalsInfo?: SyncCartPricesRes_StockAndReturnTotalsInfo;
    /**
     * Total across parent + all closed-out child sales. Populated only when children exist.
     *
     * @generated from protobuf field: rd.proto.money.Money overall_total = 26
     */
    overallTotal?: Money;
    /**
     * Total across all closed-out child sales. Populated only when children exist.
     *
     * @generated from protobuf field: rd.proto.money.Money closed_out_total = 27
     */
    closedOutTotal?: Money;
    /**
     * @generated from protobuf field: repeated rd.txn.TotalsLineItem closeout_children_breakdown_line_items = 28
     */
    closeoutChildrenBreakdownLineItems: TotalsLineItem[];
    /**
     * @generated from protobuf field: repeated rd.txn.TotalsLineItem overall_totals_line_items = 29
     */
    overallTotalsLineItems: TotalsLineItem[];
    /**
     * void scenario
     *
     * @generated from protobuf field: rd.proto.money.Money minimum_deposit_to_refund = 30
     */
    minimumDepositToRefund?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money maximum_deposit_to_refund = 31
     */
    maximumDepositToRefund?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money initial_deposit = 32
     */
    initialDeposit?: Money;
    /**
     * Per-rate tax breakdown across the whole cart (this sale plus its linked
     * returns); includes both base and card-fee (surcharge) tax lines.
     *
     * @generated from protobuf field: rd.txn.SaleTaxes sale_taxes = 33
     */
    saleTaxes?: SaleTaxes;
    /**
     * non void refund deposit scenario
     *
     * @generated from protobuf field: rd.proto.money.Money minimum_principal_to_refund = 34
     */
    minimumPrincipalToRefund?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money maximum_principal_to_refund = 35
     */
    maximumPrincipalToRefund?: Money;
    /**
     * for display
     *
     * @generated from protobuf field: rd.proto.money.Money principal_to_refund = 36
     */
    principalToRefund?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money deposit_to_refund_surcharge = 37
     */
    depositToRefundSurcharge?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money deposit_to_refund_surcharge_tax = 38
     */
    depositToRefundSurchargeTax?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money sold_subtotal = 39
     */
    soldSubtotal?: Money; // subtotal excluding linked returns
    /**
     * @generated from protobuf field: rd.proto.money.Money deposit_basis = 40
     */
    depositBasis?: Money;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal initial_deposit_rate = 41
     */
    initialDepositRate?: Decimal;
    /**
     * @generated from protobuf field: repeated rd.api.sale.SyncCartPricesRes.AddedProduct added_products = 42
     */
    addedProducts: SyncCartPricesRes_AddedProduct[];
    /**
     * @generated from protobuf field: rd.proto.money.Money subtotal_excluding_returns = 43
     */
    subtotalExcludingReturns?: Money; // subtotal of cart items excluding both linked and unlinked returns
    /**
     * @generated from protobuf field: int32 loyalty_points_to_be_earned = 44
     */
    loyaltyPointsToBeEarned: number;
}
/**
 * @generated from protobuf message rd.api.sale.SyncCartPricesRes.AdditionalFeeTotal
 */
export interface SyncCartPricesRes_AdditionalFeeTotal {
    /**
     * @generated from protobuf field: string fee_id = 1
     */
    feeId: string;
    /**
     * @generated from protobuf field: string name = 2
     */
    name: string;
    /**
     * @generated from protobuf field: rd.proto.money.Money fee = 3
     */
    fee?: Money;
}
/**
 * @generated from protobuf message rd.api.sale.SyncCartPricesRes.ProductPriceInformation
 */
export interface SyncCartPricesRes_ProductPriceInformation {
    /**
     * @generated from protobuf field: string product_id_string = 1
     */
    productIdString: string;
    /**
     * @generated from protobuf field: rd.proto.money.Money unit_price = 2
     */
    unitPrice?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money total_price = 3
     */
    totalPrice?: Money;
    /**
     * @generated from protobuf field: rd.price.RuleInformation rule_information = 4
     */
    ruleInformation?: RuleInformation;
    /**
     * @generated from protobuf field: rd.proto.money.FractionalMoney unit_fee = 5
     */
    unitFee?: FractionalMoney;
    /**
     * @generated from protobuf field: bool is_taxed = 6
     */
    isTaxed: boolean;
    /**
     * Per-fee breakdown matching the SaleProduct.additional_fees shape so the
     * FE tooltip can render a per-name breakdown without re-deriving
     * rate-based fees from the cart product config.
     *
     * @generated from protobuf field: repeated rd.txn.SaleProduct.AdditionalFee additional_fees = 7
     */
    additionalFees: SaleProduct_AdditionalFee[];
    /**
     * @generated from protobuf field: rd.proto.money.FractionalMoney unit_price_fractional = 8
     */
    unitPriceFractional?: FractionalMoney;
}
/**
 * @generated from protobuf message rd.api.sale.SyncCartPricesRes.SpecialOrderTotalsInfo
 */
export interface SyncCartPricesRes_SpecialOrderTotalsInfo {
    /**
     * @generated from protobuf field: rd.proto.money.Money subtotal = 1
     */
    subtotal?: Money;
    /**
     * @generated from protobuf field: map<string, rd.api.sale.SyncCartPricesRes.AdditionalFeeTotal> additional_fees_by_fee_id = 2
     */
    additionalFeesByFeeId: {
        [key: string]: SyncCartPricesRes_AdditionalFeeTotal;
    };
    /**
     * @generated from protobuf field: rd.proto.money.Money sales_tax = 3
     */
    salesTax?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money deposit_taken = 4
     */
    depositTaken?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money discount_applied = 5
     */
    discountApplied?: Money;
    /**
     * Per-rate base sales tax for the special order products.
     *
     * @generated from protobuf field: repeated rd.txn.TaxLine base_taxes = 6
     */
    baseTaxes: TaxLine[];
}
/**
 * @generated from protobuf message rd.api.sale.SyncCartPricesRes.StockAndReturnTotalsInfo
 */
export interface SyncCartPricesRes_StockAndReturnTotalsInfo {
    /**
     * @generated from protobuf field: rd.proto.money.Money subtotal = 1
     */
    subtotal?: Money;
    /**
     * @generated from protobuf field: map<string, rd.api.sale.SyncCartPricesRes.AdditionalFeeTotal> additional_fees_by_fee_id = 2
     */
    additionalFeesByFeeId: {
        [key: string]: SyncCartPricesRes_AdditionalFeeTotal;
    };
    /**
     * @generated from protobuf field: rd.proto.money.Money sales_tax = 3
     */
    salesTax?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money discount_applied = 4
     */
    discountApplied?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money total = 5
     */
    total?: Money;
    /**
     * Per-rate base sales tax for the stock products and linked returns.
     *
     * @generated from protobuf field: repeated rd.txn.TaxLine base_taxes = 6
     */
    baseTaxes: TaxLine[];
}
/**
 * AddedProduct is a priced line the pricing engine added that was not in the
 * cart (e.g. PPC's surcharge). Clients add it to the cart; it is then sent
 * like any other line.
 *
 * @generated from protobuf message rd.api.sale.SyncCartPricesRes.AddedProduct
 */
export interface SyncCartPricesRes_AddedProduct {
    /**
     * @generated from protobuf field: rd.txn.SaleProduct sale_product = 1
     */
    saleProduct?: SaleProduct;
    /**
     * @generated from protobuf field: rd.product.Product product = 2
     */
    product?: Product;
}
/**
 * @generated from protobuf message rd.api.sale.GetSaleReq
 */
export interface GetSaleReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
}
/**
 * @generated from protobuf message rd.api.sale.GetSaleRes
 */
export interface GetSaleRes {
    /**
     * @generated from protobuf field: rd.txn.Sale sale = 1
     */
    sale?: Sale;
    /**
     * @generated from protobuf field: rd.company.Location location = 2
     */
    location?: Location;
    /**
     * @generated from protobuf field: rd.customer.PurchaseOrder customer_purchase_order = 3
     */
    customerPurchaseOrder?: PurchaseOrder;
    /**
     * @generated from protobuf field: map<string, rd.product.Product> products_by_id = 5
     */
    productsById: {
        [key: string]: Product;
    };
    /**
     * @generated from protobuf field: map<string, rd.tintcolor.TintColor> tint_colors_by_id = 6
     */
    tintColorsById: {
        [key: string]: TintColor;
    };
    /**
     * @generated from protobuf field: rd.customer.Contacts.Contact customer_contact = 9
     */
    customerContact?: Contacts_Contact;
    /**
     * @generated from protobuf field: map<string, rd.product.Inventories> inventories_by_product_id = 10
     */
    inventoriesByProductId: {
        [key: string]: Inventories;
    };
    /**
     * @generated from protobuf field: repeated rd.txn.SaleProduct sale_products = 13
     */
    saleProducts: SaleProduct[];
    /**
     * @generated from protobuf field: map<string, rd.catalog.Product> catalog_products_by_id = 14
     */
    catalogProductsById: {
        [key: string]: Product$;
    };
    /**
     * @generated from protobuf field: rd.proto.money.Money deposit_total = 17
     */
    depositTotal?: Money;
    /**
     * @generated from protobuf field: map<string, rd.txn.Sale> returned_from_sales_by_id = 21
     */
    returnedFromSalesById: {
        [key: string]: Sale;
    };
    /**
     * @generated from protobuf field: rd.proto.money.Money amount_paid_by_customer = 22
     */
    amountPaidByCustomer?: Money;
    /**
     * @generated from protobuf field: map<string, rd.api.sale.GetSaleRes.ReturnedInSales> returned_in_sales_by_sale_product_id = 23
     */
    returnedInSalesBySaleProductId: {
        [key: string]: GetSaleRes_ReturnedInSales;
    };
    /**
     * @generated from protobuf field: rd.txn.Sale.Totals aggregated_totals = 25
     */
    aggregatedTotals?: Sale_Totals;
    /**
     * @generated from protobuf field: repeated rd.txn.TotalsLineItem totals_line_items = 26
     */
    totalsLineItems: TotalsLineItem[];
    /**
     * @generated from protobuf field: map<string, rd.proto.decimal.Decimal> quantity_remaining_by_sale_product_id_v2 = 27
     */
    quantityRemainingBySaleProductIdV2: {
        [key: string]: Decimal;
    };
    /**
     * @generated from protobuf field: rd.txn.CreditHistoryLink credit_history_link = 28
     */
    creditHistoryLink?: CreditHistoryLink;
    /**
     * @generated from protobuf field: repeated rd.txn.CreditHistoryLink credit_allocation_links = 29
     */
    creditAllocationLinks: CreditHistoryLink[];
    /**
     * @generated from protobuf field: rd.ledger.LedgerMethods ledger_methods = 30
     */
    ledgerMethods?: LedgerMethods;
    /**
     * @generated from protobuf field: rd.company.Location fulfillment_location = 31
     */
    fulfillmentLocation?: Location;
    /**
     * @generated from protobuf field: map<string, rd.price.TierPrices> tier_prices_by_product_id = 33
     */
    tierPricesByProductId: {
        [key: string]: TierPrices;
    };
    /**
     * @generated from protobuf field: repeated rd.api.sale.GetSaleRes.LinkedSpecialOrderSale linked_special_order_sales = 35
     */
    linkedSpecialOrderSales: GetSaleRes_LinkedSpecialOrderSale[];
    /**
     * @generated from protobuf field: map<string, rd.api.sale.GetSaleRes.LinkedOrders> linked_orders_list_by_sale_product_id = 38
     */
    linkedOrdersListBySaleProductId: {
        [key: string]: GetSaleRes_LinkedOrders;
    };
    /**
     * @generated from protobuf field: map<string, rd.api.sale.GetSaleRes.LinkedShipments> linked_shipments_by_sale_product_id = 39
     */
    linkedShipmentsBySaleProductId: {
        [key: string]: GetSaleRes_LinkedShipments;
    };
    /**
     * @generated from protobuf field: map<string, rd.proto.decimal.Decimal> closed_out_quantities_by_sale_product_id = 40
     */
    closedOutQuantitiesBySaleProductId: {
        [key: string]: Decimal;
    };
    /**
     * @generated from protobuf field: rd.proto.money.Money unredeemed_deposit_total = 41
     */
    unredeemedDepositTotal?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money unredeemed_deposit_principal_total = 53
     */
    unredeemedDepositPrincipalTotal?: Money;
    /**
     * @generated from protobuf field: map<string, rd.api.sale.GetSaleRes.LinkedChildSales> child_sales_by_sale_product_id = 42
     */
    childSalesBySaleProductId: {
        [key: string]: GetSaleRes_LinkedChildSales;
    };
    /**
     * @generated from protobuf field: rd.proto.money.Money applied_deposit_redemption_total = 43
     */
    appliedDepositRedemptionTotal?: Money;
    /**
     * @generated from protobuf field: repeated rd.api.sale.GetSaleRes.DepositEvent deposit_history = 44
     */
    depositHistory: GetSaleRes_DepositEvent[];
    /**
     * @generated from protobuf field: rd.api.sale.GetSaleRes.LinkedSpecialOrderSale parent_sale = 45
     */
    parentSale?: GetSaleRes_LinkedSpecialOrderSale;
    /**
     * @generated from protobuf field: rd.proto.money.Money overall_total = 46
     */
    overallTotal?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money closed_out_total = 47
     */
    closedOutTotal?: Money;
    /**
     * @generated from protobuf field: repeated rd.txn.TotalsLineItem close_out_children_breakdown_line_items = 48
     */
    closeOutChildrenBreakdownLineItems: TotalsLineItem[];
    /**
     * @generated from protobuf field: repeated rd.txn.TotalsLineItem overall_totals_line_items = 49
     */
    overallTotalsLineItems: TotalsLineItem[];
    /**
     * Set for charge-account invoices: the payment due date and the early-payment
     * discount expiration, surfaced alongside the editable sold date.
     *
     * @generated from protobuf field: google.protobuf.Timestamp due_date = 50
     */
    dueDate?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp potential_discount_expires_at = 51
     */
    potentialDiscountExpiresAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.txn.SaleTaxes sale_taxes = 52
     */
    saleTaxes?: SaleTaxes;
    /**
     * @generated from protobuf field: repeated rd.txn.DeliveryStop delivery_stops = 54
     */
    deliveryStops: DeliveryStop[];
    /**
     * @generated from protobuf field: repeated rd.txn.AppliedCoupon coupons = 55
     */
    coupons: AppliedCoupon[];
}
/**
 * @generated from protobuf message rd.api.sale.GetSaleRes.ReturnedInSales
 */
export interface GetSaleRes_ReturnedInSales {
    /**
     * @generated from protobuf field: repeated rd.txn.Sale sales = 1
     */
    sales: Sale[];
}
/**
 * @generated from protobuf message rd.api.sale.GetSaleRes.LinkedSpecialOrderSale
 */
export interface GetSaleRes_LinkedSpecialOrderSale {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: string identifier = 2
     */
    identifier: string;
    /**
     * @generated from protobuf field: rd.txn.Sale.Status status = 3
     */
    status: Sale_Status;
}
/**
 * @generated from protobuf message rd.api.sale.GetSaleRes.LinkedOrder
 */
export interface GetSaleRes_LinkedOrder {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID order_id = 1
     */
    orderId?: UUID;
    /**
     * @generated from protobuf field: string order_identifier = 2
     */
    orderIdentifier: string;
    /**
     * @generated from protobuf field: rd.txn.Order.Status order_status = 3
     */
    orderStatus: Order_Status;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal quantity = 4
     */
    quantity?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal quantity_received = 5
     */
    quantityReceived?: Decimal;
}
/**
 * @generated from protobuf message rd.api.sale.GetSaleRes.LinkedOrders
 */
export interface GetSaleRes_LinkedOrders {
    /**
     * @generated from protobuf field: repeated rd.api.sale.GetSaleRes.LinkedOrder orders = 1
     */
    orders: GetSaleRes_LinkedOrder[];
}
/**
 * @generated from protobuf message rd.api.sale.GetSaleRes.LinkedShipment
 */
export interface GetSaleRes_LinkedShipment {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID shipment_id = 1
     */
    shipmentId?: UUID;
    /**
     * @generated from protobuf field: string shipment_identifier = 2
     */
    shipmentIdentifier: string;
    /**
     * @generated from protobuf field: rd.txn.OrderShipment.Status shipment_status = 3
     */
    shipmentStatus: OrderShipment_Status;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal quantity = 4
     */
    quantity?: Decimal;
}
/**
 * @generated from protobuf message rd.api.sale.GetSaleRes.LinkedShipments
 */
export interface GetSaleRes_LinkedShipments {
    /**
     * @generated from protobuf field: repeated rd.api.sale.GetSaleRes.LinkedShipment shipments = 1
     */
    shipments: GetSaleRes_LinkedShipment[];
}
/**
 * @generated from protobuf message rd.api.sale.GetSaleRes.LinkedChildSales
 */
export interface GetSaleRes_LinkedChildSales {
    /**
     * @generated from protobuf field: repeated rd.txn.Sale sales = 1
     */
    sales: Sale[];
}
/**
 * @generated from protobuf message rd.api.sale.GetSaleRes.DepositEvent
 */
export interface GetSaleRes_DepositEvent {
    /**
     * @generated from protobuf field: rd.api.sale.GetSaleRes.DepositEvent.Type type = 1
     */
    type: GetSaleRes_DepositEvent_Type;
    /**
     * @generated from protobuf field: rd.proto.money.Money amount = 2
     */
    amount?: Money;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp accounted_at = 3
     */
    accountedAt?: Timestamp;
    /**
     * Set on PURCHASE and REFUND events.
     *
     * @generated from protobuf field: rd.ledger.LedgerMethods.Method tender_method = 4
     */
    tenderMethod?: LedgerMethods_Method;
    /**
     * @generated from protobuf field: rd.api.sale.GetSaleRes.DepositEvent.RedeemedAgainstSale redeemed_against_sale = 5
     */
    redeemedAgainstSale?: GetSaleRes_DepositEvent_RedeemedAgainstSale;
}
/**
 * Set on REDEMPTION events. Identifies the sale this deposit was redeemed against.
 *
 * @generated from protobuf message rd.api.sale.GetSaleRes.DepositEvent.RedeemedAgainstSale
 */
export interface GetSaleRes_DepositEvent_RedeemedAgainstSale {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: string identifier = 2
     */
    identifier: string;
}
/**
 * @generated from protobuf enum rd.api.sale.GetSaleRes.DepositEvent.Type
 */
export enum GetSaleRes_DepositEvent_Type {
    /**
     * @generated from protobuf enum value: UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: PURCHASE = 1;
     */
    PURCHASE = 1,
    /**
     * @generated from protobuf enum value: REDEMPTION = 2;
     */
    REDEMPTION = 2,
    /**
     * @generated from protobuf enum value: REFUND = 3;
     */
    REFUND = 3,
    /**
     * @generated from protobuf enum value: FORFEITURE = 4;
     */
    FORFEITURE = 4
}
/**
 * @generated from protobuf message rd.api.sale.GetSaleCountsByStatusReq
 */
export interface GetSaleCountsByStatusReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID location_id = 1
     */
    locationId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID customer_id = 2
     */
    customerId?: UUID;
}
/**
 * @generated from protobuf message rd.api.sale.GetSaleCountsByStatusRes
 */
export interface GetSaleCountsByStatusRes {
    /**
     * @generated from protobuf field: map<int32, rd.txn.SaleCountBySource> sale_counts_by_status = 1
     */
    saleCountsByStatus: {
        [key: number]: SaleCountBySource;
    };
}
/**
 * @generated from protobuf message rd.api.sale.GetScannedSaleReq
 */
export interface GetScannedSaleReq {
    /**
     * @generated from protobuf field: string identifier = 1
     */
    identifier: string;
}
/**
 * @generated from protobuf message rd.api.sale.GetScannedSaleRes
 */
export interface GetScannedSaleRes {
    /**
     * @generated from protobuf field: rd.txn.Sale sale = 1
     */
    sale?: Sale;
}
/**
 * @generated from protobuf message rd.api.sale.UpdateSoldSaleProductReq
 */
export interface UpdateSoldSaleProductReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID sale_id = 1
     */
    saleId?: UUID;
    /**
     * @generated from protobuf field: rd.api.sale.UpdateSoldSaleProductReq.Product product = 2
     */
    product?: UpdateSoldSaleProductReq_Product;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID sale_product_id = 3
     */
    saleProductId?: UUID;
}
/**
 * @generated from protobuf message rd.api.sale.UpdateSoldSaleProductReq.Product
 */
export interface UpdateSoldSaleProductReq_Product {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID tint_color_id = 2
     */
    tintColorId?: UUID;
    /**
     * @generated from protobuf field: string custom_tint_color = 3
     */
    customTintColor: string;
    /**
     * @generated from protobuf field: string notes = 4
     */
    notes: string;
    /**
     * @generated from protobuf field: repeated rd.company.SaleForm.CustomField custom_fields = 5
     */
    customFields: SaleForm_CustomField[];
    /**
     * @generated from protobuf field: string internal_notes = 6
     */
    internalNotes: string;
}
/**
 * @generated from protobuf message rd.api.sale.UpdateSoldSaleProductRes
 */
export interface UpdateSoldSaleProductRes {
}
/**
 * @generated from protobuf message rd.api.sale.UpdateSoldSaleDetailsReq
 */
export interface UpdateSoldSaleDetailsReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: string sale_notes = 2
     */
    saleNotes: string;
    /**
     * @generated from protobuf field: string customer_contact_id_string = 4
     */
    customerContactIdString: string;
    /**
     * @generated from protobuf field: string purchase_order_name = 5
     */
    purchaseOrderName: string;
    /**
     * @generated from protobuf field: string internal_notes = 7
     */
    internalNotes: string;
    /**
     * @generated from protobuf field: rd.proto.address.Address address = 8
     */
    address?: Address;
    /**
     * @generated from protobuf field: string customer_contact_name = 9
     */
    customerContactName: string;
}
/**
 * @generated from protobuf message rd.api.sale.UpdateSoldSaleDetailsRes
 */
export interface UpdateSoldSaleDetailsRes {
}
/**
 * @generated from protobuf message rd.api.sale.EmailSalePDFReq
 */
export interface EmailSalePDFReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: repeated string customer_contact_id_strings = 2
     */
    customerContactIdStrings: string[];
    /**
     * @generated from protobuf field: repeated string additional_emails = 3
     */
    additionalEmails: string[];
    /**
     * @generated from protobuf field: bool is_return = 4
     */
    isReturn: boolean;
    /**
     * @generated from protobuf field: rd.api.sale.ShowPricesOption show_prices = 5
     */
    showPrices: ShowPricesOption;
    /**
     * @generated from protobuf field: bool show_linked_products = 6
     */
    showLinkedProducts: boolean; // for receipt consolidation for special orders
    /**
     * @generated from protobuf field: bool show_account_balance = 7
     */
    showAccountBalance: boolean;
}
/**
 * @generated from protobuf message rd.api.sale.EmailSalePDFRes
 */
export interface EmailSalePDFRes {
}
/**
 * @generated from protobuf message rd.api.sale.GetSalePDFReq
 */
export interface GetSalePDFReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: rd.api.sale.ShowPricesOption show_prices = 2
     */
    showPrices: ShowPricesOption;
    /**
     * @generated from protobuf field: bool show_linked_products = 3
     */
    showLinkedProducts: boolean; // for receipt consolidation for special orders
    /**
     * @generated from protobuf field: bool show_account_balance = 4
     */
    showAccountBalance: boolean;
}
/**
 * @generated from protobuf message rd.api.sale.GetSalePDFRes
 */
export interface GetSalePDFRes {
    /**
     * @generated from protobuf field: bytes bytes = 1
     */
    bytes: Uint8Array;
}
/**
 * @generated from protobuf message rd.api.sale.AuthorizeCardPaymentReq
 */
export interface AuthorizeCardPaymentReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID customer_id = 3
     */
    customerId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID location_id = 8
     */
    locationId?: UUID;
    /**
     * @generated from protobuf field: rd.txn.TenderSubmissionMetadata tsm = 14
     */
    tsm?: TenderSubmissionMetadata;
}
/**
 * @generated from protobuf message rd.api.sale.AuthorizeCardPaymentRes
 */
export interface AuthorizeCardPaymentRes {
    /**
     * @generated from protobuf field: string stripe_payment_intent_id = 1
     */
    stripePaymentIntentId: string;
}
/**
 * @generated from protobuf message rd.api.sale.SetCardReaderDisplayReq
 */
export interface SetCardReaderDisplayReq {
    /**
     * @generated from protobuf field: string stripe_reader_id = 1
     */
    stripeReaderId: string;
    /**
     * @generated from protobuf field: rd.proto.money.Money sales_tax = 2
     */
    salesTax?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money sale_total = 3
     */
    saleTotal?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money card_surcharge = 4
     */
    cardSurcharge?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money card_surcharge_tax = 5
     */
    cardSurchargeTax?: Money;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal card_surcharge_rate = 6
     */
    cardSurchargeRate?: Decimal;
    /**
     * @generated from protobuf field: repeated rd.api.sale.SetCardReaderDisplayReq.CartProduct cart = 8
     */
    cart: SetCardReaderDisplayReq_CartProduct[];
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID customer_id = 9
     */
    customerId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID sale_id = 10
     */
    saleId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID location_id = 11
     */
    locationId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.address.Address address = 12
     */
    address?: Address;
}
/**
 * @generated from protobuf message rd.api.sale.SetCardReaderDisplayReq.CartProduct
 */
export interface SetCardReaderDisplayReq_CartProduct {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID product_id = 1
     */
    productId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.money.Money product_edited_price = 3
     */
    productEditedPrice?: Money;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 4
     */
    id?: UUID;
    /**
     * @generated from protobuf field: rd.txn.SaleProduct.Type sale_product_type = 5
     */
    saleProductType: SaleProduct_Type;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID returned_from_sale_product_id = 6
     */
    returnedFromSaleProductId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal quantity_v2 = 8
     */
    quantityV2?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal quantity_returned_v2 = 9
     */
    quantityReturnedV2?: Decimal;
    /**
     * Optional unit-of-measure metadata for the cart line.
     * When provided, quantity_v2 should still represent the quantity in the
     * product's base unit; quantity_uom is the physical quantity in the selected unit of measure.
     *
     * @generated from protobuf field: rd.proto.uuid.UUID uom_id = 10
     */
    uomId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal quantity_uom = 11
     */
    quantityUom?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID uom_id_returned = 12
     */
    uomIdReturned?: UUID;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal quantity_returned_uom = 13
     */
    quantityReturnedUom?: Decimal;
    /**
     * @generated from protobuf field: bool is_taxed = 14
     */
    isTaxed: boolean;
    /**
     * @generated from protobuf field: bool is_taxed_edited = 15
     */
    isTaxedEdited: boolean;
    /**
     * @generated from protobuf field: repeated string disabled_additional_fee_ids = 16
     */
    disabledAdditionalFeeIds: string[];
    /**
     * @generated from protobuf field: bool is_price_edited = 17
     */
    isPriceEdited: boolean;
}
/**
 * @generated from protobuf message rd.api.sale.SetCardReaderDisplayRes
 */
export interface SetCardReaderDisplayRes {
}
/**
 * @generated from protobuf message rd.api.sale.CanEditPriceDuringSaleReq
 */
export interface CanEditPriceDuringSaleReq {
}
/**
 * @generated from protobuf message rd.api.sale.CanEditPriceDuringSaleRes
 */
export interface CanEditPriceDuringSaleRes {
}
/**
 * @generated from protobuf message rd.api.sale.UpdateSaleProductAdditionalFeesReq
 */
export interface UpdateSaleProductAdditionalFeesReq {
}
/**
 * @generated from protobuf message rd.api.sale.UpdateSaleProductAdditionalFeesRes
 */
export interface UpdateSaleProductAdditionalFeesRes {
}
/**
 * @generated from protobuf message rd.api.sale.UpdateSaleProductCostReq
 */
export interface UpdateSaleProductCostReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID sale_product_id = 1
     */
    saleProductId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.money.FractionalMoney cost = 2
     */
    cost?: FractionalMoney;
}
/**
 * @generated from protobuf message rd.api.sale.UpdateSaleProductCostRes
 */
export interface UpdateSaleProductCostRes {
}
/**
 * @generated from protobuf message rd.api.sale.UpdateSaleProductCostsFromCCPRebatesReq
 */
export interface UpdateSaleProductCostsFromCCPRebatesReq {
    /**
     * @generated from protobuf field: bytes csv_data = 1
     */
    csvData: Uint8Array;
}
/**
 * @generated from protobuf message rd.api.sale.UpdateSaleProductCostsFromCCPRebatesRes
 */
export interface UpdateSaleProductCostsFromCCPRebatesRes {
    /**
     * @generated from protobuf field: rd.txn.CCPRebateReportUpload upload = 1
     */
    upload?: CCPRebateReportUpload;
}
/**
 * @generated from protobuf message rd.api.sale.ListCCPRebateReportUploadsReq
 */
export interface ListCCPRebateReportUploadsReq {
}
/**
 * @generated from protobuf message rd.api.sale.ListCCPRebateReportUploadsRes
 */
export interface ListCCPRebateReportUploadsRes {
    /**
     * @generated from protobuf field: repeated rd.txn.CCPRebateReportUpload uploads = 1
     */
    uploads: CCPRebateReportUpload[];
}
/**
 * @generated from protobuf message rd.api.sale.DuplicateSaleReq
 */
export interface DuplicateSaleReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID location_id = 2
     */
    locationId?: UUID;
}
/**
 * @generated from protobuf message rd.api.sale.DuplicateSaleRes
 */
export interface DuplicateSaleRes {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: repeated string warnings = 2
     */
    warnings: string[];
}
/**
 * @generated from protobuf message rd.api.sale.UpdateUnpaidChargeAccountSaleDateReq
 */
export interface UpdateUnpaidChargeAccountSaleDateReq {
}
/**
 * @generated from protobuf message rd.api.sale.UpdateUnpaidChargeAccountSaleDateRes
 */
export interface UpdateUnpaidChargeAccountSaleDateRes {
}
// Returns

/**
 * @generated from protobuf message rd.api.sale.ReturnSaleReq
 */
export interface ReturnSaleReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID sale_id = 1
     */
    saleId?: UUID;
    /**
     * @generated from protobuf field: string notes = 2
     */
    notes: string;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID returned_location_id = 3
     */
    returnedLocationId?: UUID;
    /**
     * @generated from protobuf field: string customer_purchase_order_name = 7
     */
    customerPurchaseOrderName: string;
    /**
     * @generated from protobuf field: string customer_contact_id_string = 8
     */
    customerContactIdString: string;
    /**
     * @generated from protobuf field: map<string, rd.api.sale.ReturnSaleReq.ReturnProduct> return_products_by_return_from_sale_product_id = 9
     */
    returnProductsByReturnFromSaleProductId: {
        [key: string]: ReturnSaleReq_ReturnProduct;
    };
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID printer_id = 10
     */
    printerId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.address.Address address = 11
     */
    address?: Address;
    /**
     * @generated from protobuf oneof: restock_fee
     */
    restockFee: {
        oneofKind: "restockFeePercentage";
        /**
         * @generated from protobuf field: rd.proto.decimal.Decimal restock_fee_percentage = 12
         */
        restockFeePercentage: Decimal; // percentage as decimal (e.g., 0.15 for 15%)
    } | {
        oneofKind: "restockFeeAmount";
        /**
         * @generated from protobuf field: rd.proto.money.Money restock_fee_amount = 13
         */
        restockFeeAmount: Money; // fixed amount
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID cash_register_id = 15
     */
    cashRegisterId?: UUID;
    /**
     * should_save_card, card_nickname, check, custom, tender_method_id
     *
     * @generated from protobuf field: rd.proto.uuid.UUID fulfillment_location_id = 24
     */
    fulfillmentLocationId?: UUID;
    /**
     * @generated from protobuf field: bool is_delivery_fulfillment = 25
     */
    isDeliveryFulfillment: boolean;
    /**
     * @generated from protobuf field: rd.txn.TenderSubmissionMetadata tender_submission = 27
     */
    tenderSubmission?: TenderSubmissionMetadata;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp delivery_date = 28
     */
    deliveryDate?: Timestamp;
    /**
     * @generated from protobuf field: string customer_contact_name = 29
     */
    customerContactName: string;
}
/**
 * @generated from protobuf message rd.api.sale.ReturnSaleReq.ReturnProduct
 */
export interface ReturnSaleReq_ReturnProduct {
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal quantity_to_return_v2 = 2
     */
    quantityToReturnV2?: Decimal;
    /**
     * @generated from protobuf field: repeated rd.txn.SaleProduct.TallyRow tally_rows = 3
     */
    tallyRows: SaleProduct_TallyRow[];
}
/**
 * @generated from protobuf message rd.api.sale.ReturnSaleRes
 */
export interface ReturnSaleRes {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 2
     */
    id?: UUID;
}
/**
 * @generated from protobuf message rd.api.sale.GetReturnReq
 */
export interface GetReturnReq {
}
/**
 * @generated from protobuf message rd.api.sale.GetReturnRes
 */
export interface GetReturnRes {
}
/**
 * @generated from protobuf message rd.api.sale.GetReturnPDFReq
 */
export interface GetReturnPDFReq {
}
/**
 * @generated from protobuf message rd.api.sale.GetReturnPDFRes
 */
export interface GetReturnPDFRes {
}
/**
 * @generated from protobuf message rd.api.sale.UpdateReturnDetailsReq
 */
export interface UpdateReturnDetailsReq {
}
/**
 * @generated from protobuf message rd.api.sale.UpdateReturnDetailsRes
 */
export interface UpdateReturnDetailsRes {
}
/**
 * @generated from protobuf message rd.api.sale.EmailReturnPDFReq
 */
export interface EmailReturnPDFReq {
}
/**
 * @generated from protobuf message rd.api.sale.EmailReturnPDFRes
 */
export interface EmailReturnPDFRes {
}
/**
 * @generated from protobuf message rd.api.sale.UpdateSaleProductReturnedReq
 */
export interface UpdateSaleProductReturnedReq {
}
/**
 * @generated from protobuf message rd.api.sale.UpdateSaleProductReturnedReq.Product
 */
export interface UpdateSaleProductReturnedReq_Product {
}
/**
 * @generated from protobuf message rd.api.sale.UpdateSaleProductReturnedRes
 */
export interface UpdateSaleProductReturnedRes {
}
/**
 * @generated from protobuf message rd.api.sale.UpdateSaleProductReturnedCostReq
 */
export interface UpdateSaleProductReturnedCostReq {
}
/**
 * @generated from protobuf message rd.api.sale.UpdateSaleProductReturnedCostRes
 */
export interface UpdateSaleProductReturnedCostRes {
}
/**
 * @generated from protobuf message rd.api.sale.CalculateReturnTotalsReq
 */
export interface CalculateReturnTotalsReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID return_from_sale_id = 1
     */
    returnFromSaleId?: UUID;
    /**
     * @deprecated
     * @generated from protobuf field: map<string, int32> quantities_to_return_from_sale_product_id = 2 [deprecated = true]
     */
    quantitiesToReturnFromSaleProductId: {
        [key: string]: number;
    };
    /**
     * @generated from protobuf field: map<string, rd.proto.decimal.Decimal> quantities_to_return_from_sale_product_id_v2 = 3
     */
    quantitiesToReturnFromSaleProductIdV2: {
        [key: string]: Decimal;
    };
    /**
     * @generated from protobuf oneof: restock_fee
     */
    restockFee: {
        oneofKind: "restockFeePercentage";
        /**
         * @generated from protobuf field: rd.proto.decimal.Decimal restock_fee_percentage = 12
         */
        restockFeePercentage: Decimal; // percentage as decimal (e.g., 0.15 for 15%)
    } | {
        oneofKind: "restockFeeAmount";
        /**
         * @generated from protobuf field: rd.proto.money.Money restock_fee_amount = 13
         */
        restockFeeAmount: Money; // fixed amount
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message rd.api.sale.CalculateReturnTotalsRes
 */
export interface CalculateReturnTotalsRes {
    /**
     * @generated from protobuf field: rd.proto.money.Money total = 1
     */
    total?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money subtotal = 2
     */
    subtotal?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money sales_tax_total = 3
     */
    salesTaxTotal?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money card_surcharge = 4
     */
    cardSurcharge?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money card_surcharge_tax = 5
     */
    cardSurchargeTax?: Money;
    /**
     * @generated from protobuf field: rd.company.TaxRate tax_rate = 7
     */
    taxRate?: TaxRate;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal card_surcharge_rate = 8
     */
    cardSurchargeRate?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.money.Money final_total = 10
     */
    finalTotal?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money restock_fee_total = 11
     */
    restockFeeTotal?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money current_restock_fee = 12
     */
    currentRestockFee?: Money;
    /**
     * negative amount that is applied to the returned subtotal
     *
     * @generated from protobuf field: rd.proto.money.Money discount_applied = 13
     */
    discountApplied?: Money;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal discount_rate = 14
     */
    discountRate?: Decimal;
    /**
     * @generated from protobuf field: map<string, rd.txn.Sale.Totals.AdditionalFee> additional_fees_by_name_v2 = 16
     */
    additionalFeesByNameV2: {
        [key: string]: Sale_Totals_AdditionalFee;
    };
    /**
     * @generated from protobuf field: rd.txn.SaleTaxes sale_taxes = 17
     */
    saleTaxes?: SaleTaxes;
}
/**
 * @generated from protobuf message rd.api.sale.UnlinkedReturnsReq
 */
export interface UnlinkedReturnsReq {
}
/**
 * @generated from protobuf message rd.api.sale.UnlinkedReturnsRes
 */
export interface UnlinkedReturnsRes {
}
// Completed sale ledger edits

/**
 * @generated from protobuf message rd.api.sale.VoidCompletedSaleReq
 */
export interface VoidCompletedSaleReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: bool is_inventory_returned = 2
     */
    isInventoryReturned: boolean;
    /**
     * @generated from protobuf field: string void_reason = 3
     */
    voidReason: string;
}
/**
 * @generated from protobuf message rd.api.sale.VoidCompletedSaleRes
 */
export interface VoidCompletedSaleRes {
}
/**
 * @generated from protobuf message rd.api.sale.GetIsEditingCompletedSaleAllowedReq
 */
export interface GetIsEditingCompletedSaleAllowedReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID sale_id = 1
     */
    saleId?: UUID;
}
/**
 * @generated from protobuf message rd.api.sale.GetIsEditingCompletedSaleAllowedRes
 */
export interface GetIsEditingCompletedSaleAllowedRes {
    /**
     * @generated from protobuf field: bool is_voiding_allowed = 1
     */
    isVoidingAllowed: boolean;
    /**
     * @generated from protobuf field: rd.proto.timestamprange.TimestampRange allowed_date_range = 2
     */
    allowedDateRange?: TimestampRange;
    /**
     * @generated from protobuf field: bool is_editing_allowed = 3
     */
    isEditingAllowed: boolean;
    /**
     * @generated from protobuf field: repeated string voiding_blocked_reasons = 4
     */
    voidingBlockedReasons: string[];
    /**
     * @generated from protobuf field: repeated string editing_blocked_reasons = 5
     */
    editingBlockedReasons: string[];
}
/**
 * @generated from protobuf message rd.api.sale.EditSaleDateReq
 */
export interface EditSaleDateReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID sale_id = 1
     */
    saleId?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp sale_date = 2
     */
    saleDate?: Timestamp;
    /**
     * @generated from protobuf field: string client_time_zone = 3
     */
    clientTimeZone: string;
}
/**
 * @generated from protobuf message rd.api.sale.EditSaleDateRes
 */
export interface EditSaleDateRes {
}
/**
 * @generated from protobuf message rd.api.sale.EditSaleDueDateReq
 */
export interface EditSaleDueDateReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID sale_id = 1
     */
    saleId?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp due_date = 2
     */
    dueDate?: Timestamp;
    /**
     * @generated from protobuf field: string client_time_zone = 3
     */
    clientTimeZone: string;
}
/**
 * @generated from protobuf message rd.api.sale.EditSaleDueDateRes
 */
export interface EditSaleDueDateRes {
}
/**
 * @generated from protobuf message rd.api.sale.EditSaleDiscountDateReq
 */
export interface EditSaleDiscountDateReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID sale_id = 1
     */
    saleId?: UUID;
    /**
     * Updates the early-payment discount's expiration; the sale must have one.
     *
     * @generated from protobuf field: google.protobuf.Timestamp discount_date = 2
     */
    discountDate?: Timestamp;
    /**
     * @generated from protobuf field: string client_time_zone = 3
     */
    clientTimeZone: string;
}
/**
 * @generated from protobuf message rd.api.sale.EditSaleDiscountDateRes
 */
export interface EditSaleDiscountDateRes {
}
/**
 * @generated from protobuf message rd.api.sale.EditSaleDesignatedClerkReq
 */
export interface EditSaleDesignatedClerkReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID sale_id = 1
     */
    saleId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID staff_id = 2
     */
    staffId?: UUID;
}
/**
 * @generated from protobuf message rd.api.sale.EditSaleDesignatedClerkRes
 */
export interface EditSaleDesignatedClerkRes {
}
// Card surcharge

/**
 * @generated from protobuf message rd.api.sale.CalculateCardSurchargeReq
 */
export interface CalculateCardSurchargeReq {
    /**
     * @generated from protobuf field: rd.proto.money.Money total = 1
     */
    total?: Money;
    /**
     * @generated from protobuf field: rd.api.sale.CalculateCardSurchargeReq.PaymentMethod payment_method = 2
     */
    paymentMethod: CalculateCardSurchargeReq_PaymentMethod;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID customer_id = 3
     */
    customerId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal tax_rate = 4
     */
    taxRate?: Decimal; // to be deprecated
    /**
     * @generated from protobuf field: bool is_card_surcharge_disabled = 5
     */
    isCardSurchargeDisabled: boolean;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID tax_rate_id = 6
     */
    taxRateId?: UUID; // to be deprecated
    /**
     * @generated from protobuf field: map<string, rd.proto.decimal.Decimal> tax_rates_by_rate_id = 7
     */
    taxRatesByRateId: {
        [key: string]: Decimal;
    }; // only use with flag on
}
/**
 * @generated from protobuf enum rd.api.sale.CalculateCardSurchargeReq.PaymentMethod
 */
export enum CalculateCardSurchargeReq_PaymentMethod {
    /**
     * @generated from protobuf enum value: PAYMENT_METHOD_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: PAYMENT_METHOD_CARD = 1;
     */
    CARD = 1
}
/**
 * @generated from protobuf message rd.api.sale.CalculateCardSurchargeRes
 */
export interface CalculateCardSurchargeRes {
    /**
     * @generated from protobuf field: rd.proto.money.Money surcharge = 1
     */
    surcharge?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money surcharge_tax = 2
     */
    surchargeTax?: Money; // to be deprecated
    /**
     * @generated from protobuf field: map<string, rd.proto.money.Money> surcharge_taxes_by_rate_id = 3
     */
    surchargeTaxesByRateId: {
        [key: string]: Money;
    }; // only use with flag on
}
/**
 * @generated from protobuf message rd.api.sale.CalculateCardSurchargeDisplayInfoReq
 */
export interface CalculateCardSurchargeDisplayInfoReq {
    /**
     * @generated from protobuf field: rd.proto.money.Money card_surcharge_amount = 2
     */
    cardSurchargeAmount?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money card_surcharge_tax = 3
     */
    cardSurchargeTax?: Money; // being deprecated
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID customer_id = 4
     */
    customerId?: UUID;
    /**
     * @generated from protobuf field: repeated rd.txn.TenderSubmissionMetadata split_tender_submissions = 6
     */
    splitTenderSubmissions: TenderSubmissionMetadata[];
    /**
     * @generated from protobuf field: map<string, rd.proto.money.Money> card_surcharge_taxes_by_rate_id = 7
     */
    cardSurchargeTaxesByRateId: {
        [key: string]: Money;
    }; // only use with flag on
}
/**
 * @generated from protobuf message rd.api.sale.CalculateCardSurchargeDisplayInfoRes
 */
export interface CalculateCardSurchargeDisplayInfoRes {
    /**
     * @generated from protobuf field: bool is_tax_exempt = 1
     */
    isTaxExempt: boolean;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal surcharge_rate = 2
     */
    surchargeRate?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.money.Money all_card_surcharges_total = 4
     */
    allCardSurchargesTotal?: Money; // includes tax
    /**
     * @generated from protobuf field: rd.proto.money.Money all_card_surcharges_pre_tax_total = 5
     */
    allCardSurchargesPreTaxTotal?: Money; // excludes tax, use with flag on
    /**
     * @generated from protobuf field: repeated rd.txn.TaxLine surcharge_tax_lines = 6
     */
    surchargeTaxLines: TaxLine[]; // only use with flag on
}
// Special orders

/**
 * @generated from protobuf message rd.api.sale.UpdateSpecialOrderProductPriceAndCostReq
 */
export interface UpdateSpecialOrderProductPriceAndCostReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID sale_product_id = 1
     */
    saleProductId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.money.Money price = 2
     */
    price?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.FractionalMoney cost = 3
     */
    cost?: FractionalMoney;
    /**
     * @generated from protobuf field: bool is_taxed = 4
     */
    isTaxed: boolean;
    /**
     * @generated from protobuf field: rd.proto.money.Money retail_price = 5
     */
    retailPrice?: Money;
}
/**
 * @generated from protobuf message rd.api.sale.UpdateSpecialOrderProductPriceAndCostRes
 */
export interface UpdateSpecialOrderProductPriceAndCostRes {
}
/**
 * @generated from protobuf message rd.api.sale.RefundDepositReq
 */
export interface RefundDepositReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: string purchase_order_name = 2
     */
    purchaseOrderName: string;
    /**
     * @generated from protobuf field: rd.proto.address.Address address = 3
     */
    address?: Address;
    /**
     * @generated from protobuf field: string internal_notes = 4
     */
    internalNotes: string;
    /**
     * @generated from protobuf field: string sale_notes = 5
     */
    saleNotes: string;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID fulfillment_location_id = 6
     */
    fulfillmentLocationId?: UUID;
    /**
     * @generated from protobuf field: bool is_delivery_fulfillment = 7
     */
    isDeliveryFulfillment: boolean;
    /**
     * Deprecated: use tax_rate_ids.
     *
     * @generated from protobuf field: rd.proto.uuid.UUID tax_rate_id = 8
     */
    taxRateId?: UUID;
    /**
     * @generated from protobuf field: string idempotency_key = 9
     */
    idempotencyKey: string;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID printer_id = 10
     */
    printerId?: UUID;
    /**
     * @generated from protobuf field: rd.txn.TenderSubmissionMetadata tender_submission_metadata = 11
     */
    tenderSubmissionMetadata?: TenderSubmissionMetadata;
    /**
     * @generated from protobuf field: string customer_contact_id_string = 12
     */
    customerContactIdString: string;
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID tax_rate_ids = 13
     */
    taxRateIds: UUID[];
}
/**
 * @generated from protobuf message rd.api.sale.RefundDepositRes
 */
export interface RefundDepositRes {
    /**
     * @generated from protobuf field: bool email_error = 1
     */
    emailError: boolean;
}
/**
 * @generated from protobuf message rd.api.sale.RefundInteracPaymentReq
 */
export interface RefundInteracPaymentReq {
    /**
     * @generated from protobuf field: string stripe_payment_intent_id = 1
     */
    stripePaymentIntentId: string;
    /**
     * @generated from protobuf field: string stripe_reader_id = 2
     */
    stripeReaderId: string;
    /**
     * @generated from protobuf field: string idempotency_key = 3
     */
    idempotencyKey: string;
}
/**
 * @generated from protobuf message rd.api.sale.RefundInteracPaymentRes
 */
export interface RefundInteracPaymentRes {
}
/**
 * SaleFanBuilderCoupon is one Fan Builder coupon on a cart. It carries the rule CES priced it by
 * rather than only a figure: a percentage is worth a different amount every time the cart changes,
 * so the server re-prices it instead of trusting a number computed when it was scanned.
 *
 * @generated from protobuf message rd.api.sale.SaleFanBuilderCoupon
 */
export interface SaleFanBuilderCoupon {
    /**
     * @generated from protobuf field: string coupon_barcode = 1
     */
    couponBarcode: string;
    /**
     * @generated from protobuf field: string description = 2
     */
    description: string;
    /**
     * What a fixed-amount coupon takes off, positive. Ignored for a percentage coupon.
     *
     * @generated from protobuf field: rd.proto.money.Money discount_amount = 3
     */
    discountAmount?: Money;
    /**
     * @generated from protobuf field: bool taxable = 4
     */
    taxable: boolean;
    /**
     * @generated from protobuf field: rd.api.sale.SaleFanBuilderCoupon.DiscountType discount_type = 5
     */
    discountType: SaleFanBuilderCoupon_DiscountType;
    /**
     * For a percentage coupon, the fraction of the discountable subtotal ("0.1" means 10%).
     *
     * @generated from protobuf field: rd.proto.decimal.Decimal amount = 6
     */
    amount?: Decimal;
}
/**
 * Mirrors rd.api.customer.ValidatedFanBuilderLoyaltyCoupon.DiscountType. Duplicated rather than
 * imported: no api service proto depends on another, and both are thin mappings of CES's values.
 *
 * @generated from protobuf enum rd.api.sale.SaleFanBuilderCoupon.DiscountType
 */
export enum SaleFanBuilderCoupon_DiscountType {
    /**
     * @generated from protobuf enum value: DISCOUNT_TYPE_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: DISCOUNT_TYPE_FIXED_AMOUNT = 1;
     */
    FIXED_AMOUNT = 1,
    /**
     * @generated from protobuf enum value: DISCOUNT_TYPE_PERCENTAGE = 2;
     */
    PERCENTAGE = 2
}
/**
 * SaleFanBuilderCoupons is the whole set of coupons on a cart.
 *
 * It is a message so that an absent field means "this request does not manage coupons" while a
 * present, empty one means "remove them". A bare repeated field cannot tell those apart, and the
 * deposit and special-order save paths send neither — without the distinction they would silently
 * delete a coupon the cashier had put on the sale.
 *
 * @generated from protobuf message rd.api.sale.SaleFanBuilderCoupons
 */
export interface SaleFanBuilderCoupons {
    /**
     * @generated from protobuf field: repeated rd.api.sale.SaleFanBuilderCoupon coupons = 1
     */
    coupons: SaleFanBuilderCoupon[];
}
/**
 * @generated from protobuf enum rd.api.sale.ShowPricesOption
 */
export enum ShowPricesOption {
    /**
     * @generated from protobuf enum value: SHOW_PRICES_OPTION_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: SHOW_PRICES_OPTION_SHOW = 1;
     */
    SHOW = 1,
    /**
     * @generated from protobuf enum value: SHOW_PRICES_OPTION_HIDE = 2;
     */
    HIDE = 2
}
// @generated message type with reflection information, may provide speed optimized methods
class UpsertSaleV3Req$Type extends MessageType<UpsertSaleV3Req> {
    constructor() {
        super("rd.api.sale.UpsertSaleV3Req", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "customer_id", kind: "message", T: () => UUID },
            { no: 5, name: "location_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 6, name: "quote_expires_at", kind: "message", T: () => Timestamp },
            { no: 7, name: "status", kind: "enum", T: () => ["rd.txn.Sale.Status", Sale_Status, "STATUS_"], options: { "rd.validator.require": true } },
            { no: 8, name: "notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "customer_purchase_order_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "customer_contact_id_strings", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "additional_emails", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "customer_contact_id_string", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 15, name: "stripe_reader_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 16, name: "tax_rate_id", kind: "message", T: () => UUID },
            { no: 17, name: "card_surcharge_rate", kind: "message", T: () => Decimal },
            { no: 18, name: "idempotency_key", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 19, name: "productsV2", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SaleProduct },
            { no: 20, name: "internal_notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 21, name: "printer_id", kind: "message", T: () => UUID },
            { no: 22, name: "address", kind: "message", T: () => Address },
            { no: 26, name: "restock_fee_amount", kind: "message", T: () => Money },
            { no: 27, name: "restock_fee_percentage", kind: "message", T: () => Decimal },
            { no: 28, name: "fulfillment_location_id", kind: "message", T: () => UUID },
            { no: 29, name: "is_delivery_fulfillment", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 30, name: "additional_deposit", kind: "message", T: () => Money },
            { no: 34, name: "discount_amount", kind: "message", T: () => Money },
            { no: 35, name: "discount_rate", kind: "message", T: () => Decimal },
            { no: 36, name: "return_tender_submission", kind: "message", T: () => TenderSubmissionMetadata },
            { no: 37, name: "delivery_date", kind: "message", T: () => Timestamp },
            { no: 38, name: "customer_contact_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 39, name: "tender_submissions", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TenderSubmissionMetadata },
            { no: 40, name: "deposit_refund_tender_submission_metadata", kind: "message", T: () => TenderSubmissionMetadata },
            { no: 41, name: "item_sets_by_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Sale_ItemSet } },
            { no: 42, name: "designated_clerk_id", kind: "message", T: () => UUID },
            { no: 43, name: "tax_rate_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 44, name: "deposit_config", kind: "message", T: () => DepositConfig },
            { no: 45, name: "principal_to_refund", kind: "message", T: () => Money },
            { no: 46, name: "will_call_show_prices", kind: "enum", T: () => ["rd.api.sale.ShowPricesOption", ShowPricesOption, "SHOW_PRICES_OPTION_"] },
            { no: 47, name: "delivery_details", kind: "message", T: () => DeliveryDetails },
            { no: 48, name: "delivery_id", kind: "message", T: () => UUID },
            { no: 49, name: "initial_deposit_intent", kind: "message", T: () => InitialDepositIntent },
            { no: 50, name: "fan_builder_coupons", kind: "message", T: () => SaleFanBuilderCoupons }
        ]);
    }
    create(value?: PartialMessage<UpsertSaleV3Req>): UpsertSaleV3Req {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.status = 0;
        message.notes = "";
        message.customerPurchaseOrderName = "";
        message.customerContactIdStrings = [];
        message.additionalEmails = [];
        message.customerContactIdString = "";
        message.stripeReaderId = "";
        message.idempotencyKey = "";
        message.productsV2 = [];
        message.internalNotes = "";
        message.isDeliveryFulfillment = false;
        message.customerContactName = "";
        message.tenderSubmissions = [];
        message.itemSetsById = {};
        message.taxRateIds = [];
        message.willCallShowPrices = 0;
        if (value !== undefined)
            reflectionMergePartial<UpsertSaleV3Req>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpsertSaleV3Req): UpsertSaleV3Req {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* rd.proto.uuid.UUID customer_id */ 2:
                    message.customerId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.customerId);
                    break;
                case /* rd.proto.uuid.UUID location_id */ 5:
                    message.locationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.locationId);
                    break;
                case /* google.protobuf.Timestamp quote_expires_at */ 6:
                    message.quoteExpiresAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.quoteExpiresAt);
                    break;
                case /* rd.txn.Sale.Status status */ 7:
                    message.status = reader.int32();
                    break;
                case /* string notes */ 8:
                    message.notes = reader.string();
                    break;
                case /* string customer_purchase_order_name */ 10:
                    message.customerPurchaseOrderName = reader.string();
                    break;
                case /* repeated string customer_contact_id_strings */ 11:
                    message.customerContactIdStrings.push(reader.string());
                    break;
                case /* repeated string additional_emails */ 12:
                    message.additionalEmails.push(reader.string());
                    break;
                case /* string customer_contact_id_string */ 13:
                    message.customerContactIdString = reader.string();
                    break;
                case /* string stripe_reader_id */ 15:
                    message.stripeReaderId = reader.string();
                    break;
                case /* rd.proto.uuid.UUID tax_rate_id */ 16:
                    message.taxRateId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.taxRateId);
                    break;
                case /* rd.proto.decimal.Decimal card_surcharge_rate */ 17:
                    message.cardSurchargeRate = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.cardSurchargeRate);
                    break;
                case /* string idempotency_key */ 18:
                    message.idempotencyKey = reader.string();
                    break;
                case /* repeated rd.txn.SaleProduct productsV2 */ 19:
                    message.productsV2.push(SaleProduct.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string internal_notes */ 20:
                    message.internalNotes = reader.string();
                    break;
                case /* rd.proto.uuid.UUID printer_id */ 21:
                    message.printerId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.printerId);
                    break;
                case /* rd.proto.address.Address address */ 22:
                    message.address = Address.internalBinaryRead(reader, reader.uint32(), options, message.address);
                    break;
                case /* rd.proto.money.Money restock_fee_amount */ 26:
                    message.restockFeeAmount = Money.internalBinaryRead(reader, reader.uint32(), options, message.restockFeeAmount);
                    break;
                case /* rd.proto.decimal.Decimal restock_fee_percentage */ 27:
                    message.restockFeePercentage = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.restockFeePercentage);
                    break;
                case /* rd.proto.uuid.UUID fulfillment_location_id */ 28:
                    message.fulfillmentLocationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.fulfillmentLocationId);
                    break;
                case /* bool is_delivery_fulfillment */ 29:
                    message.isDeliveryFulfillment = reader.bool();
                    break;
                case /* rd.proto.money.Money additional_deposit */ 30:
                    message.additionalDeposit = Money.internalBinaryRead(reader, reader.uint32(), options, message.additionalDeposit);
                    break;
                case /* rd.proto.money.Money discount_amount */ 34:
                    message.discountAmount = Money.internalBinaryRead(reader, reader.uint32(), options, message.discountAmount);
                    break;
                case /* rd.proto.decimal.Decimal discount_rate */ 35:
                    message.discountRate = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.discountRate);
                    break;
                case /* rd.txn.TenderSubmissionMetadata return_tender_submission */ 36:
                    message.returnTenderSubmission = TenderSubmissionMetadata.internalBinaryRead(reader, reader.uint32(), options, message.returnTenderSubmission);
                    break;
                case /* google.protobuf.Timestamp delivery_date */ 37:
                    message.deliveryDate = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.deliveryDate);
                    break;
                case /* string customer_contact_name */ 38:
                    message.customerContactName = reader.string();
                    break;
                case /* repeated rd.txn.TenderSubmissionMetadata tender_submissions */ 39:
                    message.tenderSubmissions.push(TenderSubmissionMetadata.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.txn.TenderSubmissionMetadata deposit_refund_tender_submission_metadata */ 40:
                    message.depositRefundTenderSubmissionMetadata = TenderSubmissionMetadata.internalBinaryRead(reader, reader.uint32(), options, message.depositRefundTenderSubmissionMetadata);
                    break;
                case /* map<string, rd.txn.Sale.ItemSet> item_sets_by_id */ 41:
                    this.binaryReadMap41(message.itemSetsById, reader, options);
                    break;
                case /* rd.proto.uuid.UUID designated_clerk_id */ 42:
                    message.designatedClerkId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.designatedClerkId);
                    break;
                case /* repeated rd.proto.uuid.UUID tax_rate_ids */ 43:
                    message.taxRateIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.txn.DepositConfig deposit_config */ 44:
                    message.depositConfig = DepositConfig.internalBinaryRead(reader, reader.uint32(), options, message.depositConfig);
                    break;
                case /* rd.proto.money.Money principal_to_refund */ 45:
                    message.principalToRefund = Money.internalBinaryRead(reader, reader.uint32(), options, message.principalToRefund);
                    break;
                case /* rd.api.sale.ShowPricesOption will_call_show_prices */ 46:
                    message.willCallShowPrices = reader.int32();
                    break;
                case /* rd.txn.DeliveryDetails delivery_details */ 47:
                    message.deliveryDetails = DeliveryDetails.internalBinaryRead(reader, reader.uint32(), options, message.deliveryDetails);
                    break;
                case /* rd.proto.uuid.UUID delivery_id */ 48:
                    message.deliveryId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.deliveryId);
                    break;
                case /* rd.txn.InitialDepositIntent initial_deposit_intent */ 49:
                    message.initialDepositIntent = InitialDepositIntent.internalBinaryRead(reader, reader.uint32(), options, message.initialDepositIntent);
                    break;
                case /* rd.api.sale.SaleFanBuilderCoupons fan_builder_coupons */ 50:
                    message.fanBuilderCoupons = SaleFanBuilderCoupons.internalBinaryRead(reader, reader.uint32(), options, message.fanBuilderCoupons);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap41(map: UpsertSaleV3Req["itemSetsById"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof UpsertSaleV3Req["itemSetsById"] | undefined, val: UpsertSaleV3Req["itemSetsById"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Sale_ItemSet.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.api.sale.UpsertSaleV3Req.item_sets_by_id");
            }
        }
        map[key ?? ""] = val ?? Sale_ItemSet.create();
    }
    internalBinaryWrite(message: UpsertSaleV3Req, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID customer_id = 2; */
        if (message.customerId)
            UUID.internalBinaryWrite(message.customerId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID location_id = 5; */
        if (message.locationId)
            UUID.internalBinaryWrite(message.locationId, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp quote_expires_at = 6; */
        if (message.quoteExpiresAt)
            Timestamp.internalBinaryWrite(message.quoteExpiresAt, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* rd.txn.Sale.Status status = 7; */
        if (message.status !== 0)
            writer.tag(7, WireType.Varint).int32(message.status);
        /* string notes = 8; */
        if (message.notes !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.notes);
        /* string customer_purchase_order_name = 10; */
        if (message.customerPurchaseOrderName !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.customerPurchaseOrderName);
        /* repeated string customer_contact_id_strings = 11; */
        for (let i = 0; i < message.customerContactIdStrings.length; i++)
            writer.tag(11, WireType.LengthDelimited).string(message.customerContactIdStrings[i]);
        /* repeated string additional_emails = 12; */
        for (let i = 0; i < message.additionalEmails.length; i++)
            writer.tag(12, WireType.LengthDelimited).string(message.additionalEmails[i]);
        /* string customer_contact_id_string = 13; */
        if (message.customerContactIdString !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.customerContactIdString);
        /* string stripe_reader_id = 15; */
        if (message.stripeReaderId !== "")
            writer.tag(15, WireType.LengthDelimited).string(message.stripeReaderId);
        /* rd.proto.uuid.UUID tax_rate_id = 16; */
        if (message.taxRateId)
            UUID.internalBinaryWrite(message.taxRateId, writer.tag(16, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal card_surcharge_rate = 17; */
        if (message.cardSurchargeRate)
            Decimal.internalBinaryWrite(message.cardSurchargeRate, writer.tag(17, WireType.LengthDelimited).fork(), options).join();
        /* string idempotency_key = 18; */
        if (message.idempotencyKey !== "")
            writer.tag(18, WireType.LengthDelimited).string(message.idempotencyKey);
        /* repeated rd.txn.SaleProduct productsV2 = 19; */
        for (let i = 0; i < message.productsV2.length; i++)
            SaleProduct.internalBinaryWrite(message.productsV2[i], writer.tag(19, WireType.LengthDelimited).fork(), options).join();
        /* string internal_notes = 20; */
        if (message.internalNotes !== "")
            writer.tag(20, WireType.LengthDelimited).string(message.internalNotes);
        /* rd.proto.uuid.UUID printer_id = 21; */
        if (message.printerId)
            UUID.internalBinaryWrite(message.printerId, writer.tag(21, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.address.Address address = 22; */
        if (message.address)
            Address.internalBinaryWrite(message.address, writer.tag(22, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money restock_fee_amount = 26; */
        if (message.restockFeeAmount)
            Money.internalBinaryWrite(message.restockFeeAmount, writer.tag(26, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal restock_fee_percentage = 27; */
        if (message.restockFeePercentage)
            Decimal.internalBinaryWrite(message.restockFeePercentage, writer.tag(27, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID fulfillment_location_id = 28; */
        if (message.fulfillmentLocationId)
            UUID.internalBinaryWrite(message.fulfillmentLocationId, writer.tag(28, WireType.LengthDelimited).fork(), options).join();
        /* bool is_delivery_fulfillment = 29; */
        if (message.isDeliveryFulfillment !== false)
            writer.tag(29, WireType.Varint).bool(message.isDeliveryFulfillment);
        /* rd.proto.money.Money additional_deposit = 30; */
        if (message.additionalDeposit)
            Money.internalBinaryWrite(message.additionalDeposit, writer.tag(30, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money discount_amount = 34; */
        if (message.discountAmount)
            Money.internalBinaryWrite(message.discountAmount, writer.tag(34, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal discount_rate = 35; */
        if (message.discountRate)
            Decimal.internalBinaryWrite(message.discountRate, writer.tag(35, WireType.LengthDelimited).fork(), options).join();
        /* rd.txn.TenderSubmissionMetadata return_tender_submission = 36; */
        if (message.returnTenderSubmission)
            TenderSubmissionMetadata.internalBinaryWrite(message.returnTenderSubmission, writer.tag(36, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp delivery_date = 37; */
        if (message.deliveryDate)
            Timestamp.internalBinaryWrite(message.deliveryDate, writer.tag(37, WireType.LengthDelimited).fork(), options).join();
        /* string customer_contact_name = 38; */
        if (message.customerContactName !== "")
            writer.tag(38, WireType.LengthDelimited).string(message.customerContactName);
        /* repeated rd.txn.TenderSubmissionMetadata tender_submissions = 39; */
        for (let i = 0; i < message.tenderSubmissions.length; i++)
            TenderSubmissionMetadata.internalBinaryWrite(message.tenderSubmissions[i], writer.tag(39, WireType.LengthDelimited).fork(), options).join();
        /* rd.txn.TenderSubmissionMetadata deposit_refund_tender_submission_metadata = 40; */
        if (message.depositRefundTenderSubmissionMetadata)
            TenderSubmissionMetadata.internalBinaryWrite(message.depositRefundTenderSubmissionMetadata, writer.tag(40, WireType.LengthDelimited).fork(), options).join();
        /* map<string, rd.txn.Sale.ItemSet> item_sets_by_id = 41; */
        for (let k of globalThis.Object.keys(message.itemSetsById)) {
            writer.tag(41, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Sale_ItemSet.internalBinaryWrite(message.itemSetsById[k], writer, options);
            writer.join().join();
        }
        /* rd.proto.uuid.UUID designated_clerk_id = 42; */
        if (message.designatedClerkId)
            UUID.internalBinaryWrite(message.designatedClerkId, writer.tag(42, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID tax_rate_ids = 43; */
        for (let i = 0; i < message.taxRateIds.length; i++)
            UUID.internalBinaryWrite(message.taxRateIds[i], writer.tag(43, WireType.LengthDelimited).fork(), options).join();
        /* rd.txn.DepositConfig deposit_config = 44; */
        if (message.depositConfig)
            DepositConfig.internalBinaryWrite(message.depositConfig, writer.tag(44, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money principal_to_refund = 45; */
        if (message.principalToRefund)
            Money.internalBinaryWrite(message.principalToRefund, writer.tag(45, WireType.LengthDelimited).fork(), options).join();
        /* rd.api.sale.ShowPricesOption will_call_show_prices = 46; */
        if (message.willCallShowPrices !== 0)
            writer.tag(46, WireType.Varint).int32(message.willCallShowPrices);
        /* rd.txn.DeliveryDetails delivery_details = 47; */
        if (message.deliveryDetails)
            DeliveryDetails.internalBinaryWrite(message.deliveryDetails, writer.tag(47, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID delivery_id = 48; */
        if (message.deliveryId)
            UUID.internalBinaryWrite(message.deliveryId, writer.tag(48, WireType.LengthDelimited).fork(), options).join();
        /* rd.txn.InitialDepositIntent initial_deposit_intent = 49; */
        if (message.initialDepositIntent)
            InitialDepositIntent.internalBinaryWrite(message.initialDepositIntent, writer.tag(49, WireType.LengthDelimited).fork(), options).join();
        /* rd.api.sale.SaleFanBuilderCoupons fan_builder_coupons = 50; */
        if (message.fanBuilderCoupons)
            SaleFanBuilderCoupons.internalBinaryWrite(message.fanBuilderCoupons, writer.tag(50, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.UpsertSaleV3Req
 */
export const UpsertSaleV3Req = new UpsertSaleV3Req$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpsertSaleV3Res$Type extends MessageType<UpsertSaleV3Res> {
    constructor() {
        super("rd.api.sale.UpsertSaleV3Res", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "email_error", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "signature_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "show_linked_products_on_receipt", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UpsertSaleV3Res>): UpsertSaleV3Res {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.emailError = false;
        message.signatureUrl = "";
        message.showLinkedProductsOnReceipt = false;
        if (value !== undefined)
            reflectionMergePartial<UpsertSaleV3Res>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpsertSaleV3Res): UpsertSaleV3Res {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* bool email_error */ 2:
                    message.emailError = reader.bool();
                    break;
                case /* string signature_url */ 3:
                    message.signatureUrl = reader.string();
                    break;
                case /* bool show_linked_products_on_receipt */ 4:
                    message.showLinkedProductsOnReceipt = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpsertSaleV3Res, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* bool email_error = 2; */
        if (message.emailError !== false)
            writer.tag(2, WireType.Varint).bool(message.emailError);
        /* string signature_url = 3; */
        if (message.signatureUrl !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.signatureUrl);
        /* bool show_linked_products_on_receipt = 4; */
        if (message.showLinkedProductsOnReceipt !== false)
            writer.tag(4, WireType.Varint).bool(message.showLinkedProductsOnReceipt);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.UpsertSaleV3Res
 */
export const UpsertSaleV3Res = new UpsertSaleV3Res$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CloseOutSaleReq$Type extends MessageType<CloseOutSaleReq> {
    constructor() {
        super("rd.api.sale.CloseOutSaleReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "sale_products_to_close_out_by_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => CloseOutSaleReq_SaleProductToCloseOut } },
            { no: 4, name: "idempotency_key", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "tender_submissions", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TenderSubmissionMetadata },
            { no: 6, name: "stripe_reader_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "sale_notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "internal_notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "customer_purchase_order_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "address", kind: "message", T: () => Address },
            { no: 11, name: "customer_contact_id_string", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "fulfillment_location_id", kind: "message", T: () => UUID },
            { no: 13, name: "is_delivery_fulfillment", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 14, name: "tax_rate_id", kind: "message", T: () => UUID },
            { no: 15, name: "printer_id", kind: "message", T: () => UUID },
            { no: 16, name: "return_tender_submission", kind: "message", T: () => TenderSubmissionMetadata },
            { no: 17, name: "tax_rate_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 18, name: "principal_to_redeem", kind: "message", T: () => Money },
            { no: 19, name: "delivery_details", kind: "message", T: () => DeliveryDetails },
            { no: 20, name: "delivery_id", kind: "message", T: () => UUID },
            { no: 21, name: "add_delivery_details_to_original_sale", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<CloseOutSaleReq>): CloseOutSaleReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.saleProductsToCloseOutById = {};
        message.idempotencyKey = "";
        message.tenderSubmissions = [];
        message.stripeReaderId = "";
        message.saleNotes = "";
        message.internalNotes = "";
        message.customerPurchaseOrderName = "";
        message.customerContactIdString = "";
        message.isDeliveryFulfillment = false;
        message.taxRateIds = [];
        message.addDeliveryDetailsToOriginalSale = false;
        if (value !== undefined)
            reflectionMergePartial<CloseOutSaleReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CloseOutSaleReq): CloseOutSaleReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* map<string, rd.api.sale.CloseOutSaleReq.SaleProductToCloseOut> sale_products_to_close_out_by_id */ 2:
                    this.binaryReadMap2(message.saleProductsToCloseOutById, reader, options);
                    break;
                case /* string idempotency_key */ 4:
                    message.idempotencyKey = reader.string();
                    break;
                case /* repeated rd.txn.TenderSubmissionMetadata tender_submissions */ 5:
                    message.tenderSubmissions.push(TenderSubmissionMetadata.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string stripe_reader_id */ 6:
                    message.stripeReaderId = reader.string();
                    break;
                case /* string sale_notes */ 7:
                    message.saleNotes = reader.string();
                    break;
                case /* string internal_notes */ 8:
                    message.internalNotes = reader.string();
                    break;
                case /* string customer_purchase_order_name */ 9:
                    message.customerPurchaseOrderName = reader.string();
                    break;
                case /* rd.proto.address.Address address */ 10:
                    message.address = Address.internalBinaryRead(reader, reader.uint32(), options, message.address);
                    break;
                case /* string customer_contact_id_string */ 11:
                    message.customerContactIdString = reader.string();
                    break;
                case /* rd.proto.uuid.UUID fulfillment_location_id */ 12:
                    message.fulfillmentLocationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.fulfillmentLocationId);
                    break;
                case /* bool is_delivery_fulfillment */ 13:
                    message.isDeliveryFulfillment = reader.bool();
                    break;
                case /* rd.proto.uuid.UUID tax_rate_id */ 14:
                    message.taxRateId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.taxRateId);
                    break;
                case /* rd.proto.uuid.UUID printer_id */ 15:
                    message.printerId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.printerId);
                    break;
                case /* rd.txn.TenderSubmissionMetadata return_tender_submission */ 16:
                    message.returnTenderSubmission = TenderSubmissionMetadata.internalBinaryRead(reader, reader.uint32(), options, message.returnTenderSubmission);
                    break;
                case /* repeated rd.proto.uuid.UUID tax_rate_ids */ 17:
                    message.taxRateIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.proto.money.Money principal_to_redeem */ 18:
                    message.principalToRedeem = Money.internalBinaryRead(reader, reader.uint32(), options, message.principalToRedeem);
                    break;
                case /* rd.txn.DeliveryDetails delivery_details */ 19:
                    message.deliveryDetails = DeliveryDetails.internalBinaryRead(reader, reader.uint32(), options, message.deliveryDetails);
                    break;
                case /* rd.proto.uuid.UUID delivery_id */ 20:
                    message.deliveryId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.deliveryId);
                    break;
                case /* bool add_delivery_details_to_original_sale */ 21:
                    message.addDeliveryDetailsToOriginalSale = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap2(map: CloseOutSaleReq["saleProductsToCloseOutById"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof CloseOutSaleReq["saleProductsToCloseOutById"] | undefined, val: CloseOutSaleReq["saleProductsToCloseOutById"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = CloseOutSaleReq_SaleProductToCloseOut.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.api.sale.CloseOutSaleReq.sale_products_to_close_out_by_id");
            }
        }
        map[key ?? ""] = val ?? CloseOutSaleReq_SaleProductToCloseOut.create();
    }
    internalBinaryWrite(message: CloseOutSaleReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* map<string, rd.api.sale.CloseOutSaleReq.SaleProductToCloseOut> sale_products_to_close_out_by_id = 2; */
        for (let k of globalThis.Object.keys(message.saleProductsToCloseOutById)) {
            writer.tag(2, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            CloseOutSaleReq_SaleProductToCloseOut.internalBinaryWrite(message.saleProductsToCloseOutById[k], writer, options);
            writer.join().join();
        }
        /* string idempotency_key = 4; */
        if (message.idempotencyKey !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.idempotencyKey);
        /* repeated rd.txn.TenderSubmissionMetadata tender_submissions = 5; */
        for (let i = 0; i < message.tenderSubmissions.length; i++)
            TenderSubmissionMetadata.internalBinaryWrite(message.tenderSubmissions[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* string stripe_reader_id = 6; */
        if (message.stripeReaderId !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.stripeReaderId);
        /* string sale_notes = 7; */
        if (message.saleNotes !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.saleNotes);
        /* string internal_notes = 8; */
        if (message.internalNotes !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.internalNotes);
        /* string customer_purchase_order_name = 9; */
        if (message.customerPurchaseOrderName !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.customerPurchaseOrderName);
        /* rd.proto.address.Address address = 10; */
        if (message.address)
            Address.internalBinaryWrite(message.address, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* string customer_contact_id_string = 11; */
        if (message.customerContactIdString !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.customerContactIdString);
        /* rd.proto.uuid.UUID fulfillment_location_id = 12; */
        if (message.fulfillmentLocationId)
            UUID.internalBinaryWrite(message.fulfillmentLocationId, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* bool is_delivery_fulfillment = 13; */
        if (message.isDeliveryFulfillment !== false)
            writer.tag(13, WireType.Varint).bool(message.isDeliveryFulfillment);
        /* rd.proto.uuid.UUID tax_rate_id = 14; */
        if (message.taxRateId)
            UUID.internalBinaryWrite(message.taxRateId, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID printer_id = 15; */
        if (message.printerId)
            UUID.internalBinaryWrite(message.printerId, writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        /* rd.txn.TenderSubmissionMetadata return_tender_submission = 16; */
        if (message.returnTenderSubmission)
            TenderSubmissionMetadata.internalBinaryWrite(message.returnTenderSubmission, writer.tag(16, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID tax_rate_ids = 17; */
        for (let i = 0; i < message.taxRateIds.length; i++)
            UUID.internalBinaryWrite(message.taxRateIds[i], writer.tag(17, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money principal_to_redeem = 18; */
        if (message.principalToRedeem)
            Money.internalBinaryWrite(message.principalToRedeem, writer.tag(18, WireType.LengthDelimited).fork(), options).join();
        /* rd.txn.DeliveryDetails delivery_details = 19; */
        if (message.deliveryDetails)
            DeliveryDetails.internalBinaryWrite(message.deliveryDetails, writer.tag(19, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID delivery_id = 20; */
        if (message.deliveryId)
            UUID.internalBinaryWrite(message.deliveryId, writer.tag(20, WireType.LengthDelimited).fork(), options).join();
        /* bool add_delivery_details_to_original_sale = 21; */
        if (message.addDeliveryDetailsToOriginalSale !== false)
            writer.tag(21, WireType.Varint).bool(message.addDeliveryDetailsToOriginalSale);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.CloseOutSaleReq
 */
export const CloseOutSaleReq = new CloseOutSaleReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CloseOutSaleReq_SaleProductToCloseOut$Type extends MessageType<CloseOutSaleReq_SaleProductToCloseOut> {
    constructor() {
        super("rd.api.sale.CloseOutSaleReq.SaleProductToCloseOut", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "qty", kind: "message", T: () => Decimal }
        ]);
    }
    create(value?: PartialMessage<CloseOutSaleReq_SaleProductToCloseOut>): CloseOutSaleReq_SaleProductToCloseOut {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<CloseOutSaleReq_SaleProductToCloseOut>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CloseOutSaleReq_SaleProductToCloseOut): CloseOutSaleReq_SaleProductToCloseOut {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* rd.proto.decimal.Decimal qty */ 2:
                    message.qty = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.qty);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CloseOutSaleReq_SaleProductToCloseOut, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal qty = 2; */
        if (message.qty)
            Decimal.internalBinaryWrite(message.qty, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.CloseOutSaleReq.SaleProductToCloseOut
 */
export const CloseOutSaleReq_SaleProductToCloseOut = new CloseOutSaleReq_SaleProductToCloseOut$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CloseOutSaleRes$Type extends MessageType<CloseOutSaleRes> {
    constructor() {
        super("rd.api.sale.CloseOutSaleRes", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "email_error", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "signature_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<CloseOutSaleRes>): CloseOutSaleRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.emailError = false;
        message.signatureUrl = "";
        if (value !== undefined)
            reflectionMergePartial<CloseOutSaleRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CloseOutSaleRes): CloseOutSaleRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* bool email_error */ 2:
                    message.emailError = reader.bool();
                    break;
                case /* string signature_url */ 3:
                    message.signatureUrl = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CloseOutSaleRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* bool email_error = 2; */
        if (message.emailError !== false)
            writer.tag(2, WireType.Varint).bool(message.emailError);
        /* string signature_url = 3; */
        if (message.signatureUrl !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.signatureUrl);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.CloseOutSaleRes
 */
export const CloseOutSaleRes = new CloseOutSaleRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CalculatePartialCloseoutTotalsReq$Type extends MessageType<CalculatePartialCloseoutTotalsReq> {
    constructor() {
        super("rd.api.sale.CalculatePartialCloseoutTotalsReq", [
            { no: 1, name: "sale_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "quantities_to_close_out_by_sale_product_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Decimal } },
            { no: 4, name: "is_card_surcharge_disabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "is_card_payment", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "principal_to_redeem", kind: "message", T: () => Money }
        ]);
    }
    create(value?: PartialMessage<CalculatePartialCloseoutTotalsReq>): CalculatePartialCloseoutTotalsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.quantitiesToCloseOutBySaleProductId = {};
        message.isCardSurchargeDisabled = false;
        message.isCardPayment = false;
        if (value !== undefined)
            reflectionMergePartial<CalculatePartialCloseoutTotalsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CalculatePartialCloseoutTotalsReq): CalculatePartialCloseoutTotalsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID sale_id */ 1:
                    message.saleId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.saleId);
                    break;
                case /* map<string, rd.proto.decimal.Decimal> quantities_to_close_out_by_sale_product_id */ 2:
                    this.binaryReadMap2(message.quantitiesToCloseOutBySaleProductId, reader, options);
                    break;
                case /* bool is_card_surcharge_disabled */ 4:
                    message.isCardSurchargeDisabled = reader.bool();
                    break;
                case /* bool is_card_payment */ 5:
                    message.isCardPayment = reader.bool();
                    break;
                case /* rd.proto.money.Money principal_to_redeem */ 6:
                    message.principalToRedeem = Money.internalBinaryRead(reader, reader.uint32(), options, message.principalToRedeem);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap2(map: CalculatePartialCloseoutTotalsReq["quantitiesToCloseOutBySaleProductId"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof CalculatePartialCloseoutTotalsReq["quantitiesToCloseOutBySaleProductId"] | undefined, val: CalculatePartialCloseoutTotalsReq["quantitiesToCloseOutBySaleProductId"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Decimal.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.api.sale.CalculatePartialCloseoutTotalsReq.quantities_to_close_out_by_sale_product_id");
            }
        }
        map[key ?? ""] = val ?? Decimal.create();
    }
    internalBinaryWrite(message: CalculatePartialCloseoutTotalsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID sale_id = 1; */
        if (message.saleId)
            UUID.internalBinaryWrite(message.saleId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* map<string, rd.proto.decimal.Decimal> quantities_to_close_out_by_sale_product_id = 2; */
        for (let k of globalThis.Object.keys(message.quantitiesToCloseOutBySaleProductId)) {
            writer.tag(2, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Decimal.internalBinaryWrite(message.quantitiesToCloseOutBySaleProductId[k], writer, options);
            writer.join().join();
        }
        /* bool is_card_surcharge_disabled = 4; */
        if (message.isCardSurchargeDisabled !== false)
            writer.tag(4, WireType.Varint).bool(message.isCardSurchargeDisabled);
        /* bool is_card_payment = 5; */
        if (message.isCardPayment !== false)
            writer.tag(5, WireType.Varint).bool(message.isCardPayment);
        /* rd.proto.money.Money principal_to_redeem = 6; */
        if (message.principalToRedeem)
            Money.internalBinaryWrite(message.principalToRedeem, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.CalculatePartialCloseoutTotalsReq
 */
export const CalculatePartialCloseoutTotalsReq = new CalculatePartialCloseoutTotalsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CalculatePartialCloseoutTotalsRes$Type extends MessageType<CalculatePartialCloseoutTotalsRes> {
    constructor() {
        super("rd.api.sale.CalculatePartialCloseoutTotalsRes", [
            { no: 1, name: "subtotal", kind: "message", T: () => Money },
            { no: 2, name: "additional_fees_by_name", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Money } },
            { no: 3, name: "total", kind: "message", T: () => Money },
            { no: 4, name: "payment_card_surcharge", kind: "message", T: () => Money },
            { no: 5, name: "payment_card_surcharge_tax", kind: "message", T: () => Money },
            { no: 6, name: "payment_card_surcharge_rate", kind: "message", T: () => Decimal },
            { no: 7, name: "tax_rate", kind: "message", T: () => TaxRate },
            { no: 9, name: "closeout_card_surcharge", kind: "message", T: () => Money },
            { no: 10, name: "closeout_card_surcharge_tax", kind: "message", T: () => Money },
            { no: 11, name: "remaining_total", kind: "message", T: () => Money },
            { no: 12, name: "total_due_today", kind: "message", T: () => Money },
            { no: 14, name: "discount_applied", kind: "message", T: () => Money },
            { no: 15, name: "returned_card_surcharge", kind: "message", T: () => Money },
            { no: 16, name: "returned_card_surcharge_tax", kind: "message", T: () => Money },
            { no: 17, name: "min_principal_to_redeem", kind: "message", T: () => Money },
            { no: 18, name: "max_principal_to_redeem", kind: "message", T: () => Money },
            { no: 19, name: "deposit_to_redeem", kind: "message", T: () => Money },
            { no: 20, name: "deposit_surcharge_to_redeem", kind: "message", T: () => Money },
            { no: 21, name: "deposit_surcharge_tax_to_redeem", kind: "message", T: () => Money },
            { no: 22, name: "restock_fee", kind: "message", T: () => Money },
            { no: 23, name: "base_taxes", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TaxLine },
            { no: 24, name: "payment_surcharge_taxes", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TaxLine },
            { no: 25, name: "loyalty_points_to_be_earned", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<CalculatePartialCloseoutTotalsRes>): CalculatePartialCloseoutTotalsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.additionalFeesByName = {};
        message.baseTaxes = [];
        message.paymentSurchargeTaxes = [];
        message.loyaltyPointsToBeEarned = 0;
        if (value !== undefined)
            reflectionMergePartial<CalculatePartialCloseoutTotalsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CalculatePartialCloseoutTotalsRes): CalculatePartialCloseoutTotalsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.money.Money subtotal */ 1:
                    message.subtotal = Money.internalBinaryRead(reader, reader.uint32(), options, message.subtotal);
                    break;
                case /* map<string, rd.proto.money.Money> additional_fees_by_name */ 2:
                    this.binaryReadMap2(message.additionalFeesByName, reader, options);
                    break;
                case /* rd.proto.money.Money total */ 3:
                    message.total = Money.internalBinaryRead(reader, reader.uint32(), options, message.total);
                    break;
                case /* rd.proto.money.Money payment_card_surcharge */ 4:
                    message.paymentCardSurcharge = Money.internalBinaryRead(reader, reader.uint32(), options, message.paymentCardSurcharge);
                    break;
                case /* rd.proto.money.Money payment_card_surcharge_tax */ 5:
                    message.paymentCardSurchargeTax = Money.internalBinaryRead(reader, reader.uint32(), options, message.paymentCardSurchargeTax);
                    break;
                case /* rd.proto.decimal.Decimal payment_card_surcharge_rate */ 6:
                    message.paymentCardSurchargeRate = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.paymentCardSurchargeRate);
                    break;
                case /* rd.company.TaxRate tax_rate */ 7:
                    message.taxRate = TaxRate.internalBinaryRead(reader, reader.uint32(), options, message.taxRate);
                    break;
                case /* rd.proto.money.Money closeout_card_surcharge */ 9:
                    message.closeoutCardSurcharge = Money.internalBinaryRead(reader, reader.uint32(), options, message.closeoutCardSurcharge);
                    break;
                case /* rd.proto.money.Money closeout_card_surcharge_tax */ 10:
                    message.closeoutCardSurchargeTax = Money.internalBinaryRead(reader, reader.uint32(), options, message.closeoutCardSurchargeTax);
                    break;
                case /* rd.proto.money.Money remaining_total */ 11:
                    message.remainingTotal = Money.internalBinaryRead(reader, reader.uint32(), options, message.remainingTotal);
                    break;
                case /* rd.proto.money.Money total_due_today */ 12:
                    message.totalDueToday = Money.internalBinaryRead(reader, reader.uint32(), options, message.totalDueToday);
                    break;
                case /* rd.proto.money.Money discount_applied */ 14:
                    message.discountApplied = Money.internalBinaryRead(reader, reader.uint32(), options, message.discountApplied);
                    break;
                case /* rd.proto.money.Money returned_card_surcharge */ 15:
                    message.returnedCardSurcharge = Money.internalBinaryRead(reader, reader.uint32(), options, message.returnedCardSurcharge);
                    break;
                case /* rd.proto.money.Money returned_card_surcharge_tax */ 16:
                    message.returnedCardSurchargeTax = Money.internalBinaryRead(reader, reader.uint32(), options, message.returnedCardSurchargeTax);
                    break;
                case /* rd.proto.money.Money min_principal_to_redeem */ 17:
                    message.minPrincipalToRedeem = Money.internalBinaryRead(reader, reader.uint32(), options, message.minPrincipalToRedeem);
                    break;
                case /* rd.proto.money.Money max_principal_to_redeem */ 18:
                    message.maxPrincipalToRedeem = Money.internalBinaryRead(reader, reader.uint32(), options, message.maxPrincipalToRedeem);
                    break;
                case /* rd.proto.money.Money deposit_to_redeem */ 19:
                    message.depositToRedeem = Money.internalBinaryRead(reader, reader.uint32(), options, message.depositToRedeem);
                    break;
                case /* rd.proto.money.Money deposit_surcharge_to_redeem */ 20:
                    message.depositSurchargeToRedeem = Money.internalBinaryRead(reader, reader.uint32(), options, message.depositSurchargeToRedeem);
                    break;
                case /* rd.proto.money.Money deposit_surcharge_tax_to_redeem */ 21:
                    message.depositSurchargeTaxToRedeem = Money.internalBinaryRead(reader, reader.uint32(), options, message.depositSurchargeTaxToRedeem);
                    break;
                case /* rd.proto.money.Money restock_fee */ 22:
                    message.restockFee = Money.internalBinaryRead(reader, reader.uint32(), options, message.restockFee);
                    break;
                case /* repeated rd.txn.TaxLine base_taxes */ 23:
                    message.baseTaxes.push(TaxLine.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.txn.TaxLine payment_surcharge_taxes */ 24:
                    message.paymentSurchargeTaxes.push(TaxLine.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 loyalty_points_to_be_earned */ 25:
                    message.loyaltyPointsToBeEarned = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap2(map: CalculatePartialCloseoutTotalsRes["additionalFeesByName"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof CalculatePartialCloseoutTotalsRes["additionalFeesByName"] | undefined, val: CalculatePartialCloseoutTotalsRes["additionalFeesByName"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Money.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.api.sale.CalculatePartialCloseoutTotalsRes.additional_fees_by_name");
            }
        }
        map[key ?? ""] = val ?? Money.create();
    }
    internalBinaryWrite(message: CalculatePartialCloseoutTotalsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.money.Money subtotal = 1; */
        if (message.subtotal)
            Money.internalBinaryWrite(message.subtotal, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* map<string, rd.proto.money.Money> additional_fees_by_name = 2; */
        for (let k of globalThis.Object.keys(message.additionalFeesByName)) {
            writer.tag(2, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Money.internalBinaryWrite(message.additionalFeesByName[k], writer, options);
            writer.join().join();
        }
        /* rd.proto.money.Money total = 3; */
        if (message.total)
            Money.internalBinaryWrite(message.total, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money payment_card_surcharge = 4; */
        if (message.paymentCardSurcharge)
            Money.internalBinaryWrite(message.paymentCardSurcharge, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money payment_card_surcharge_tax = 5; */
        if (message.paymentCardSurchargeTax)
            Money.internalBinaryWrite(message.paymentCardSurchargeTax, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal payment_card_surcharge_rate = 6; */
        if (message.paymentCardSurchargeRate)
            Decimal.internalBinaryWrite(message.paymentCardSurchargeRate, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* rd.company.TaxRate tax_rate = 7; */
        if (message.taxRate)
            TaxRate.internalBinaryWrite(message.taxRate, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money closeout_card_surcharge = 9; */
        if (message.closeoutCardSurcharge)
            Money.internalBinaryWrite(message.closeoutCardSurcharge, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money closeout_card_surcharge_tax = 10; */
        if (message.closeoutCardSurchargeTax)
            Money.internalBinaryWrite(message.closeoutCardSurchargeTax, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money remaining_total = 11; */
        if (message.remainingTotal)
            Money.internalBinaryWrite(message.remainingTotal, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money total_due_today = 12; */
        if (message.totalDueToday)
            Money.internalBinaryWrite(message.totalDueToday, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money discount_applied = 14; */
        if (message.discountApplied)
            Money.internalBinaryWrite(message.discountApplied, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money returned_card_surcharge = 15; */
        if (message.returnedCardSurcharge)
            Money.internalBinaryWrite(message.returnedCardSurcharge, writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money returned_card_surcharge_tax = 16; */
        if (message.returnedCardSurchargeTax)
            Money.internalBinaryWrite(message.returnedCardSurchargeTax, writer.tag(16, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money min_principal_to_redeem = 17; */
        if (message.minPrincipalToRedeem)
            Money.internalBinaryWrite(message.minPrincipalToRedeem, writer.tag(17, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money max_principal_to_redeem = 18; */
        if (message.maxPrincipalToRedeem)
            Money.internalBinaryWrite(message.maxPrincipalToRedeem, writer.tag(18, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money deposit_to_redeem = 19; */
        if (message.depositToRedeem)
            Money.internalBinaryWrite(message.depositToRedeem, writer.tag(19, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money deposit_surcharge_to_redeem = 20; */
        if (message.depositSurchargeToRedeem)
            Money.internalBinaryWrite(message.depositSurchargeToRedeem, writer.tag(20, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money deposit_surcharge_tax_to_redeem = 21; */
        if (message.depositSurchargeTaxToRedeem)
            Money.internalBinaryWrite(message.depositSurchargeTaxToRedeem, writer.tag(21, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money restock_fee = 22; */
        if (message.restockFee)
            Money.internalBinaryWrite(message.restockFee, writer.tag(22, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.txn.TaxLine base_taxes = 23; */
        for (let i = 0; i < message.baseTaxes.length; i++)
            TaxLine.internalBinaryWrite(message.baseTaxes[i], writer.tag(23, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.txn.TaxLine payment_surcharge_taxes = 24; */
        for (let i = 0; i < message.paymentSurchargeTaxes.length; i++)
            TaxLine.internalBinaryWrite(message.paymentSurchargeTaxes[i], writer.tag(24, WireType.LengthDelimited).fork(), options).join();
        /* int32 loyalty_points_to_be_earned = 25; */
        if (message.loyaltyPointsToBeEarned !== 0)
            writer.tag(25, WireType.Varint).int32(message.loyaltyPointsToBeEarned);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.CalculatePartialCloseoutTotalsRes
 */
export const CalculatePartialCloseoutTotalsRes = new CalculatePartialCloseoutTotalsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetCartPricesReq$Type extends MessageType<GetCartPricesReq> {
    constructor() {
        super("rd.api.sale.GetCartPricesReq", []);
    }
    create(value?: PartialMessage<GetCartPricesReq>): GetCartPricesReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetCartPricesReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetCartPricesReq): GetCartPricesReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetCartPricesReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.GetCartPricesReq
 */
export const GetCartPricesReq = new GetCartPricesReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetCartPricesReq_CartProduct$Type extends MessageType<GetCartPricesReq_CartProduct> {
    constructor() {
        super("rd.api.sale.GetCartPricesReq.CartProduct", []);
    }
    create(value?: PartialMessage<GetCartPricesReq_CartProduct>): GetCartPricesReq_CartProduct {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetCartPricesReq_CartProduct>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetCartPricesReq_CartProduct): GetCartPricesReq_CartProduct {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetCartPricesReq_CartProduct, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.GetCartPricesReq.CartProduct
 */
export const GetCartPricesReq_CartProduct = new GetCartPricesReq_CartProduct$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetCartPricesRes$Type extends MessageType<GetCartPricesRes> {
    constructor() {
        super("rd.api.sale.GetCartPricesRes", []);
    }
    create(value?: PartialMessage<GetCartPricesRes>): GetCartPricesRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetCartPricesRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetCartPricesRes): GetCartPricesRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetCartPricesRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.GetCartPricesRes
 */
export const GetCartPricesRes = new GetCartPricesRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetCartPricesRes_AdditionalFeeTotal$Type extends MessageType<GetCartPricesRes_AdditionalFeeTotal> {
    constructor() {
        super("rd.api.sale.GetCartPricesRes.AdditionalFeeTotal", []);
    }
    create(value?: PartialMessage<GetCartPricesRes_AdditionalFeeTotal>): GetCartPricesRes_AdditionalFeeTotal {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetCartPricesRes_AdditionalFeeTotal>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetCartPricesRes_AdditionalFeeTotal): GetCartPricesRes_AdditionalFeeTotal {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetCartPricesRes_AdditionalFeeTotal, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.GetCartPricesRes.AdditionalFeeTotal
 */
export const GetCartPricesRes_AdditionalFeeTotal = new GetCartPricesRes_AdditionalFeeTotal$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetCartPricesRes_ProductPriceInformation$Type extends MessageType<GetCartPricesRes_ProductPriceInformation> {
    constructor() {
        super("rd.api.sale.GetCartPricesRes.ProductPriceInformation", []);
    }
    create(value?: PartialMessage<GetCartPricesRes_ProductPriceInformation>): GetCartPricesRes_ProductPriceInformation {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetCartPricesRes_ProductPriceInformation>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetCartPricesRes_ProductPriceInformation): GetCartPricesRes_ProductPriceInformation {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetCartPricesRes_ProductPriceInformation, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.GetCartPricesRes.ProductPriceInformation
 */
export const GetCartPricesRes_ProductPriceInformation = new GetCartPricesRes_ProductPriceInformation$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SyncCartPricesReq$Type extends MessageType<SyncCartPricesReq> {
    constructor() {
        super("rd.api.sale.SyncCartPricesReq", [
            { no: 1, name: "location_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "cart", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SyncCartPricesReq_CartProduct },
            { no: 3, name: "customer_id", kind: "message", T: () => UUID },
            { no: 4, name: "sale_id", kind: "message", T: () => UUID },
            { no: 5, name: "stripe_reader_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "tax_rate_id", kind: "message", T: () => UUID },
            { no: 9, name: "is_special_order_closeout", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 10, name: "restock_fee_percentage", kind: "message", T: () => Decimal },
            { no: 11, name: "restock_fee_amount", kind: "message", T: () => Money },
            { no: 12, name: "skip_card_reader_sync", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 13, name: "additional_deposit", kind: "message", T: () => Money },
            { no: 17, name: "discount_amount", kind: "message", T: () => Money },
            { no: 18, name: "discount_rate", kind: "message", T: () => Decimal },
            { no: 19, name: "deposit_refund_amount", kind: "message", T: () => Money },
            { no: 20, name: "tax_rate_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 21, name: "deposit_config", kind: "message", T: () => DepositConfig },
            { no: 22, name: "principal_to_refund", kind: "message", T: () => Money },
            { no: 23, name: "separate_special_order_and_stock_totals", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 24, name: "is_additional_deposit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 25, name: "is_refund_deposit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 26, name: "is_initial_deposit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 27, name: "initial_deposit_intent", kind: "message", T: () => InitialDepositIntent },
            { no: 28, name: "address", kind: "message", T: () => Address },
            { no: 29, name: "fan_builder_coupons", kind: "message", T: () => SaleFanBuilderCoupons }
        ]);
    }
    create(value?: PartialMessage<SyncCartPricesReq>): SyncCartPricesReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.cart = [];
        message.stripeReaderId = "";
        message.isSpecialOrderCloseout = false;
        message.skipCardReaderSync = false;
        message.taxRateIds = [];
        message.separateSpecialOrderAndStockTotals = false;
        message.isAdditionalDeposit = false;
        message.isRefundDeposit = false;
        message.isInitialDeposit = false;
        if (value !== undefined)
            reflectionMergePartial<SyncCartPricesReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SyncCartPricesReq): SyncCartPricesReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID location_id */ 1:
                    message.locationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.locationId);
                    break;
                case /* repeated rd.api.sale.SyncCartPricesReq.CartProduct cart */ 2:
                    message.cart.push(SyncCartPricesReq_CartProduct.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.proto.uuid.UUID customer_id */ 3:
                    message.customerId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.customerId);
                    break;
                case /* rd.proto.uuid.UUID sale_id */ 4:
                    message.saleId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.saleId);
                    break;
                case /* string stripe_reader_id */ 5:
                    message.stripeReaderId = reader.string();
                    break;
                case /* rd.proto.uuid.UUID tax_rate_id */ 7:
                    message.taxRateId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.taxRateId);
                    break;
                case /* bool is_special_order_closeout */ 9:
                    message.isSpecialOrderCloseout = reader.bool();
                    break;
                case /* rd.proto.decimal.Decimal restock_fee_percentage */ 10:
                    message.restockFeePercentage = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.restockFeePercentage);
                    break;
                case /* rd.proto.money.Money restock_fee_amount */ 11:
                    message.restockFeeAmount = Money.internalBinaryRead(reader, reader.uint32(), options, message.restockFeeAmount);
                    break;
                case /* bool skip_card_reader_sync */ 12:
                    message.skipCardReaderSync = reader.bool();
                    break;
                case /* rd.proto.money.Money additional_deposit */ 13:
                    message.additionalDeposit = Money.internalBinaryRead(reader, reader.uint32(), options, message.additionalDeposit);
                    break;
                case /* rd.proto.money.Money discount_amount */ 17:
                    message.discountAmount = Money.internalBinaryRead(reader, reader.uint32(), options, message.discountAmount);
                    break;
                case /* rd.proto.decimal.Decimal discount_rate */ 18:
                    message.discountRate = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.discountRate);
                    break;
                case /* rd.proto.money.Money deposit_refund_amount */ 19:
                    message.depositRefundAmount = Money.internalBinaryRead(reader, reader.uint32(), options, message.depositRefundAmount);
                    break;
                case /* repeated rd.proto.uuid.UUID tax_rate_ids */ 20:
                    message.taxRateIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.txn.DepositConfig deposit_config */ 21:
                    message.depositConfig = DepositConfig.internalBinaryRead(reader, reader.uint32(), options, message.depositConfig);
                    break;
                case /* rd.proto.money.Money principal_to_refund */ 22:
                    message.principalToRefund = Money.internalBinaryRead(reader, reader.uint32(), options, message.principalToRefund);
                    break;
                case /* bool separate_special_order_and_stock_totals */ 23:
                    message.separateSpecialOrderAndStockTotals = reader.bool();
                    break;
                case /* bool is_additional_deposit */ 24:
                    message.isAdditionalDeposit = reader.bool();
                    break;
                case /* bool is_refund_deposit */ 25:
                    message.isRefundDeposit = reader.bool();
                    break;
                case /* bool is_initial_deposit */ 26:
                    message.isInitialDeposit = reader.bool();
                    break;
                case /* rd.txn.InitialDepositIntent initial_deposit_intent */ 27:
                    message.initialDepositIntent = InitialDepositIntent.internalBinaryRead(reader, reader.uint32(), options, message.initialDepositIntent);
                    break;
                case /* rd.proto.address.Address address */ 28:
                    message.address = Address.internalBinaryRead(reader, reader.uint32(), options, message.address);
                    break;
                case /* rd.api.sale.SaleFanBuilderCoupons fan_builder_coupons */ 29:
                    message.fanBuilderCoupons = SaleFanBuilderCoupons.internalBinaryRead(reader, reader.uint32(), options, message.fanBuilderCoupons);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SyncCartPricesReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID location_id = 1; */
        if (message.locationId)
            UUID.internalBinaryWrite(message.locationId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.api.sale.SyncCartPricesReq.CartProduct cart = 2; */
        for (let i = 0; i < message.cart.length; i++)
            SyncCartPricesReq_CartProduct.internalBinaryWrite(message.cart[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID customer_id = 3; */
        if (message.customerId)
            UUID.internalBinaryWrite(message.customerId, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID sale_id = 4; */
        if (message.saleId)
            UUID.internalBinaryWrite(message.saleId, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* string stripe_reader_id = 5; */
        if (message.stripeReaderId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.stripeReaderId);
        /* rd.proto.uuid.UUID tax_rate_id = 7; */
        if (message.taxRateId)
            UUID.internalBinaryWrite(message.taxRateId, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* bool is_special_order_closeout = 9; */
        if (message.isSpecialOrderCloseout !== false)
            writer.tag(9, WireType.Varint).bool(message.isSpecialOrderCloseout);
        /* rd.proto.decimal.Decimal restock_fee_percentage = 10; */
        if (message.restockFeePercentage)
            Decimal.internalBinaryWrite(message.restockFeePercentage, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money restock_fee_amount = 11; */
        if (message.restockFeeAmount)
            Money.internalBinaryWrite(message.restockFeeAmount, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* bool skip_card_reader_sync = 12; */
        if (message.skipCardReaderSync !== false)
            writer.tag(12, WireType.Varint).bool(message.skipCardReaderSync);
        /* rd.proto.money.Money additional_deposit = 13; */
        if (message.additionalDeposit)
            Money.internalBinaryWrite(message.additionalDeposit, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money discount_amount = 17; */
        if (message.discountAmount)
            Money.internalBinaryWrite(message.discountAmount, writer.tag(17, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal discount_rate = 18; */
        if (message.discountRate)
            Decimal.internalBinaryWrite(message.discountRate, writer.tag(18, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money deposit_refund_amount = 19; */
        if (message.depositRefundAmount)
            Money.internalBinaryWrite(message.depositRefundAmount, writer.tag(19, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID tax_rate_ids = 20; */
        for (let i = 0; i < message.taxRateIds.length; i++)
            UUID.internalBinaryWrite(message.taxRateIds[i], writer.tag(20, WireType.LengthDelimited).fork(), options).join();
        /* rd.txn.DepositConfig deposit_config = 21; */
        if (message.depositConfig)
            DepositConfig.internalBinaryWrite(message.depositConfig, writer.tag(21, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money principal_to_refund = 22; */
        if (message.principalToRefund)
            Money.internalBinaryWrite(message.principalToRefund, writer.tag(22, WireType.LengthDelimited).fork(), options).join();
        /* bool separate_special_order_and_stock_totals = 23; */
        if (message.separateSpecialOrderAndStockTotals !== false)
            writer.tag(23, WireType.Varint).bool(message.separateSpecialOrderAndStockTotals);
        /* bool is_additional_deposit = 24; */
        if (message.isAdditionalDeposit !== false)
            writer.tag(24, WireType.Varint).bool(message.isAdditionalDeposit);
        /* bool is_refund_deposit = 25; */
        if (message.isRefundDeposit !== false)
            writer.tag(25, WireType.Varint).bool(message.isRefundDeposit);
        /* bool is_initial_deposit = 26; */
        if (message.isInitialDeposit !== false)
            writer.tag(26, WireType.Varint).bool(message.isInitialDeposit);
        /* rd.txn.InitialDepositIntent initial_deposit_intent = 27; */
        if (message.initialDepositIntent)
            InitialDepositIntent.internalBinaryWrite(message.initialDepositIntent, writer.tag(27, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.address.Address address = 28; */
        if (message.address)
            Address.internalBinaryWrite(message.address, writer.tag(28, WireType.LengthDelimited).fork(), options).join();
        /* rd.api.sale.SaleFanBuilderCoupons fan_builder_coupons = 29; */
        if (message.fanBuilderCoupons)
            SaleFanBuilderCoupons.internalBinaryWrite(message.fanBuilderCoupons, writer.tag(29, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.SyncCartPricesReq
 */
export const SyncCartPricesReq = new SyncCartPricesReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SyncCartPricesReq_CartProduct$Type extends MessageType<SyncCartPricesReq_CartProduct> {
    constructor() {
        super("rd.api.sale.SyncCartPricesReq.CartProduct", [
            { no: 1, name: "product_id", kind: "message", T: () => UUID },
            { no: 3, name: "product_edited_price", kind: "message", T: () => Money },
            { no: 5, name: "id", kind: "message", T: () => UUID },
            { no: 7, name: "is_special_orderable_v2", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 8, name: "sale_product_type", kind: "enum", T: () => ["rd.txn.SaleProduct.Type", SaleProduct_Type, "TYPE_"] },
            { no: 9, name: "returned_from_sale_product_id", kind: "message", T: () => UUID },
            { no: 10, name: "quantity_v2", kind: "message", T: () => Decimal },
            { no: 11, name: "quantity_returned_v2", kind: "message", T: () => Decimal },
            { no: 12, name: "uom_id", kind: "message", T: () => UUID },
            { no: 13, name: "quantity_uom", kind: "message", T: () => Decimal },
            { no: 14, name: "uom_id_returned", kind: "message", T: () => UUID },
            { no: 15, name: "quantity_returned_uom", kind: "message", T: () => Decimal },
            { no: 16, name: "is_taxed", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 17, name: "is_taxed_edited", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 18, name: "disabled_additional_fee_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 19, name: "product_edited_price_fractional", kind: "message", T: () => FractionalMoney },
            { no: 20, name: "is_price_edited", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<SyncCartPricesReq_CartProduct>): SyncCartPricesReq_CartProduct {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isSpecialOrderableV2 = false;
        message.saleProductType = 0;
        message.isTaxed = false;
        message.isTaxedEdited = false;
        message.disabledAdditionalFeeIds = [];
        message.isPriceEdited = false;
        if (value !== undefined)
            reflectionMergePartial<SyncCartPricesReq_CartProduct>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SyncCartPricesReq_CartProduct): SyncCartPricesReq_CartProduct {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID product_id */ 1:
                    message.productId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.productId);
                    break;
                case /* rd.proto.money.Money product_edited_price */ 3:
                    message.productEditedPrice = Money.internalBinaryRead(reader, reader.uint32(), options, message.productEditedPrice);
                    break;
                case /* rd.proto.uuid.UUID id */ 5:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* bool is_special_orderable_v2 */ 7:
                    message.isSpecialOrderableV2 = reader.bool();
                    break;
                case /* rd.txn.SaleProduct.Type sale_product_type */ 8:
                    message.saleProductType = reader.int32();
                    break;
                case /* rd.proto.uuid.UUID returned_from_sale_product_id */ 9:
                    message.returnedFromSaleProductId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.returnedFromSaleProductId);
                    break;
                case /* rd.proto.decimal.Decimal quantity_v2 */ 10:
                    message.quantityV2 = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.quantityV2);
                    break;
                case /* rd.proto.decimal.Decimal quantity_returned_v2 */ 11:
                    message.quantityReturnedV2 = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.quantityReturnedV2);
                    break;
                case /* rd.proto.uuid.UUID uom_id */ 12:
                    message.uomId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.uomId);
                    break;
                case /* rd.proto.decimal.Decimal quantity_uom */ 13:
                    message.quantityUom = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.quantityUom);
                    break;
                case /* rd.proto.uuid.UUID uom_id_returned */ 14:
                    message.uomIdReturned = UUID.internalBinaryRead(reader, reader.uint32(), options, message.uomIdReturned);
                    break;
                case /* rd.proto.decimal.Decimal quantity_returned_uom */ 15:
                    message.quantityReturnedUom = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.quantityReturnedUom);
                    break;
                case /* bool is_taxed */ 16:
                    message.isTaxed = reader.bool();
                    break;
                case /* bool is_taxed_edited */ 17:
                    message.isTaxedEdited = reader.bool();
                    break;
                case /* repeated string disabled_additional_fee_ids */ 18:
                    message.disabledAdditionalFeeIds.push(reader.string());
                    break;
                case /* rd.proto.money.FractionalMoney product_edited_price_fractional */ 19:
                    message.productEditedPriceFractional = FractionalMoney.internalBinaryRead(reader, reader.uint32(), options, message.productEditedPriceFractional);
                    break;
                case /* bool is_price_edited */ 20:
                    message.isPriceEdited = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SyncCartPricesReq_CartProduct, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID product_id = 1; */
        if (message.productId)
            UUID.internalBinaryWrite(message.productId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money product_edited_price = 3; */
        if (message.productEditedPrice)
            Money.internalBinaryWrite(message.productEditedPrice, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID id = 5; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* bool is_special_orderable_v2 = 7; */
        if (message.isSpecialOrderableV2 !== false)
            writer.tag(7, WireType.Varint).bool(message.isSpecialOrderableV2);
        /* rd.txn.SaleProduct.Type sale_product_type = 8; */
        if (message.saleProductType !== 0)
            writer.tag(8, WireType.Varint).int32(message.saleProductType);
        /* rd.proto.uuid.UUID returned_from_sale_product_id = 9; */
        if (message.returnedFromSaleProductId)
            UUID.internalBinaryWrite(message.returnedFromSaleProductId, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal quantity_v2 = 10; */
        if (message.quantityV2)
            Decimal.internalBinaryWrite(message.quantityV2, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal quantity_returned_v2 = 11; */
        if (message.quantityReturnedV2)
            Decimal.internalBinaryWrite(message.quantityReturnedV2, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID uom_id = 12; */
        if (message.uomId)
            UUID.internalBinaryWrite(message.uomId, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal quantity_uom = 13; */
        if (message.quantityUom)
            Decimal.internalBinaryWrite(message.quantityUom, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID uom_id_returned = 14; */
        if (message.uomIdReturned)
            UUID.internalBinaryWrite(message.uomIdReturned, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal quantity_returned_uom = 15; */
        if (message.quantityReturnedUom)
            Decimal.internalBinaryWrite(message.quantityReturnedUom, writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        /* bool is_taxed = 16; */
        if (message.isTaxed !== false)
            writer.tag(16, WireType.Varint).bool(message.isTaxed);
        /* bool is_taxed_edited = 17; */
        if (message.isTaxedEdited !== false)
            writer.tag(17, WireType.Varint).bool(message.isTaxedEdited);
        /* repeated string disabled_additional_fee_ids = 18; */
        for (let i = 0; i < message.disabledAdditionalFeeIds.length; i++)
            writer.tag(18, WireType.LengthDelimited).string(message.disabledAdditionalFeeIds[i]);
        /* rd.proto.money.FractionalMoney product_edited_price_fractional = 19; */
        if (message.productEditedPriceFractional)
            FractionalMoney.internalBinaryWrite(message.productEditedPriceFractional, writer.tag(19, WireType.LengthDelimited).fork(), options).join();
        /* bool is_price_edited = 20; */
        if (message.isPriceEdited !== false)
            writer.tag(20, WireType.Varint).bool(message.isPriceEdited);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.SyncCartPricesReq.CartProduct
 */
export const SyncCartPricesReq_CartProduct = new SyncCartPricesReq_CartProduct$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SyncCartPricesRes$Type extends MessageType<SyncCartPricesRes> {
    constructor() {
        super("rd.api.sale.SyncCartPricesRes", [
            { no: 1, name: "subtotal", kind: "message", T: () => Money },
            { no: 2, name: "additional_fees_by_fee_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => SyncCartPricesRes_AdditionalFeeTotal } },
            { no: 3, name: "base_sales_tax", kind: "message", T: () => Money },
            { no: 4, name: "total", kind: "message", T: () => Money },
            { no: 8, name: "amount_to_refund", kind: "message", T: () => Money },
            { no: 9, name: "tax_rate", kind: "message", T: () => TaxRate },
            { no: 10, name: "card_surcharge_rate", kind: "message", T: () => Decimal },
            { no: 11, name: "card_surcharge", kind: "message", T: () => Money },
            { no: 12, name: "card_surcharge_tax", kind: "message", T: () => Money },
            { no: 13, name: "total_due_today", kind: "message", T: () => Money },
            { no: 15, name: "deposit_total", kind: "message", T: () => Money },
            { no: 16, name: "prices_by_sale_product_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => SyncCartPricesRes_ProductPriceInformation } },
            { no: 17, name: "total_returned_surcharge", kind: "message", T: () => Money },
            { no: 18, name: "total_returned_surcharge_tax", kind: "message", T: () => Money },
            { no: 20, name: "total_restock_fee", kind: "message", T: () => Money },
            { no: 21, name: "special_order_totals_info", kind: "message", T: () => SyncCartPricesRes_SpecialOrderTotalsInfo },
            { no: 22, name: "discount_applied", kind: "message", T: () => Money },
            { no: 23, name: "combined_totals_line_items", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TotalsLineItem },
            { no: 24, name: "due_today_line_items", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TotalsLineItem },
            { no: 25, name: "stock_and_return_totals_info", kind: "message", T: () => SyncCartPricesRes_StockAndReturnTotalsInfo },
            { no: 26, name: "overall_total", kind: "message", T: () => Money },
            { no: 27, name: "closed_out_total", kind: "message", T: () => Money },
            { no: 28, name: "closeout_children_breakdown_line_items", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TotalsLineItem },
            { no: 29, name: "overall_totals_line_items", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TotalsLineItem },
            { no: 30, name: "minimum_deposit_to_refund", kind: "message", T: () => Money },
            { no: 31, name: "maximum_deposit_to_refund", kind: "message", T: () => Money },
            { no: 32, name: "initial_deposit", kind: "message", T: () => Money },
            { no: 33, name: "sale_taxes", kind: "message", T: () => SaleTaxes },
            { no: 34, name: "minimum_principal_to_refund", kind: "message", T: () => Money },
            { no: 35, name: "maximum_principal_to_refund", kind: "message", T: () => Money },
            { no: 36, name: "principal_to_refund", kind: "message", T: () => Money },
            { no: 37, name: "deposit_to_refund_surcharge", kind: "message", T: () => Money },
            { no: 38, name: "deposit_to_refund_surcharge_tax", kind: "message", T: () => Money },
            { no: 39, name: "sold_subtotal", kind: "message", T: () => Money },
            { no: 40, name: "deposit_basis", kind: "message", T: () => Money },
            { no: 41, name: "initial_deposit_rate", kind: "message", T: () => Decimal },
            { no: 42, name: "added_products", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SyncCartPricesRes_AddedProduct },
            { no: 43, name: "subtotal_excluding_returns", kind: "message", T: () => Money },
            { no: 44, name: "loyalty_points_to_be_earned", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<SyncCartPricesRes>): SyncCartPricesRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.additionalFeesByFeeId = {};
        message.pricesBySaleProductId = {};
        message.combinedTotalsLineItems = [];
        message.dueTodayLineItems = [];
        message.closeoutChildrenBreakdownLineItems = [];
        message.overallTotalsLineItems = [];
        message.addedProducts = [];
        message.loyaltyPointsToBeEarned = 0;
        if (value !== undefined)
            reflectionMergePartial<SyncCartPricesRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SyncCartPricesRes): SyncCartPricesRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.money.Money subtotal */ 1:
                    message.subtotal = Money.internalBinaryRead(reader, reader.uint32(), options, message.subtotal);
                    break;
                case /* map<string, rd.api.sale.SyncCartPricesRes.AdditionalFeeTotal> additional_fees_by_fee_id */ 2:
                    this.binaryReadMap2(message.additionalFeesByFeeId, reader, options);
                    break;
                case /* rd.proto.money.Money base_sales_tax */ 3:
                    message.baseSalesTax = Money.internalBinaryRead(reader, reader.uint32(), options, message.baseSalesTax);
                    break;
                case /* rd.proto.money.Money total */ 4:
                    message.total = Money.internalBinaryRead(reader, reader.uint32(), options, message.total);
                    break;
                case /* rd.proto.money.Money amount_to_refund */ 8:
                    message.amountToRefund = Money.internalBinaryRead(reader, reader.uint32(), options, message.amountToRefund);
                    break;
                case /* rd.company.TaxRate tax_rate */ 9:
                    message.taxRate = TaxRate.internalBinaryRead(reader, reader.uint32(), options, message.taxRate);
                    break;
                case /* rd.proto.decimal.Decimal card_surcharge_rate */ 10:
                    message.cardSurchargeRate = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.cardSurchargeRate);
                    break;
                case /* rd.proto.money.Money card_surcharge */ 11:
                    message.cardSurcharge = Money.internalBinaryRead(reader, reader.uint32(), options, message.cardSurcharge);
                    break;
                case /* rd.proto.money.Money card_surcharge_tax */ 12:
                    message.cardSurchargeTax = Money.internalBinaryRead(reader, reader.uint32(), options, message.cardSurchargeTax);
                    break;
                case /* rd.proto.money.Money total_due_today */ 13:
                    message.totalDueToday = Money.internalBinaryRead(reader, reader.uint32(), options, message.totalDueToday);
                    break;
                case /* rd.proto.money.Money deposit_total */ 15:
                    message.depositTotal = Money.internalBinaryRead(reader, reader.uint32(), options, message.depositTotal);
                    break;
                case /* map<string, rd.api.sale.SyncCartPricesRes.ProductPriceInformation> prices_by_sale_product_id */ 16:
                    this.binaryReadMap16(message.pricesBySaleProductId, reader, options);
                    break;
                case /* rd.proto.money.Money total_returned_surcharge */ 17:
                    message.totalReturnedSurcharge = Money.internalBinaryRead(reader, reader.uint32(), options, message.totalReturnedSurcharge);
                    break;
                case /* rd.proto.money.Money total_returned_surcharge_tax */ 18:
                    message.totalReturnedSurchargeTax = Money.internalBinaryRead(reader, reader.uint32(), options, message.totalReturnedSurchargeTax);
                    break;
                case /* rd.proto.money.Money total_restock_fee */ 20:
                    message.totalRestockFee = Money.internalBinaryRead(reader, reader.uint32(), options, message.totalRestockFee);
                    break;
                case /* rd.api.sale.SyncCartPricesRes.SpecialOrderTotalsInfo special_order_totals_info */ 21:
                    message.specialOrderTotalsInfo = SyncCartPricesRes_SpecialOrderTotalsInfo.internalBinaryRead(reader, reader.uint32(), options, message.specialOrderTotalsInfo);
                    break;
                case /* rd.proto.money.Money discount_applied */ 22:
                    message.discountApplied = Money.internalBinaryRead(reader, reader.uint32(), options, message.discountApplied);
                    break;
                case /* repeated rd.txn.TotalsLineItem combined_totals_line_items */ 23:
                    message.combinedTotalsLineItems.push(TotalsLineItem.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.txn.TotalsLineItem due_today_line_items */ 24:
                    message.dueTodayLineItems.push(TotalsLineItem.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.api.sale.SyncCartPricesRes.StockAndReturnTotalsInfo stock_and_return_totals_info */ 25:
                    message.stockAndReturnTotalsInfo = SyncCartPricesRes_StockAndReturnTotalsInfo.internalBinaryRead(reader, reader.uint32(), options, message.stockAndReturnTotalsInfo);
                    break;
                case /* rd.proto.money.Money overall_total */ 26:
                    message.overallTotal = Money.internalBinaryRead(reader, reader.uint32(), options, message.overallTotal);
                    break;
                case /* rd.proto.money.Money closed_out_total */ 27:
                    message.closedOutTotal = Money.internalBinaryRead(reader, reader.uint32(), options, message.closedOutTotal);
                    break;
                case /* repeated rd.txn.TotalsLineItem closeout_children_breakdown_line_items */ 28:
                    message.closeoutChildrenBreakdownLineItems.push(TotalsLineItem.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.txn.TotalsLineItem overall_totals_line_items */ 29:
                    message.overallTotalsLineItems.push(TotalsLineItem.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.proto.money.Money minimum_deposit_to_refund */ 30:
                    message.minimumDepositToRefund = Money.internalBinaryRead(reader, reader.uint32(), options, message.minimumDepositToRefund);
                    break;
                case /* rd.proto.money.Money maximum_deposit_to_refund */ 31:
                    message.maximumDepositToRefund = Money.internalBinaryRead(reader, reader.uint32(), options, message.maximumDepositToRefund);
                    break;
                case /* rd.proto.money.Money initial_deposit */ 32:
                    message.initialDeposit = Money.internalBinaryRead(reader, reader.uint32(), options, message.initialDeposit);
                    break;
                case /* rd.txn.SaleTaxes sale_taxes */ 33:
                    message.saleTaxes = SaleTaxes.internalBinaryRead(reader, reader.uint32(), options, message.saleTaxes);
                    break;
                case /* rd.proto.money.Money minimum_principal_to_refund */ 34:
                    message.minimumPrincipalToRefund = Money.internalBinaryRead(reader, reader.uint32(), options, message.minimumPrincipalToRefund);
                    break;
                case /* rd.proto.money.Money maximum_principal_to_refund */ 35:
                    message.maximumPrincipalToRefund = Money.internalBinaryRead(reader, reader.uint32(), options, message.maximumPrincipalToRefund);
                    break;
                case /* rd.proto.money.Money principal_to_refund */ 36:
                    message.principalToRefund = Money.internalBinaryRead(reader, reader.uint32(), options, message.principalToRefund);
                    break;
                case /* rd.proto.money.Money deposit_to_refund_surcharge */ 37:
                    message.depositToRefundSurcharge = Money.internalBinaryRead(reader, reader.uint32(), options, message.depositToRefundSurcharge);
                    break;
                case /* rd.proto.money.Money deposit_to_refund_surcharge_tax */ 38:
                    message.depositToRefundSurchargeTax = Money.internalBinaryRead(reader, reader.uint32(), options, message.depositToRefundSurchargeTax);
                    break;
                case /* rd.proto.money.Money sold_subtotal */ 39:
                    message.soldSubtotal = Money.internalBinaryRead(reader, reader.uint32(), options, message.soldSubtotal);
                    break;
                case /* rd.proto.money.Money deposit_basis */ 40:
                    message.depositBasis = Money.internalBinaryRead(reader, reader.uint32(), options, message.depositBasis);
                    break;
                case /* rd.proto.decimal.Decimal initial_deposit_rate */ 41:
                    message.initialDepositRate = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.initialDepositRate);
                    break;
                case /* repeated rd.api.sale.SyncCartPricesRes.AddedProduct added_products */ 42:
                    message.addedProducts.push(SyncCartPricesRes_AddedProduct.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.proto.money.Money subtotal_excluding_returns */ 43:
                    message.subtotalExcludingReturns = Money.internalBinaryRead(reader, reader.uint32(), options, message.subtotalExcludingReturns);
                    break;
                case /* int32 loyalty_points_to_be_earned */ 44:
                    message.loyaltyPointsToBeEarned = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap2(map: SyncCartPricesRes["additionalFeesByFeeId"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof SyncCartPricesRes["additionalFeesByFeeId"] | undefined, val: SyncCartPricesRes["additionalFeesByFeeId"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = SyncCartPricesRes_AdditionalFeeTotal.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.api.sale.SyncCartPricesRes.additional_fees_by_fee_id");
            }
        }
        map[key ?? ""] = val ?? SyncCartPricesRes_AdditionalFeeTotal.create();
    }
    private binaryReadMap16(map: SyncCartPricesRes["pricesBySaleProductId"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof SyncCartPricesRes["pricesBySaleProductId"] | undefined, val: SyncCartPricesRes["pricesBySaleProductId"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = SyncCartPricesRes_ProductPriceInformation.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.api.sale.SyncCartPricesRes.prices_by_sale_product_id");
            }
        }
        map[key ?? ""] = val ?? SyncCartPricesRes_ProductPriceInformation.create();
    }
    internalBinaryWrite(message: SyncCartPricesRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.money.Money subtotal = 1; */
        if (message.subtotal)
            Money.internalBinaryWrite(message.subtotal, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* map<string, rd.api.sale.SyncCartPricesRes.AdditionalFeeTotal> additional_fees_by_fee_id = 2; */
        for (let k of globalThis.Object.keys(message.additionalFeesByFeeId)) {
            writer.tag(2, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            SyncCartPricesRes_AdditionalFeeTotal.internalBinaryWrite(message.additionalFeesByFeeId[k], writer, options);
            writer.join().join();
        }
        /* rd.proto.money.Money base_sales_tax = 3; */
        if (message.baseSalesTax)
            Money.internalBinaryWrite(message.baseSalesTax, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money total = 4; */
        if (message.total)
            Money.internalBinaryWrite(message.total, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money amount_to_refund = 8; */
        if (message.amountToRefund)
            Money.internalBinaryWrite(message.amountToRefund, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* rd.company.TaxRate tax_rate = 9; */
        if (message.taxRate)
            TaxRate.internalBinaryWrite(message.taxRate, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal card_surcharge_rate = 10; */
        if (message.cardSurchargeRate)
            Decimal.internalBinaryWrite(message.cardSurchargeRate, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money card_surcharge = 11; */
        if (message.cardSurcharge)
            Money.internalBinaryWrite(message.cardSurcharge, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money card_surcharge_tax = 12; */
        if (message.cardSurchargeTax)
            Money.internalBinaryWrite(message.cardSurchargeTax, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money total_due_today = 13; */
        if (message.totalDueToday)
            Money.internalBinaryWrite(message.totalDueToday, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money deposit_total = 15; */
        if (message.depositTotal)
            Money.internalBinaryWrite(message.depositTotal, writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        /* map<string, rd.api.sale.SyncCartPricesRes.ProductPriceInformation> prices_by_sale_product_id = 16; */
        for (let k of globalThis.Object.keys(message.pricesBySaleProductId)) {
            writer.tag(16, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            SyncCartPricesRes_ProductPriceInformation.internalBinaryWrite(message.pricesBySaleProductId[k], writer, options);
            writer.join().join();
        }
        /* rd.proto.money.Money total_returned_surcharge = 17; */
        if (message.totalReturnedSurcharge)
            Money.internalBinaryWrite(message.totalReturnedSurcharge, writer.tag(17, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money total_returned_surcharge_tax = 18; */
        if (message.totalReturnedSurchargeTax)
            Money.internalBinaryWrite(message.totalReturnedSurchargeTax, writer.tag(18, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money total_restock_fee = 20; */
        if (message.totalRestockFee)
            Money.internalBinaryWrite(message.totalRestockFee, writer.tag(20, WireType.LengthDelimited).fork(), options).join();
        /* rd.api.sale.SyncCartPricesRes.SpecialOrderTotalsInfo special_order_totals_info = 21; */
        if (message.specialOrderTotalsInfo)
            SyncCartPricesRes_SpecialOrderTotalsInfo.internalBinaryWrite(message.specialOrderTotalsInfo, writer.tag(21, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money discount_applied = 22; */
        if (message.discountApplied)
            Money.internalBinaryWrite(message.discountApplied, writer.tag(22, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.txn.TotalsLineItem combined_totals_line_items = 23; */
        for (let i = 0; i < message.combinedTotalsLineItems.length; i++)
            TotalsLineItem.internalBinaryWrite(message.combinedTotalsLineItems[i], writer.tag(23, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.txn.TotalsLineItem due_today_line_items = 24; */
        for (let i = 0; i < message.dueTodayLineItems.length; i++)
            TotalsLineItem.internalBinaryWrite(message.dueTodayLineItems[i], writer.tag(24, WireType.LengthDelimited).fork(), options).join();
        /* rd.api.sale.SyncCartPricesRes.StockAndReturnTotalsInfo stock_and_return_totals_info = 25; */
        if (message.stockAndReturnTotalsInfo)
            SyncCartPricesRes_StockAndReturnTotalsInfo.internalBinaryWrite(message.stockAndReturnTotalsInfo, writer.tag(25, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money overall_total = 26; */
        if (message.overallTotal)
            Money.internalBinaryWrite(message.overallTotal, writer.tag(26, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money closed_out_total = 27; */
        if (message.closedOutTotal)
            Money.internalBinaryWrite(message.closedOutTotal, writer.tag(27, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.txn.TotalsLineItem closeout_children_breakdown_line_items = 28; */
        for (let i = 0; i < message.closeoutChildrenBreakdownLineItems.length; i++)
            TotalsLineItem.internalBinaryWrite(message.closeoutChildrenBreakdownLineItems[i], writer.tag(28, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.txn.TotalsLineItem overall_totals_line_items = 29; */
        for (let i = 0; i < message.overallTotalsLineItems.length; i++)
            TotalsLineItem.internalBinaryWrite(message.overallTotalsLineItems[i], writer.tag(29, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money minimum_deposit_to_refund = 30; */
        if (message.minimumDepositToRefund)
            Money.internalBinaryWrite(message.minimumDepositToRefund, writer.tag(30, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money maximum_deposit_to_refund = 31; */
        if (message.maximumDepositToRefund)
            Money.internalBinaryWrite(message.maximumDepositToRefund, writer.tag(31, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money initial_deposit = 32; */
        if (message.initialDeposit)
            Money.internalBinaryWrite(message.initialDeposit, writer.tag(32, WireType.LengthDelimited).fork(), options).join();
        /* rd.txn.SaleTaxes sale_taxes = 33; */
        if (message.saleTaxes)
            SaleTaxes.internalBinaryWrite(message.saleTaxes, writer.tag(33, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money minimum_principal_to_refund = 34; */
        if (message.minimumPrincipalToRefund)
            Money.internalBinaryWrite(message.minimumPrincipalToRefund, writer.tag(34, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money maximum_principal_to_refund = 35; */
        if (message.maximumPrincipalToRefund)
            Money.internalBinaryWrite(message.maximumPrincipalToRefund, writer.tag(35, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money principal_to_refund = 36; */
        if (message.principalToRefund)
            Money.internalBinaryWrite(message.principalToRefund, writer.tag(36, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money deposit_to_refund_surcharge = 37; */
        if (message.depositToRefundSurcharge)
            Money.internalBinaryWrite(message.depositToRefundSurcharge, writer.tag(37, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money deposit_to_refund_surcharge_tax = 38; */
        if (message.depositToRefundSurchargeTax)
            Money.internalBinaryWrite(message.depositToRefundSurchargeTax, writer.tag(38, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money sold_subtotal = 39; */
        if (message.soldSubtotal)
            Money.internalBinaryWrite(message.soldSubtotal, writer.tag(39, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money deposit_basis = 40; */
        if (message.depositBasis)
            Money.internalBinaryWrite(message.depositBasis, writer.tag(40, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal initial_deposit_rate = 41; */
        if (message.initialDepositRate)
            Decimal.internalBinaryWrite(message.initialDepositRate, writer.tag(41, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.api.sale.SyncCartPricesRes.AddedProduct added_products = 42; */
        for (let i = 0; i < message.addedProducts.length; i++)
            SyncCartPricesRes_AddedProduct.internalBinaryWrite(message.addedProducts[i], writer.tag(42, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money subtotal_excluding_returns = 43; */
        if (message.subtotalExcludingReturns)
            Money.internalBinaryWrite(message.subtotalExcludingReturns, writer.tag(43, WireType.LengthDelimited).fork(), options).join();
        /* int32 loyalty_points_to_be_earned = 44; */
        if (message.loyaltyPointsToBeEarned !== 0)
            writer.tag(44, WireType.Varint).int32(message.loyaltyPointsToBeEarned);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.SyncCartPricesRes
 */
export const SyncCartPricesRes = new SyncCartPricesRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SyncCartPricesRes_AdditionalFeeTotal$Type extends MessageType<SyncCartPricesRes_AdditionalFeeTotal> {
    constructor() {
        super("rd.api.sale.SyncCartPricesRes.AdditionalFeeTotal", [
            { no: 1, name: "fee_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "fee", kind: "message", T: () => Money }
        ]);
    }
    create(value?: PartialMessage<SyncCartPricesRes_AdditionalFeeTotal>): SyncCartPricesRes_AdditionalFeeTotal {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.feeId = "";
        message.name = "";
        if (value !== undefined)
            reflectionMergePartial<SyncCartPricesRes_AdditionalFeeTotal>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SyncCartPricesRes_AdditionalFeeTotal): SyncCartPricesRes_AdditionalFeeTotal {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string fee_id */ 1:
                    message.feeId = reader.string();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* rd.proto.money.Money fee */ 3:
                    message.fee = Money.internalBinaryRead(reader, reader.uint32(), options, message.fee);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SyncCartPricesRes_AdditionalFeeTotal, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string fee_id = 1; */
        if (message.feeId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.feeId);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* rd.proto.money.Money fee = 3; */
        if (message.fee)
            Money.internalBinaryWrite(message.fee, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.SyncCartPricesRes.AdditionalFeeTotal
 */
export const SyncCartPricesRes_AdditionalFeeTotal = new SyncCartPricesRes_AdditionalFeeTotal$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SyncCartPricesRes_ProductPriceInformation$Type extends MessageType<SyncCartPricesRes_ProductPriceInformation> {
    constructor() {
        super("rd.api.sale.SyncCartPricesRes.ProductPriceInformation", [
            { no: 1, name: "product_id_string", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "unit_price", kind: "message", T: () => Money },
            { no: 3, name: "total_price", kind: "message", T: () => Money },
            { no: 4, name: "rule_information", kind: "message", T: () => RuleInformation },
            { no: 5, name: "unit_fee", kind: "message", T: () => FractionalMoney },
            { no: 6, name: "is_taxed", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "additional_fees", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SaleProduct_AdditionalFee },
            { no: 8, name: "unit_price_fractional", kind: "message", T: () => FractionalMoney }
        ]);
    }
    create(value?: PartialMessage<SyncCartPricesRes_ProductPriceInformation>): SyncCartPricesRes_ProductPriceInformation {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.productIdString = "";
        message.isTaxed = false;
        message.additionalFees = [];
        if (value !== undefined)
            reflectionMergePartial<SyncCartPricesRes_ProductPriceInformation>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SyncCartPricesRes_ProductPriceInformation): SyncCartPricesRes_ProductPriceInformation {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string product_id_string */ 1:
                    message.productIdString = reader.string();
                    break;
                case /* rd.proto.money.Money unit_price */ 2:
                    message.unitPrice = Money.internalBinaryRead(reader, reader.uint32(), options, message.unitPrice);
                    break;
                case /* rd.proto.money.Money total_price */ 3:
                    message.totalPrice = Money.internalBinaryRead(reader, reader.uint32(), options, message.totalPrice);
                    break;
                case /* rd.price.RuleInformation rule_information */ 4:
                    message.ruleInformation = RuleInformation.internalBinaryRead(reader, reader.uint32(), options, message.ruleInformation);
                    break;
                case /* rd.proto.money.FractionalMoney unit_fee */ 5:
                    message.unitFee = FractionalMoney.internalBinaryRead(reader, reader.uint32(), options, message.unitFee);
                    break;
                case /* bool is_taxed */ 6:
                    message.isTaxed = reader.bool();
                    break;
                case /* repeated rd.txn.SaleProduct.AdditionalFee additional_fees */ 7:
                    message.additionalFees.push(SaleProduct_AdditionalFee.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.proto.money.FractionalMoney unit_price_fractional */ 8:
                    message.unitPriceFractional = FractionalMoney.internalBinaryRead(reader, reader.uint32(), options, message.unitPriceFractional);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SyncCartPricesRes_ProductPriceInformation, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string product_id_string = 1; */
        if (message.productIdString !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.productIdString);
        /* rd.proto.money.Money unit_price = 2; */
        if (message.unitPrice)
            Money.internalBinaryWrite(message.unitPrice, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money total_price = 3; */
        if (message.totalPrice)
            Money.internalBinaryWrite(message.totalPrice, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.price.RuleInformation rule_information = 4; */
        if (message.ruleInformation)
            RuleInformation.internalBinaryWrite(message.ruleInformation, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.FractionalMoney unit_fee = 5; */
        if (message.unitFee)
            FractionalMoney.internalBinaryWrite(message.unitFee, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* bool is_taxed = 6; */
        if (message.isTaxed !== false)
            writer.tag(6, WireType.Varint).bool(message.isTaxed);
        /* repeated rd.txn.SaleProduct.AdditionalFee additional_fees = 7; */
        for (let i = 0; i < message.additionalFees.length; i++)
            SaleProduct_AdditionalFee.internalBinaryWrite(message.additionalFees[i], writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.FractionalMoney unit_price_fractional = 8; */
        if (message.unitPriceFractional)
            FractionalMoney.internalBinaryWrite(message.unitPriceFractional, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.SyncCartPricesRes.ProductPriceInformation
 */
export const SyncCartPricesRes_ProductPriceInformation = new SyncCartPricesRes_ProductPriceInformation$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SyncCartPricesRes_SpecialOrderTotalsInfo$Type extends MessageType<SyncCartPricesRes_SpecialOrderTotalsInfo> {
    constructor() {
        super("rd.api.sale.SyncCartPricesRes.SpecialOrderTotalsInfo", [
            { no: 1, name: "subtotal", kind: "message", T: () => Money },
            { no: 2, name: "additional_fees_by_fee_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => SyncCartPricesRes_AdditionalFeeTotal } },
            { no: 3, name: "sales_tax", kind: "message", T: () => Money },
            { no: 4, name: "deposit_taken", kind: "message", T: () => Money },
            { no: 5, name: "discount_applied", kind: "message", T: () => Money },
            { no: 6, name: "base_taxes", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TaxLine }
        ]);
    }
    create(value?: PartialMessage<SyncCartPricesRes_SpecialOrderTotalsInfo>): SyncCartPricesRes_SpecialOrderTotalsInfo {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.additionalFeesByFeeId = {};
        message.baseTaxes = [];
        if (value !== undefined)
            reflectionMergePartial<SyncCartPricesRes_SpecialOrderTotalsInfo>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SyncCartPricesRes_SpecialOrderTotalsInfo): SyncCartPricesRes_SpecialOrderTotalsInfo {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.money.Money subtotal */ 1:
                    message.subtotal = Money.internalBinaryRead(reader, reader.uint32(), options, message.subtotal);
                    break;
                case /* map<string, rd.api.sale.SyncCartPricesRes.AdditionalFeeTotal> additional_fees_by_fee_id */ 2:
                    this.binaryReadMap2(message.additionalFeesByFeeId, reader, options);
                    break;
                case /* rd.proto.money.Money sales_tax */ 3:
                    message.salesTax = Money.internalBinaryRead(reader, reader.uint32(), options, message.salesTax);
                    break;
                case /* rd.proto.money.Money deposit_taken */ 4:
                    message.depositTaken = Money.internalBinaryRead(reader, reader.uint32(), options, message.depositTaken);
                    break;
                case /* rd.proto.money.Money discount_applied */ 5:
                    message.discountApplied = Money.internalBinaryRead(reader, reader.uint32(), options, message.discountApplied);
                    break;
                case /* repeated rd.txn.TaxLine base_taxes */ 6:
                    message.baseTaxes.push(TaxLine.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap2(map: SyncCartPricesRes_SpecialOrderTotalsInfo["additionalFeesByFeeId"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof SyncCartPricesRes_SpecialOrderTotalsInfo["additionalFeesByFeeId"] | undefined, val: SyncCartPricesRes_SpecialOrderTotalsInfo["additionalFeesByFeeId"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = SyncCartPricesRes_AdditionalFeeTotal.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.api.sale.SyncCartPricesRes.SpecialOrderTotalsInfo.additional_fees_by_fee_id");
            }
        }
        map[key ?? ""] = val ?? SyncCartPricesRes_AdditionalFeeTotal.create();
    }
    internalBinaryWrite(message: SyncCartPricesRes_SpecialOrderTotalsInfo, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.money.Money subtotal = 1; */
        if (message.subtotal)
            Money.internalBinaryWrite(message.subtotal, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* map<string, rd.api.sale.SyncCartPricesRes.AdditionalFeeTotal> additional_fees_by_fee_id = 2; */
        for (let k of globalThis.Object.keys(message.additionalFeesByFeeId)) {
            writer.tag(2, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            SyncCartPricesRes_AdditionalFeeTotal.internalBinaryWrite(message.additionalFeesByFeeId[k], writer, options);
            writer.join().join();
        }
        /* rd.proto.money.Money sales_tax = 3; */
        if (message.salesTax)
            Money.internalBinaryWrite(message.salesTax, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money deposit_taken = 4; */
        if (message.depositTaken)
            Money.internalBinaryWrite(message.depositTaken, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money discount_applied = 5; */
        if (message.discountApplied)
            Money.internalBinaryWrite(message.discountApplied, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.txn.TaxLine base_taxes = 6; */
        for (let i = 0; i < message.baseTaxes.length; i++)
            TaxLine.internalBinaryWrite(message.baseTaxes[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.SyncCartPricesRes.SpecialOrderTotalsInfo
 */
export const SyncCartPricesRes_SpecialOrderTotalsInfo = new SyncCartPricesRes_SpecialOrderTotalsInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SyncCartPricesRes_StockAndReturnTotalsInfo$Type extends MessageType<SyncCartPricesRes_StockAndReturnTotalsInfo> {
    constructor() {
        super("rd.api.sale.SyncCartPricesRes.StockAndReturnTotalsInfo", [
            { no: 1, name: "subtotal", kind: "message", T: () => Money },
            { no: 2, name: "additional_fees_by_fee_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => SyncCartPricesRes_AdditionalFeeTotal } },
            { no: 3, name: "sales_tax", kind: "message", T: () => Money },
            { no: 4, name: "discount_applied", kind: "message", T: () => Money },
            { no: 5, name: "total", kind: "message", T: () => Money },
            { no: 6, name: "base_taxes", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TaxLine }
        ]);
    }
    create(value?: PartialMessage<SyncCartPricesRes_StockAndReturnTotalsInfo>): SyncCartPricesRes_StockAndReturnTotalsInfo {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.additionalFeesByFeeId = {};
        message.baseTaxes = [];
        if (value !== undefined)
            reflectionMergePartial<SyncCartPricesRes_StockAndReturnTotalsInfo>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SyncCartPricesRes_StockAndReturnTotalsInfo): SyncCartPricesRes_StockAndReturnTotalsInfo {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.money.Money subtotal */ 1:
                    message.subtotal = Money.internalBinaryRead(reader, reader.uint32(), options, message.subtotal);
                    break;
                case /* map<string, rd.api.sale.SyncCartPricesRes.AdditionalFeeTotal> additional_fees_by_fee_id */ 2:
                    this.binaryReadMap2(message.additionalFeesByFeeId, reader, options);
                    break;
                case /* rd.proto.money.Money sales_tax */ 3:
                    message.salesTax = Money.internalBinaryRead(reader, reader.uint32(), options, message.salesTax);
                    break;
                case /* rd.proto.money.Money discount_applied */ 4:
                    message.discountApplied = Money.internalBinaryRead(reader, reader.uint32(), options, message.discountApplied);
                    break;
                case /* rd.proto.money.Money total */ 5:
                    message.total = Money.internalBinaryRead(reader, reader.uint32(), options, message.total);
                    break;
                case /* repeated rd.txn.TaxLine base_taxes */ 6:
                    message.baseTaxes.push(TaxLine.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap2(map: SyncCartPricesRes_StockAndReturnTotalsInfo["additionalFeesByFeeId"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof SyncCartPricesRes_StockAndReturnTotalsInfo["additionalFeesByFeeId"] | undefined, val: SyncCartPricesRes_StockAndReturnTotalsInfo["additionalFeesByFeeId"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = SyncCartPricesRes_AdditionalFeeTotal.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.api.sale.SyncCartPricesRes.StockAndReturnTotalsInfo.additional_fees_by_fee_id");
            }
        }
        map[key ?? ""] = val ?? SyncCartPricesRes_AdditionalFeeTotal.create();
    }
    internalBinaryWrite(message: SyncCartPricesRes_StockAndReturnTotalsInfo, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.money.Money subtotal = 1; */
        if (message.subtotal)
            Money.internalBinaryWrite(message.subtotal, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* map<string, rd.api.sale.SyncCartPricesRes.AdditionalFeeTotal> additional_fees_by_fee_id = 2; */
        for (let k of globalThis.Object.keys(message.additionalFeesByFeeId)) {
            writer.tag(2, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            SyncCartPricesRes_AdditionalFeeTotal.internalBinaryWrite(message.additionalFeesByFeeId[k], writer, options);
            writer.join().join();
        }
        /* rd.proto.money.Money sales_tax = 3; */
        if (message.salesTax)
            Money.internalBinaryWrite(message.salesTax, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money discount_applied = 4; */
        if (message.discountApplied)
            Money.internalBinaryWrite(message.discountApplied, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money total = 5; */
        if (message.total)
            Money.internalBinaryWrite(message.total, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.txn.TaxLine base_taxes = 6; */
        for (let i = 0; i < message.baseTaxes.length; i++)
            TaxLine.internalBinaryWrite(message.baseTaxes[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.SyncCartPricesRes.StockAndReturnTotalsInfo
 */
export const SyncCartPricesRes_StockAndReturnTotalsInfo = new SyncCartPricesRes_StockAndReturnTotalsInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SyncCartPricesRes_AddedProduct$Type extends MessageType<SyncCartPricesRes_AddedProduct> {
    constructor() {
        super("rd.api.sale.SyncCartPricesRes.AddedProduct", [
            { no: 1, name: "sale_product", kind: "message", T: () => SaleProduct },
            { no: 2, name: "product", kind: "message", T: () => Product }
        ]);
    }
    create(value?: PartialMessage<SyncCartPricesRes_AddedProduct>): SyncCartPricesRes_AddedProduct {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<SyncCartPricesRes_AddedProduct>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SyncCartPricesRes_AddedProduct): SyncCartPricesRes_AddedProduct {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.txn.SaleProduct sale_product */ 1:
                    message.saleProduct = SaleProduct.internalBinaryRead(reader, reader.uint32(), options, message.saleProduct);
                    break;
                case /* rd.product.Product product */ 2:
                    message.product = Product.internalBinaryRead(reader, reader.uint32(), options, message.product);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SyncCartPricesRes_AddedProduct, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.txn.SaleProduct sale_product = 1; */
        if (message.saleProduct)
            SaleProduct.internalBinaryWrite(message.saleProduct, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.product.Product product = 2; */
        if (message.product)
            Product.internalBinaryWrite(message.product, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.SyncCartPricesRes.AddedProduct
 */
export const SyncCartPricesRes_AddedProduct = new SyncCartPricesRes_AddedProduct$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSaleReq$Type extends MessageType<GetSaleReq> {
    constructor() {
        super("rd.api.sale.GetSaleReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<GetSaleReq>): GetSaleReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetSaleReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetSaleReq): GetSaleReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetSaleReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.GetSaleReq
 */
export const GetSaleReq = new GetSaleReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSaleRes$Type extends MessageType<GetSaleRes> {
    constructor() {
        super("rd.api.sale.GetSaleRes", [
            { no: 1, name: "sale", kind: "message", T: () => Sale },
            { no: 2, name: "location", kind: "message", T: () => Location },
            { no: 3, name: "customer_purchase_order", kind: "message", T: () => PurchaseOrder },
            { no: 5, name: "products_by_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Product } },
            { no: 6, name: "tint_colors_by_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => TintColor } },
            { no: 9, name: "customer_contact", kind: "message", T: () => Contacts_Contact },
            { no: 10, name: "inventories_by_product_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Inventories } },
            { no: 13, name: "sale_products", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SaleProduct },
            { no: 14, name: "catalog_products_by_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Product$ } },
            { no: 17, name: "deposit_total", kind: "message", T: () => Money },
            { no: 21, name: "returned_from_sales_by_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Sale } },
            { no: 22, name: "amount_paid_by_customer", kind: "message", T: () => Money },
            { no: 23, name: "returned_in_sales_by_sale_product_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => GetSaleRes_ReturnedInSales } },
            { no: 25, name: "aggregated_totals", kind: "message", T: () => Sale_Totals },
            { no: 26, name: "totals_line_items", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TotalsLineItem },
            { no: 27, name: "quantity_remaining_by_sale_product_id_v2", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Decimal } },
            { no: 28, name: "credit_history_link", kind: "message", T: () => CreditHistoryLink },
            { no: 29, name: "credit_allocation_links", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => CreditHistoryLink },
            { no: 30, name: "ledger_methods", kind: "message", T: () => LedgerMethods },
            { no: 31, name: "fulfillment_location", kind: "message", T: () => Location },
            { no: 33, name: "tier_prices_by_product_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => TierPrices } },
            { no: 35, name: "linked_special_order_sales", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => GetSaleRes_LinkedSpecialOrderSale },
            { no: 38, name: "linked_orders_list_by_sale_product_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => GetSaleRes_LinkedOrders } },
            { no: 39, name: "linked_shipments_by_sale_product_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => GetSaleRes_LinkedShipments } },
            { no: 40, name: "closed_out_quantities_by_sale_product_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Decimal } },
            { no: 41, name: "unredeemed_deposit_total", kind: "message", T: () => Money },
            { no: 53, name: "unredeemed_deposit_principal_total", kind: "message", T: () => Money },
            { no: 42, name: "child_sales_by_sale_product_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => GetSaleRes_LinkedChildSales } },
            { no: 43, name: "applied_deposit_redemption_total", kind: "message", T: () => Money },
            { no: 44, name: "deposit_history", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => GetSaleRes_DepositEvent },
            { no: 45, name: "parent_sale", kind: "message", T: () => GetSaleRes_LinkedSpecialOrderSale },
            { no: 46, name: "overall_total", kind: "message", T: () => Money },
            { no: 47, name: "closed_out_total", kind: "message", T: () => Money },
            { no: 48, name: "close_out_children_breakdown_line_items", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TotalsLineItem },
            { no: 49, name: "overall_totals_line_items", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TotalsLineItem },
            { no: 50, name: "due_date", kind: "message", T: () => Timestamp },
            { no: 51, name: "potential_discount_expires_at", kind: "message", T: () => Timestamp },
            { no: 52, name: "sale_taxes", kind: "message", T: () => SaleTaxes },
            { no: 54, name: "delivery_stops", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => DeliveryStop },
            { no: 55, name: "coupons", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppliedCoupon }
        ]);
    }
    create(value?: PartialMessage<GetSaleRes>): GetSaleRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.productsById = {};
        message.tintColorsById = {};
        message.inventoriesByProductId = {};
        message.saleProducts = [];
        message.catalogProductsById = {};
        message.returnedFromSalesById = {};
        message.returnedInSalesBySaleProductId = {};
        message.totalsLineItems = [];
        message.quantityRemainingBySaleProductIdV2 = {};
        message.creditAllocationLinks = [];
        message.tierPricesByProductId = {};
        message.linkedSpecialOrderSales = [];
        message.linkedOrdersListBySaleProductId = {};
        message.linkedShipmentsBySaleProductId = {};
        message.closedOutQuantitiesBySaleProductId = {};
        message.childSalesBySaleProductId = {};
        message.depositHistory = [];
        message.closeOutChildrenBreakdownLineItems = [];
        message.overallTotalsLineItems = [];
        message.deliveryStops = [];
        message.coupons = [];
        if (value !== undefined)
            reflectionMergePartial<GetSaleRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetSaleRes): GetSaleRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.txn.Sale sale */ 1:
                    message.sale = Sale.internalBinaryRead(reader, reader.uint32(), options, message.sale);
                    break;
                case /* rd.company.Location location */ 2:
                    message.location = Location.internalBinaryRead(reader, reader.uint32(), options, message.location);
                    break;
                case /* rd.customer.PurchaseOrder customer_purchase_order */ 3:
                    message.customerPurchaseOrder = PurchaseOrder.internalBinaryRead(reader, reader.uint32(), options, message.customerPurchaseOrder);
                    break;
                case /* map<string, rd.product.Product> products_by_id */ 5:
                    this.binaryReadMap5(message.productsById, reader, options);
                    break;
                case /* map<string, rd.tintcolor.TintColor> tint_colors_by_id */ 6:
                    this.binaryReadMap6(message.tintColorsById, reader, options);
                    break;
                case /* rd.customer.Contacts.Contact customer_contact */ 9:
                    message.customerContact = Contacts_Contact.internalBinaryRead(reader, reader.uint32(), options, message.customerContact);
                    break;
                case /* map<string, rd.product.Inventories> inventories_by_product_id */ 10:
                    this.binaryReadMap10(message.inventoriesByProductId, reader, options);
                    break;
                case /* repeated rd.txn.SaleProduct sale_products */ 13:
                    message.saleProducts.push(SaleProduct.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* map<string, rd.catalog.Product> catalog_products_by_id */ 14:
                    this.binaryReadMap14(message.catalogProductsById, reader, options);
                    break;
                case /* rd.proto.money.Money deposit_total */ 17:
                    message.depositTotal = Money.internalBinaryRead(reader, reader.uint32(), options, message.depositTotal);
                    break;
                case /* map<string, rd.txn.Sale> returned_from_sales_by_id */ 21:
                    this.binaryReadMap21(message.returnedFromSalesById, reader, options);
                    break;
                case /* rd.proto.money.Money amount_paid_by_customer */ 22:
                    message.amountPaidByCustomer = Money.internalBinaryRead(reader, reader.uint32(), options, message.amountPaidByCustomer);
                    break;
                case /* map<string, rd.api.sale.GetSaleRes.ReturnedInSales> returned_in_sales_by_sale_product_id */ 23:
                    this.binaryReadMap23(message.returnedInSalesBySaleProductId, reader, options);
                    break;
                case /* rd.txn.Sale.Totals aggregated_totals */ 25:
                    message.aggregatedTotals = Sale_Totals.internalBinaryRead(reader, reader.uint32(), options, message.aggregatedTotals);
                    break;
                case /* repeated rd.txn.TotalsLineItem totals_line_items */ 26:
                    message.totalsLineItems.push(TotalsLineItem.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* map<string, rd.proto.decimal.Decimal> quantity_remaining_by_sale_product_id_v2 */ 27:
                    this.binaryReadMap27(message.quantityRemainingBySaleProductIdV2, reader, options);
                    break;
                case /* rd.txn.CreditHistoryLink credit_history_link */ 28:
                    message.creditHistoryLink = CreditHistoryLink.internalBinaryRead(reader, reader.uint32(), options, message.creditHistoryLink);
                    break;
                case /* repeated rd.txn.CreditHistoryLink credit_allocation_links */ 29:
                    message.creditAllocationLinks.push(CreditHistoryLink.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.ledger.LedgerMethods ledger_methods */ 30:
                    message.ledgerMethods = LedgerMethods.internalBinaryRead(reader, reader.uint32(), options, message.ledgerMethods);
                    break;
                case /* rd.company.Location fulfillment_location */ 31:
                    message.fulfillmentLocation = Location.internalBinaryRead(reader, reader.uint32(), options, message.fulfillmentLocation);
                    break;
                case /* map<string, rd.price.TierPrices> tier_prices_by_product_id */ 33:
                    this.binaryReadMap33(message.tierPricesByProductId, reader, options);
                    break;
                case /* repeated rd.api.sale.GetSaleRes.LinkedSpecialOrderSale linked_special_order_sales */ 35:
                    message.linkedSpecialOrderSales.push(GetSaleRes_LinkedSpecialOrderSale.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* map<string, rd.api.sale.GetSaleRes.LinkedOrders> linked_orders_list_by_sale_product_id */ 38:
                    this.binaryReadMap38(message.linkedOrdersListBySaleProductId, reader, options);
                    break;
                case /* map<string, rd.api.sale.GetSaleRes.LinkedShipments> linked_shipments_by_sale_product_id */ 39:
                    this.binaryReadMap39(message.linkedShipmentsBySaleProductId, reader, options);
                    break;
                case /* map<string, rd.proto.decimal.Decimal> closed_out_quantities_by_sale_product_id */ 40:
                    this.binaryReadMap40(message.closedOutQuantitiesBySaleProductId, reader, options);
                    break;
                case /* rd.proto.money.Money unredeemed_deposit_total */ 41:
                    message.unredeemedDepositTotal = Money.internalBinaryRead(reader, reader.uint32(), options, message.unredeemedDepositTotal);
                    break;
                case /* rd.proto.money.Money unredeemed_deposit_principal_total */ 53:
                    message.unredeemedDepositPrincipalTotal = Money.internalBinaryRead(reader, reader.uint32(), options, message.unredeemedDepositPrincipalTotal);
                    break;
                case /* map<string, rd.api.sale.GetSaleRes.LinkedChildSales> child_sales_by_sale_product_id */ 42:
                    this.binaryReadMap42(message.childSalesBySaleProductId, reader, options);
                    break;
                case /* rd.proto.money.Money applied_deposit_redemption_total */ 43:
                    message.appliedDepositRedemptionTotal = Money.internalBinaryRead(reader, reader.uint32(), options, message.appliedDepositRedemptionTotal);
                    break;
                case /* repeated rd.api.sale.GetSaleRes.DepositEvent deposit_history */ 44:
                    message.depositHistory.push(GetSaleRes_DepositEvent.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.api.sale.GetSaleRes.LinkedSpecialOrderSale parent_sale */ 45:
                    message.parentSale = GetSaleRes_LinkedSpecialOrderSale.internalBinaryRead(reader, reader.uint32(), options, message.parentSale);
                    break;
                case /* rd.proto.money.Money overall_total */ 46:
                    message.overallTotal = Money.internalBinaryRead(reader, reader.uint32(), options, message.overallTotal);
                    break;
                case /* rd.proto.money.Money closed_out_total */ 47:
                    message.closedOutTotal = Money.internalBinaryRead(reader, reader.uint32(), options, message.closedOutTotal);
                    break;
                case /* repeated rd.txn.TotalsLineItem close_out_children_breakdown_line_items */ 48:
                    message.closeOutChildrenBreakdownLineItems.push(TotalsLineItem.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.txn.TotalsLineItem overall_totals_line_items */ 49:
                    message.overallTotalsLineItems.push(TotalsLineItem.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* google.protobuf.Timestamp due_date */ 50:
                    message.dueDate = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.dueDate);
                    break;
                case /* google.protobuf.Timestamp potential_discount_expires_at */ 51:
                    message.potentialDiscountExpiresAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.potentialDiscountExpiresAt);
                    break;
                case /* rd.txn.SaleTaxes sale_taxes */ 52:
                    message.saleTaxes = SaleTaxes.internalBinaryRead(reader, reader.uint32(), options, message.saleTaxes);
                    break;
                case /* repeated rd.txn.DeliveryStop delivery_stops */ 54:
                    message.deliveryStops.push(DeliveryStop.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.txn.AppliedCoupon coupons */ 55:
                    message.coupons.push(AppliedCoupon.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap5(map: GetSaleRes["productsById"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof GetSaleRes["productsById"] | undefined, val: GetSaleRes["productsById"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Product.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.api.sale.GetSaleRes.products_by_id");
            }
        }
        map[key ?? ""] = val ?? Product.create();
    }
    private binaryReadMap6(map: GetSaleRes["tintColorsById"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof GetSaleRes["tintColorsById"] | undefined, val: GetSaleRes["tintColorsById"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = TintColor.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.api.sale.GetSaleRes.tint_colors_by_id");
            }
        }
        map[key ?? ""] = val ?? TintColor.create();
    }
    private binaryReadMap10(map: GetSaleRes["inventoriesByProductId"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof GetSaleRes["inventoriesByProductId"] | undefined, val: GetSaleRes["inventoriesByProductId"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Inventories.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.api.sale.GetSaleRes.inventories_by_product_id");
            }
        }
        map[key ?? ""] = val ?? Inventories.create();
    }
    private binaryReadMap14(map: GetSaleRes["catalogProductsById"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof GetSaleRes["catalogProductsById"] | undefined, val: GetSaleRes["catalogProductsById"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Product$.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.api.sale.GetSaleRes.catalog_products_by_id");
            }
        }
        map[key ?? ""] = val ?? Product$.create();
    }
    private binaryReadMap21(map: GetSaleRes["returnedFromSalesById"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof GetSaleRes["returnedFromSalesById"] | undefined, val: GetSaleRes["returnedFromSalesById"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Sale.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.api.sale.GetSaleRes.returned_from_sales_by_id");
            }
        }
        map[key ?? ""] = val ?? Sale.create();
    }
    private binaryReadMap23(map: GetSaleRes["returnedInSalesBySaleProductId"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof GetSaleRes["returnedInSalesBySaleProductId"] | undefined, val: GetSaleRes["returnedInSalesBySaleProductId"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = GetSaleRes_ReturnedInSales.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.api.sale.GetSaleRes.returned_in_sales_by_sale_product_id");
            }
        }
        map[key ?? ""] = val ?? GetSaleRes_ReturnedInSales.create();
    }
    private binaryReadMap27(map: GetSaleRes["quantityRemainingBySaleProductIdV2"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof GetSaleRes["quantityRemainingBySaleProductIdV2"] | undefined, val: GetSaleRes["quantityRemainingBySaleProductIdV2"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Decimal.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.api.sale.GetSaleRes.quantity_remaining_by_sale_product_id_v2");
            }
        }
        map[key ?? ""] = val ?? Decimal.create();
    }
    private binaryReadMap33(map: GetSaleRes["tierPricesByProductId"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof GetSaleRes["tierPricesByProductId"] | undefined, val: GetSaleRes["tierPricesByProductId"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = TierPrices.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.api.sale.GetSaleRes.tier_prices_by_product_id");
            }
        }
        map[key ?? ""] = val ?? TierPrices.create();
    }
    private binaryReadMap38(map: GetSaleRes["linkedOrdersListBySaleProductId"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof GetSaleRes["linkedOrdersListBySaleProductId"] | undefined, val: GetSaleRes["linkedOrdersListBySaleProductId"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = GetSaleRes_LinkedOrders.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.api.sale.GetSaleRes.linked_orders_list_by_sale_product_id");
            }
        }
        map[key ?? ""] = val ?? GetSaleRes_LinkedOrders.create();
    }
    private binaryReadMap39(map: GetSaleRes["linkedShipmentsBySaleProductId"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof GetSaleRes["linkedShipmentsBySaleProductId"] | undefined, val: GetSaleRes["linkedShipmentsBySaleProductId"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = GetSaleRes_LinkedShipments.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.api.sale.GetSaleRes.linked_shipments_by_sale_product_id");
            }
        }
        map[key ?? ""] = val ?? GetSaleRes_LinkedShipments.create();
    }
    private binaryReadMap40(map: GetSaleRes["closedOutQuantitiesBySaleProductId"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof GetSaleRes["closedOutQuantitiesBySaleProductId"] | undefined, val: GetSaleRes["closedOutQuantitiesBySaleProductId"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Decimal.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.api.sale.GetSaleRes.closed_out_quantities_by_sale_product_id");
            }
        }
        map[key ?? ""] = val ?? Decimal.create();
    }
    private binaryReadMap42(map: GetSaleRes["childSalesBySaleProductId"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof GetSaleRes["childSalesBySaleProductId"] | undefined, val: GetSaleRes["childSalesBySaleProductId"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = GetSaleRes_LinkedChildSales.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.api.sale.GetSaleRes.child_sales_by_sale_product_id");
            }
        }
        map[key ?? ""] = val ?? GetSaleRes_LinkedChildSales.create();
    }
    internalBinaryWrite(message: GetSaleRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.txn.Sale sale = 1; */
        if (message.sale)
            Sale.internalBinaryWrite(message.sale, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.company.Location location = 2; */
        if (message.location)
            Location.internalBinaryWrite(message.location, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.customer.PurchaseOrder customer_purchase_order = 3; */
        if (message.customerPurchaseOrder)
            PurchaseOrder.internalBinaryWrite(message.customerPurchaseOrder, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* map<string, rd.product.Product> products_by_id = 5; */
        for (let k of globalThis.Object.keys(message.productsById)) {
            writer.tag(5, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Product.internalBinaryWrite(message.productsById[k], writer, options);
            writer.join().join();
        }
        /* map<string, rd.tintcolor.TintColor> tint_colors_by_id = 6; */
        for (let k of globalThis.Object.keys(message.tintColorsById)) {
            writer.tag(6, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            TintColor.internalBinaryWrite(message.tintColorsById[k], writer, options);
            writer.join().join();
        }
        /* rd.customer.Contacts.Contact customer_contact = 9; */
        if (message.customerContact)
            Contacts_Contact.internalBinaryWrite(message.customerContact, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* map<string, rd.product.Inventories> inventories_by_product_id = 10; */
        for (let k of globalThis.Object.keys(message.inventoriesByProductId)) {
            writer.tag(10, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Inventories.internalBinaryWrite(message.inventoriesByProductId[k], writer, options);
            writer.join().join();
        }
        /* repeated rd.txn.SaleProduct sale_products = 13; */
        for (let i = 0; i < message.saleProducts.length; i++)
            SaleProduct.internalBinaryWrite(message.saleProducts[i], writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* map<string, rd.catalog.Product> catalog_products_by_id = 14; */
        for (let k of globalThis.Object.keys(message.catalogProductsById)) {
            writer.tag(14, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Product$.internalBinaryWrite(message.catalogProductsById[k], writer, options);
            writer.join().join();
        }
        /* rd.proto.money.Money deposit_total = 17; */
        if (message.depositTotal)
            Money.internalBinaryWrite(message.depositTotal, writer.tag(17, WireType.LengthDelimited).fork(), options).join();
        /* map<string, rd.txn.Sale> returned_from_sales_by_id = 21; */
        for (let k of globalThis.Object.keys(message.returnedFromSalesById)) {
            writer.tag(21, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Sale.internalBinaryWrite(message.returnedFromSalesById[k], writer, options);
            writer.join().join();
        }
        /* rd.proto.money.Money amount_paid_by_customer = 22; */
        if (message.amountPaidByCustomer)
            Money.internalBinaryWrite(message.amountPaidByCustomer, writer.tag(22, WireType.LengthDelimited).fork(), options).join();
        /* map<string, rd.api.sale.GetSaleRes.ReturnedInSales> returned_in_sales_by_sale_product_id = 23; */
        for (let k of globalThis.Object.keys(message.returnedInSalesBySaleProductId)) {
            writer.tag(23, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            GetSaleRes_ReturnedInSales.internalBinaryWrite(message.returnedInSalesBySaleProductId[k], writer, options);
            writer.join().join();
        }
        /* rd.txn.Sale.Totals aggregated_totals = 25; */
        if (message.aggregatedTotals)
            Sale_Totals.internalBinaryWrite(message.aggregatedTotals, writer.tag(25, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.txn.TotalsLineItem totals_line_items = 26; */
        for (let i = 0; i < message.totalsLineItems.length; i++)
            TotalsLineItem.internalBinaryWrite(message.totalsLineItems[i], writer.tag(26, WireType.LengthDelimited).fork(), options).join();
        /* map<string, rd.proto.decimal.Decimal> quantity_remaining_by_sale_product_id_v2 = 27; */
        for (let k of globalThis.Object.keys(message.quantityRemainingBySaleProductIdV2)) {
            writer.tag(27, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Decimal.internalBinaryWrite(message.quantityRemainingBySaleProductIdV2[k], writer, options);
            writer.join().join();
        }
        /* rd.txn.CreditHistoryLink credit_history_link = 28; */
        if (message.creditHistoryLink)
            CreditHistoryLink.internalBinaryWrite(message.creditHistoryLink, writer.tag(28, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.txn.CreditHistoryLink credit_allocation_links = 29; */
        for (let i = 0; i < message.creditAllocationLinks.length; i++)
            CreditHistoryLink.internalBinaryWrite(message.creditAllocationLinks[i], writer.tag(29, WireType.LengthDelimited).fork(), options).join();
        /* rd.ledger.LedgerMethods ledger_methods = 30; */
        if (message.ledgerMethods)
            LedgerMethods.internalBinaryWrite(message.ledgerMethods, writer.tag(30, WireType.LengthDelimited).fork(), options).join();
        /* rd.company.Location fulfillment_location = 31; */
        if (message.fulfillmentLocation)
            Location.internalBinaryWrite(message.fulfillmentLocation, writer.tag(31, WireType.LengthDelimited).fork(), options).join();
        /* map<string, rd.price.TierPrices> tier_prices_by_product_id = 33; */
        for (let k of globalThis.Object.keys(message.tierPricesByProductId)) {
            writer.tag(33, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            TierPrices.internalBinaryWrite(message.tierPricesByProductId[k], writer, options);
            writer.join().join();
        }
        /* repeated rd.api.sale.GetSaleRes.LinkedSpecialOrderSale linked_special_order_sales = 35; */
        for (let i = 0; i < message.linkedSpecialOrderSales.length; i++)
            GetSaleRes_LinkedSpecialOrderSale.internalBinaryWrite(message.linkedSpecialOrderSales[i], writer.tag(35, WireType.LengthDelimited).fork(), options).join();
        /* map<string, rd.api.sale.GetSaleRes.LinkedOrders> linked_orders_list_by_sale_product_id = 38; */
        for (let k of globalThis.Object.keys(message.linkedOrdersListBySaleProductId)) {
            writer.tag(38, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            GetSaleRes_LinkedOrders.internalBinaryWrite(message.linkedOrdersListBySaleProductId[k], writer, options);
            writer.join().join();
        }
        /* map<string, rd.api.sale.GetSaleRes.LinkedShipments> linked_shipments_by_sale_product_id = 39; */
        for (let k of globalThis.Object.keys(message.linkedShipmentsBySaleProductId)) {
            writer.tag(39, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            GetSaleRes_LinkedShipments.internalBinaryWrite(message.linkedShipmentsBySaleProductId[k], writer, options);
            writer.join().join();
        }
        /* map<string, rd.proto.decimal.Decimal> closed_out_quantities_by_sale_product_id = 40; */
        for (let k of globalThis.Object.keys(message.closedOutQuantitiesBySaleProductId)) {
            writer.tag(40, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Decimal.internalBinaryWrite(message.closedOutQuantitiesBySaleProductId[k], writer, options);
            writer.join().join();
        }
        /* rd.proto.money.Money unredeemed_deposit_total = 41; */
        if (message.unredeemedDepositTotal)
            Money.internalBinaryWrite(message.unredeemedDepositTotal, writer.tag(41, WireType.LengthDelimited).fork(), options).join();
        /* map<string, rd.api.sale.GetSaleRes.LinkedChildSales> child_sales_by_sale_product_id = 42; */
        for (let k of globalThis.Object.keys(message.childSalesBySaleProductId)) {
            writer.tag(42, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            GetSaleRes_LinkedChildSales.internalBinaryWrite(message.childSalesBySaleProductId[k], writer, options);
            writer.join().join();
        }
        /* rd.proto.money.Money applied_deposit_redemption_total = 43; */
        if (message.appliedDepositRedemptionTotal)
            Money.internalBinaryWrite(message.appliedDepositRedemptionTotal, writer.tag(43, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.api.sale.GetSaleRes.DepositEvent deposit_history = 44; */
        for (let i = 0; i < message.depositHistory.length; i++)
            GetSaleRes_DepositEvent.internalBinaryWrite(message.depositHistory[i], writer.tag(44, WireType.LengthDelimited).fork(), options).join();
        /* rd.api.sale.GetSaleRes.LinkedSpecialOrderSale parent_sale = 45; */
        if (message.parentSale)
            GetSaleRes_LinkedSpecialOrderSale.internalBinaryWrite(message.parentSale, writer.tag(45, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money overall_total = 46; */
        if (message.overallTotal)
            Money.internalBinaryWrite(message.overallTotal, writer.tag(46, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money closed_out_total = 47; */
        if (message.closedOutTotal)
            Money.internalBinaryWrite(message.closedOutTotal, writer.tag(47, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.txn.TotalsLineItem close_out_children_breakdown_line_items = 48; */
        for (let i = 0; i < message.closeOutChildrenBreakdownLineItems.length; i++)
            TotalsLineItem.internalBinaryWrite(message.closeOutChildrenBreakdownLineItems[i], writer.tag(48, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.txn.TotalsLineItem overall_totals_line_items = 49; */
        for (let i = 0; i < message.overallTotalsLineItems.length; i++)
            TotalsLineItem.internalBinaryWrite(message.overallTotalsLineItems[i], writer.tag(49, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp due_date = 50; */
        if (message.dueDate)
            Timestamp.internalBinaryWrite(message.dueDate, writer.tag(50, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp potential_discount_expires_at = 51; */
        if (message.potentialDiscountExpiresAt)
            Timestamp.internalBinaryWrite(message.potentialDiscountExpiresAt, writer.tag(51, WireType.LengthDelimited).fork(), options).join();
        /* rd.txn.SaleTaxes sale_taxes = 52; */
        if (message.saleTaxes)
            SaleTaxes.internalBinaryWrite(message.saleTaxes, writer.tag(52, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money unredeemed_deposit_principal_total = 53; */
        if (message.unredeemedDepositPrincipalTotal)
            Money.internalBinaryWrite(message.unredeemedDepositPrincipalTotal, writer.tag(53, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.txn.DeliveryStop delivery_stops = 54; */
        for (let i = 0; i < message.deliveryStops.length; i++)
            DeliveryStop.internalBinaryWrite(message.deliveryStops[i], writer.tag(54, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.txn.AppliedCoupon coupons = 55; */
        for (let i = 0; i < message.coupons.length; i++)
            AppliedCoupon.internalBinaryWrite(message.coupons[i], writer.tag(55, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.GetSaleRes
 */
export const GetSaleRes = new GetSaleRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSaleRes_ReturnedInSales$Type extends MessageType<GetSaleRes_ReturnedInSales> {
    constructor() {
        super("rd.api.sale.GetSaleRes.ReturnedInSales", [
            { no: 1, name: "sales", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Sale }
        ]);
    }
    create(value?: PartialMessage<GetSaleRes_ReturnedInSales>): GetSaleRes_ReturnedInSales {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.sales = [];
        if (value !== undefined)
            reflectionMergePartial<GetSaleRes_ReturnedInSales>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetSaleRes_ReturnedInSales): GetSaleRes_ReturnedInSales {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.txn.Sale sales */ 1:
                    message.sales.push(Sale.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetSaleRes_ReturnedInSales, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.txn.Sale sales = 1; */
        for (let i = 0; i < message.sales.length; i++)
            Sale.internalBinaryWrite(message.sales[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.GetSaleRes.ReturnedInSales
 */
export const GetSaleRes_ReturnedInSales = new GetSaleRes_ReturnedInSales$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSaleRes_LinkedSpecialOrderSale$Type extends MessageType<GetSaleRes_LinkedSpecialOrderSale> {
    constructor() {
        super("rd.api.sale.GetSaleRes.LinkedSpecialOrderSale", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "identifier", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "status", kind: "enum", T: () => ["rd.txn.Sale.Status", Sale_Status, "STATUS_"] }
        ]);
    }
    create(value?: PartialMessage<GetSaleRes_LinkedSpecialOrderSale>): GetSaleRes_LinkedSpecialOrderSale {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.identifier = "";
        message.status = 0;
        if (value !== undefined)
            reflectionMergePartial<GetSaleRes_LinkedSpecialOrderSale>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetSaleRes_LinkedSpecialOrderSale): GetSaleRes_LinkedSpecialOrderSale {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* string identifier */ 2:
                    message.identifier = reader.string();
                    break;
                case /* rd.txn.Sale.Status status */ 3:
                    message.status = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetSaleRes_LinkedSpecialOrderSale, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string identifier = 2; */
        if (message.identifier !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.identifier);
        /* rd.txn.Sale.Status status = 3; */
        if (message.status !== 0)
            writer.tag(3, WireType.Varint).int32(message.status);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.GetSaleRes.LinkedSpecialOrderSale
 */
export const GetSaleRes_LinkedSpecialOrderSale = new GetSaleRes_LinkedSpecialOrderSale$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSaleRes_LinkedOrder$Type extends MessageType<GetSaleRes_LinkedOrder> {
    constructor() {
        super("rd.api.sale.GetSaleRes.LinkedOrder", [
            { no: 1, name: "order_id", kind: "message", T: () => UUID },
            { no: 2, name: "order_identifier", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "order_status", kind: "enum", T: () => ["rd.txn.Order.Status", Order_Status, "STATUS_"] },
            { no: 4, name: "quantity", kind: "message", T: () => Decimal },
            { no: 5, name: "quantity_received", kind: "message", T: () => Decimal }
        ]);
    }
    create(value?: PartialMessage<GetSaleRes_LinkedOrder>): GetSaleRes_LinkedOrder {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.orderIdentifier = "";
        message.orderStatus = 0;
        if (value !== undefined)
            reflectionMergePartial<GetSaleRes_LinkedOrder>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetSaleRes_LinkedOrder): GetSaleRes_LinkedOrder {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID order_id */ 1:
                    message.orderId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.orderId);
                    break;
                case /* string order_identifier */ 2:
                    message.orderIdentifier = reader.string();
                    break;
                case /* rd.txn.Order.Status order_status */ 3:
                    message.orderStatus = reader.int32();
                    break;
                case /* rd.proto.decimal.Decimal quantity */ 4:
                    message.quantity = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.quantity);
                    break;
                case /* rd.proto.decimal.Decimal quantity_received */ 5:
                    message.quantityReceived = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.quantityReceived);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetSaleRes_LinkedOrder, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID order_id = 1; */
        if (message.orderId)
            UUID.internalBinaryWrite(message.orderId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string order_identifier = 2; */
        if (message.orderIdentifier !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.orderIdentifier);
        /* rd.txn.Order.Status order_status = 3; */
        if (message.orderStatus !== 0)
            writer.tag(3, WireType.Varint).int32(message.orderStatus);
        /* rd.proto.decimal.Decimal quantity = 4; */
        if (message.quantity)
            Decimal.internalBinaryWrite(message.quantity, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal quantity_received = 5; */
        if (message.quantityReceived)
            Decimal.internalBinaryWrite(message.quantityReceived, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.GetSaleRes.LinkedOrder
 */
export const GetSaleRes_LinkedOrder = new GetSaleRes_LinkedOrder$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSaleRes_LinkedOrders$Type extends MessageType<GetSaleRes_LinkedOrders> {
    constructor() {
        super("rd.api.sale.GetSaleRes.LinkedOrders", [
            { no: 1, name: "orders", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => GetSaleRes_LinkedOrder }
        ]);
    }
    create(value?: PartialMessage<GetSaleRes_LinkedOrders>): GetSaleRes_LinkedOrders {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.orders = [];
        if (value !== undefined)
            reflectionMergePartial<GetSaleRes_LinkedOrders>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetSaleRes_LinkedOrders): GetSaleRes_LinkedOrders {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.api.sale.GetSaleRes.LinkedOrder orders */ 1:
                    message.orders.push(GetSaleRes_LinkedOrder.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetSaleRes_LinkedOrders, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.api.sale.GetSaleRes.LinkedOrder orders = 1; */
        for (let i = 0; i < message.orders.length; i++)
            GetSaleRes_LinkedOrder.internalBinaryWrite(message.orders[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.GetSaleRes.LinkedOrders
 */
export const GetSaleRes_LinkedOrders = new GetSaleRes_LinkedOrders$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSaleRes_LinkedShipment$Type extends MessageType<GetSaleRes_LinkedShipment> {
    constructor() {
        super("rd.api.sale.GetSaleRes.LinkedShipment", [
            { no: 1, name: "shipment_id", kind: "message", T: () => UUID },
            { no: 2, name: "shipment_identifier", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "shipment_status", kind: "enum", T: () => ["rd.txn.OrderShipment.Status", OrderShipment_Status, "STATUS_"] },
            { no: 4, name: "quantity", kind: "message", T: () => Decimal }
        ]);
    }
    create(value?: PartialMessage<GetSaleRes_LinkedShipment>): GetSaleRes_LinkedShipment {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.shipmentIdentifier = "";
        message.shipmentStatus = 0;
        if (value !== undefined)
            reflectionMergePartial<GetSaleRes_LinkedShipment>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetSaleRes_LinkedShipment): GetSaleRes_LinkedShipment {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID shipment_id */ 1:
                    message.shipmentId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.shipmentId);
                    break;
                case /* string shipment_identifier */ 2:
                    message.shipmentIdentifier = reader.string();
                    break;
                case /* rd.txn.OrderShipment.Status shipment_status */ 3:
                    message.shipmentStatus = reader.int32();
                    break;
                case /* rd.proto.decimal.Decimal quantity */ 4:
                    message.quantity = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.quantity);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetSaleRes_LinkedShipment, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID shipment_id = 1; */
        if (message.shipmentId)
            UUID.internalBinaryWrite(message.shipmentId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string shipment_identifier = 2; */
        if (message.shipmentIdentifier !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.shipmentIdentifier);
        /* rd.txn.OrderShipment.Status shipment_status = 3; */
        if (message.shipmentStatus !== 0)
            writer.tag(3, WireType.Varint).int32(message.shipmentStatus);
        /* rd.proto.decimal.Decimal quantity = 4; */
        if (message.quantity)
            Decimal.internalBinaryWrite(message.quantity, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.GetSaleRes.LinkedShipment
 */
export const GetSaleRes_LinkedShipment = new GetSaleRes_LinkedShipment$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSaleRes_LinkedShipments$Type extends MessageType<GetSaleRes_LinkedShipments> {
    constructor() {
        super("rd.api.sale.GetSaleRes.LinkedShipments", [
            { no: 1, name: "shipments", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => GetSaleRes_LinkedShipment }
        ]);
    }
    create(value?: PartialMessage<GetSaleRes_LinkedShipments>): GetSaleRes_LinkedShipments {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.shipments = [];
        if (value !== undefined)
            reflectionMergePartial<GetSaleRes_LinkedShipments>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetSaleRes_LinkedShipments): GetSaleRes_LinkedShipments {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.api.sale.GetSaleRes.LinkedShipment shipments */ 1:
                    message.shipments.push(GetSaleRes_LinkedShipment.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetSaleRes_LinkedShipments, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.api.sale.GetSaleRes.LinkedShipment shipments = 1; */
        for (let i = 0; i < message.shipments.length; i++)
            GetSaleRes_LinkedShipment.internalBinaryWrite(message.shipments[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.GetSaleRes.LinkedShipments
 */
export const GetSaleRes_LinkedShipments = new GetSaleRes_LinkedShipments$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSaleRes_LinkedChildSales$Type extends MessageType<GetSaleRes_LinkedChildSales> {
    constructor() {
        super("rd.api.sale.GetSaleRes.LinkedChildSales", [
            { no: 1, name: "sales", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Sale }
        ]);
    }
    create(value?: PartialMessage<GetSaleRes_LinkedChildSales>): GetSaleRes_LinkedChildSales {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.sales = [];
        if (value !== undefined)
            reflectionMergePartial<GetSaleRes_LinkedChildSales>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetSaleRes_LinkedChildSales): GetSaleRes_LinkedChildSales {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.txn.Sale sales */ 1:
                    message.sales.push(Sale.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetSaleRes_LinkedChildSales, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.txn.Sale sales = 1; */
        for (let i = 0; i < message.sales.length; i++)
            Sale.internalBinaryWrite(message.sales[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.GetSaleRes.LinkedChildSales
 */
export const GetSaleRes_LinkedChildSales = new GetSaleRes_LinkedChildSales$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSaleRes_DepositEvent$Type extends MessageType<GetSaleRes_DepositEvent> {
    constructor() {
        super("rd.api.sale.GetSaleRes.DepositEvent", [
            { no: 1, name: "type", kind: "enum", T: () => ["rd.api.sale.GetSaleRes.DepositEvent.Type", GetSaleRes_DepositEvent_Type] },
            { no: 2, name: "amount", kind: "message", T: () => Money },
            { no: 3, name: "accounted_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "tender_method", kind: "message", T: () => LedgerMethods_Method },
            { no: 5, name: "redeemed_against_sale", kind: "message", T: () => GetSaleRes_DepositEvent_RedeemedAgainstSale }
        ]);
    }
    create(value?: PartialMessage<GetSaleRes_DepositEvent>): GetSaleRes_DepositEvent {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.type = 0;
        if (value !== undefined)
            reflectionMergePartial<GetSaleRes_DepositEvent>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetSaleRes_DepositEvent): GetSaleRes_DepositEvent {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.api.sale.GetSaleRes.DepositEvent.Type type */ 1:
                    message.type = reader.int32();
                    break;
                case /* rd.proto.money.Money amount */ 2:
                    message.amount = Money.internalBinaryRead(reader, reader.uint32(), options, message.amount);
                    break;
                case /* google.protobuf.Timestamp accounted_at */ 3:
                    message.accountedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.accountedAt);
                    break;
                case /* rd.ledger.LedgerMethods.Method tender_method */ 4:
                    message.tenderMethod = LedgerMethods_Method.internalBinaryRead(reader, reader.uint32(), options, message.tenderMethod);
                    break;
                case /* rd.api.sale.GetSaleRes.DepositEvent.RedeemedAgainstSale redeemed_against_sale */ 5:
                    message.redeemedAgainstSale = GetSaleRes_DepositEvent_RedeemedAgainstSale.internalBinaryRead(reader, reader.uint32(), options, message.redeemedAgainstSale);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetSaleRes_DepositEvent, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.api.sale.GetSaleRes.DepositEvent.Type type = 1; */
        if (message.type !== 0)
            writer.tag(1, WireType.Varint).int32(message.type);
        /* rd.proto.money.Money amount = 2; */
        if (message.amount)
            Money.internalBinaryWrite(message.amount, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp accounted_at = 3; */
        if (message.accountedAt)
            Timestamp.internalBinaryWrite(message.accountedAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.ledger.LedgerMethods.Method tender_method = 4; */
        if (message.tenderMethod)
            LedgerMethods_Method.internalBinaryWrite(message.tenderMethod, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.api.sale.GetSaleRes.DepositEvent.RedeemedAgainstSale redeemed_against_sale = 5; */
        if (message.redeemedAgainstSale)
            GetSaleRes_DepositEvent_RedeemedAgainstSale.internalBinaryWrite(message.redeemedAgainstSale, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.GetSaleRes.DepositEvent
 */
export const GetSaleRes_DepositEvent = new GetSaleRes_DepositEvent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSaleRes_DepositEvent_RedeemedAgainstSale$Type extends MessageType<GetSaleRes_DepositEvent_RedeemedAgainstSale> {
    constructor() {
        super("rd.api.sale.GetSaleRes.DepositEvent.RedeemedAgainstSale", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "identifier", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetSaleRes_DepositEvent_RedeemedAgainstSale>): GetSaleRes_DepositEvent_RedeemedAgainstSale {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.identifier = "";
        if (value !== undefined)
            reflectionMergePartial<GetSaleRes_DepositEvent_RedeemedAgainstSale>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetSaleRes_DepositEvent_RedeemedAgainstSale): GetSaleRes_DepositEvent_RedeemedAgainstSale {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* string identifier */ 2:
                    message.identifier = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetSaleRes_DepositEvent_RedeemedAgainstSale, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string identifier = 2; */
        if (message.identifier !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.identifier);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.GetSaleRes.DepositEvent.RedeemedAgainstSale
 */
export const GetSaleRes_DepositEvent_RedeemedAgainstSale = new GetSaleRes_DepositEvent_RedeemedAgainstSale$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSaleCountsByStatusReq$Type extends MessageType<GetSaleCountsByStatusReq> {
    constructor() {
        super("rd.api.sale.GetSaleCountsByStatusReq", [
            { no: 1, name: "location_id", kind: "message", T: () => UUID },
            { no: 2, name: "customer_id", kind: "message", T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<GetSaleCountsByStatusReq>): GetSaleCountsByStatusReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetSaleCountsByStatusReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetSaleCountsByStatusReq): GetSaleCountsByStatusReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID location_id */ 1:
                    message.locationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.locationId);
                    break;
                case /* rd.proto.uuid.UUID customer_id */ 2:
                    message.customerId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.customerId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetSaleCountsByStatusReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID location_id = 1; */
        if (message.locationId)
            UUID.internalBinaryWrite(message.locationId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID customer_id = 2; */
        if (message.customerId)
            UUID.internalBinaryWrite(message.customerId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.GetSaleCountsByStatusReq
 */
export const GetSaleCountsByStatusReq = new GetSaleCountsByStatusReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSaleCountsByStatusRes$Type extends MessageType<GetSaleCountsByStatusRes> {
    constructor() {
        super("rd.api.sale.GetSaleCountsByStatusRes", [
            { no: 1, name: "sale_counts_by_status", kind: "map", K: 5 /*ScalarType.INT32*/, V: { kind: "message", T: () => SaleCountBySource } }
        ]);
    }
    create(value?: PartialMessage<GetSaleCountsByStatusRes>): GetSaleCountsByStatusRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.saleCountsByStatus = {};
        if (value !== undefined)
            reflectionMergePartial<GetSaleCountsByStatusRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetSaleCountsByStatusRes): GetSaleCountsByStatusRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* map<int32, rd.txn.SaleCountBySource> sale_counts_by_status */ 1:
                    this.binaryReadMap1(message.saleCountsByStatus, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap1(map: GetSaleCountsByStatusRes["saleCountsByStatus"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof GetSaleCountsByStatusRes["saleCountsByStatus"] | undefined, val: GetSaleCountsByStatusRes["saleCountsByStatus"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.int32();
                    break;
                case 2:
                    val = SaleCountBySource.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.api.sale.GetSaleCountsByStatusRes.sale_counts_by_status");
            }
        }
        map[key ?? 0] = val ?? SaleCountBySource.create();
    }
    internalBinaryWrite(message: GetSaleCountsByStatusRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* map<int32, rd.txn.SaleCountBySource> sale_counts_by_status = 1; */
        for (let k of globalThis.Object.keys(message.saleCountsByStatus)) {
            writer.tag(1, WireType.LengthDelimited).fork().tag(1, WireType.Varint).int32(parseInt(k));
            writer.tag(2, WireType.LengthDelimited).fork();
            SaleCountBySource.internalBinaryWrite(message.saleCountsByStatus[k as any], writer, options);
            writer.join().join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.GetSaleCountsByStatusRes
 */
export const GetSaleCountsByStatusRes = new GetSaleCountsByStatusRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetScannedSaleReq$Type extends MessageType<GetScannedSaleReq> {
    constructor() {
        super("rd.api.sale.GetScannedSaleReq", [
            { no: 1, name: "identifier", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<GetScannedSaleReq>): GetScannedSaleReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.identifier = "";
        if (value !== undefined)
            reflectionMergePartial<GetScannedSaleReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetScannedSaleReq): GetScannedSaleReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string identifier */ 1:
                    message.identifier = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetScannedSaleReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string identifier = 1; */
        if (message.identifier !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.identifier);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.GetScannedSaleReq
 */
export const GetScannedSaleReq = new GetScannedSaleReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetScannedSaleRes$Type extends MessageType<GetScannedSaleRes> {
    constructor() {
        super("rd.api.sale.GetScannedSaleRes", [
            { no: 1, name: "sale", kind: "message", T: () => Sale }
        ]);
    }
    create(value?: PartialMessage<GetScannedSaleRes>): GetScannedSaleRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetScannedSaleRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetScannedSaleRes): GetScannedSaleRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.txn.Sale sale */ 1:
                    message.sale = Sale.internalBinaryRead(reader, reader.uint32(), options, message.sale);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetScannedSaleRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.txn.Sale sale = 1; */
        if (message.sale)
            Sale.internalBinaryWrite(message.sale, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.GetScannedSaleRes
 */
export const GetScannedSaleRes = new GetScannedSaleRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateSoldSaleProductReq$Type extends MessageType<UpdateSoldSaleProductReq> {
    constructor() {
        super("rd.api.sale.UpdateSoldSaleProductReq", [
            { no: 1, name: "sale_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "product", kind: "message", T: () => UpdateSoldSaleProductReq_Product, options: { "rd.validator.require": true } },
            { no: 3, name: "sale_product_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<UpdateSoldSaleProductReq>): UpdateSoldSaleProductReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateSoldSaleProductReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateSoldSaleProductReq): UpdateSoldSaleProductReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID sale_id */ 1:
                    message.saleId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.saleId);
                    break;
                case /* rd.api.sale.UpdateSoldSaleProductReq.Product product */ 2:
                    message.product = UpdateSoldSaleProductReq_Product.internalBinaryRead(reader, reader.uint32(), options, message.product);
                    break;
                case /* rd.proto.uuid.UUID sale_product_id */ 3:
                    message.saleProductId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.saleProductId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateSoldSaleProductReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID sale_id = 1; */
        if (message.saleId)
            UUID.internalBinaryWrite(message.saleId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.api.sale.UpdateSoldSaleProductReq.Product product = 2; */
        if (message.product)
            UpdateSoldSaleProductReq_Product.internalBinaryWrite(message.product, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID sale_product_id = 3; */
        if (message.saleProductId)
            UUID.internalBinaryWrite(message.saleProductId, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.UpdateSoldSaleProductReq
 */
export const UpdateSoldSaleProductReq = new UpdateSoldSaleProductReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateSoldSaleProductReq_Product$Type extends MessageType<UpdateSoldSaleProductReq_Product> {
    constructor() {
        super("rd.api.sale.UpdateSoldSaleProductReq.Product", [
            { no: 2, name: "tint_color_id", kind: "message", T: () => UUID },
            { no: 3, name: "custom_tint_color", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "custom_fields", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SaleForm_CustomField },
            { no: 6, name: "internal_notes", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.sanitize.cxa": true } }
        ]);
    }
    create(value?: PartialMessage<UpdateSoldSaleProductReq_Product>): UpdateSoldSaleProductReq_Product {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.customTintColor = "";
        message.notes = "";
        message.customFields = [];
        message.internalNotes = "";
        if (value !== undefined)
            reflectionMergePartial<UpdateSoldSaleProductReq_Product>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateSoldSaleProductReq_Product): UpdateSoldSaleProductReq_Product {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID tint_color_id */ 2:
                    message.tintColorId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.tintColorId);
                    break;
                case /* string custom_tint_color */ 3:
                    message.customTintColor = reader.string();
                    break;
                case /* string notes */ 4:
                    message.notes = reader.string();
                    break;
                case /* repeated rd.company.SaleForm.CustomField custom_fields */ 5:
                    message.customFields.push(SaleForm_CustomField.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string internal_notes */ 6:
                    message.internalNotes = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateSoldSaleProductReq_Product, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID tint_color_id = 2; */
        if (message.tintColorId)
            UUID.internalBinaryWrite(message.tintColorId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string custom_tint_color = 3; */
        if (message.customTintColor !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.customTintColor);
        /* string notes = 4; */
        if (message.notes !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.notes);
        /* repeated rd.company.SaleForm.CustomField custom_fields = 5; */
        for (let i = 0; i < message.customFields.length; i++)
            SaleForm_CustomField.internalBinaryWrite(message.customFields[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* string internal_notes = 6; */
        if (message.internalNotes !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.internalNotes);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.UpdateSoldSaleProductReq.Product
 */
export const UpdateSoldSaleProductReq_Product = new UpdateSoldSaleProductReq_Product$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateSoldSaleProductRes$Type extends MessageType<UpdateSoldSaleProductRes> {
    constructor() {
        super("rd.api.sale.UpdateSoldSaleProductRes", []);
    }
    create(value?: PartialMessage<UpdateSoldSaleProductRes>): UpdateSoldSaleProductRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateSoldSaleProductRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateSoldSaleProductRes): UpdateSoldSaleProductRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateSoldSaleProductRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.UpdateSoldSaleProductRes
 */
export const UpdateSoldSaleProductRes = new UpdateSoldSaleProductRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateSoldSaleDetailsReq$Type extends MessageType<UpdateSoldSaleDetailsReq> {
    constructor() {
        super("rd.api.sale.UpdateSoldSaleDetailsReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "sale_notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "customer_contact_id_string", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "purchase_order_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "internal_notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "address", kind: "message", T: () => Address },
            { no: 9, name: "customer_contact_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateSoldSaleDetailsReq>): UpdateSoldSaleDetailsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.saleNotes = "";
        message.customerContactIdString = "";
        message.purchaseOrderName = "";
        message.internalNotes = "";
        message.customerContactName = "";
        if (value !== undefined)
            reflectionMergePartial<UpdateSoldSaleDetailsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateSoldSaleDetailsReq): UpdateSoldSaleDetailsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* string sale_notes */ 2:
                    message.saleNotes = reader.string();
                    break;
                case /* string customer_contact_id_string */ 4:
                    message.customerContactIdString = reader.string();
                    break;
                case /* string purchase_order_name */ 5:
                    message.purchaseOrderName = reader.string();
                    break;
                case /* string internal_notes */ 7:
                    message.internalNotes = reader.string();
                    break;
                case /* rd.proto.address.Address address */ 8:
                    message.address = Address.internalBinaryRead(reader, reader.uint32(), options, message.address);
                    break;
                case /* string customer_contact_name */ 9:
                    message.customerContactName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateSoldSaleDetailsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string sale_notes = 2; */
        if (message.saleNotes !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.saleNotes);
        /* string customer_contact_id_string = 4; */
        if (message.customerContactIdString !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.customerContactIdString);
        /* string purchase_order_name = 5; */
        if (message.purchaseOrderName !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.purchaseOrderName);
        /* string internal_notes = 7; */
        if (message.internalNotes !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.internalNotes);
        /* rd.proto.address.Address address = 8; */
        if (message.address)
            Address.internalBinaryWrite(message.address, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* string customer_contact_name = 9; */
        if (message.customerContactName !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.customerContactName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.UpdateSoldSaleDetailsReq
 */
export const UpdateSoldSaleDetailsReq = new UpdateSoldSaleDetailsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateSoldSaleDetailsRes$Type extends MessageType<UpdateSoldSaleDetailsRes> {
    constructor() {
        super("rd.api.sale.UpdateSoldSaleDetailsRes", []);
    }
    create(value?: PartialMessage<UpdateSoldSaleDetailsRes>): UpdateSoldSaleDetailsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateSoldSaleDetailsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateSoldSaleDetailsRes): UpdateSoldSaleDetailsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateSoldSaleDetailsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.UpdateSoldSaleDetailsRes
 */
export const UpdateSoldSaleDetailsRes = new UpdateSoldSaleDetailsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EmailSalePDFReq$Type extends MessageType<EmailSalePDFReq> {
    constructor() {
        super("rd.api.sale.EmailSalePDFReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "customer_contact_id_strings", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "additional_emails", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "is_return", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "show_prices", kind: "enum", T: () => ["rd.api.sale.ShowPricesOption", ShowPricesOption, "SHOW_PRICES_OPTION_"] },
            { no: 6, name: "show_linked_products", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "show_account_balance", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<EmailSalePDFReq>): EmailSalePDFReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.customerContactIdStrings = [];
        message.additionalEmails = [];
        message.isReturn = false;
        message.showPrices = 0;
        message.showLinkedProducts = false;
        message.showAccountBalance = false;
        if (value !== undefined)
            reflectionMergePartial<EmailSalePDFReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EmailSalePDFReq): EmailSalePDFReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* repeated string customer_contact_id_strings */ 2:
                    message.customerContactIdStrings.push(reader.string());
                    break;
                case /* repeated string additional_emails */ 3:
                    message.additionalEmails.push(reader.string());
                    break;
                case /* bool is_return */ 4:
                    message.isReturn = reader.bool();
                    break;
                case /* rd.api.sale.ShowPricesOption show_prices */ 5:
                    message.showPrices = reader.int32();
                    break;
                case /* bool show_linked_products */ 6:
                    message.showLinkedProducts = reader.bool();
                    break;
                case /* bool show_account_balance */ 7:
                    message.showAccountBalance = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EmailSalePDFReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated string customer_contact_id_strings = 2; */
        for (let i = 0; i < message.customerContactIdStrings.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.customerContactIdStrings[i]);
        /* repeated string additional_emails = 3; */
        for (let i = 0; i < message.additionalEmails.length; i++)
            writer.tag(3, WireType.LengthDelimited).string(message.additionalEmails[i]);
        /* bool is_return = 4; */
        if (message.isReturn !== false)
            writer.tag(4, WireType.Varint).bool(message.isReturn);
        /* rd.api.sale.ShowPricesOption show_prices = 5; */
        if (message.showPrices !== 0)
            writer.tag(5, WireType.Varint).int32(message.showPrices);
        /* bool show_linked_products = 6; */
        if (message.showLinkedProducts !== false)
            writer.tag(6, WireType.Varint).bool(message.showLinkedProducts);
        /* bool show_account_balance = 7; */
        if (message.showAccountBalance !== false)
            writer.tag(7, WireType.Varint).bool(message.showAccountBalance);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.EmailSalePDFReq
 */
export const EmailSalePDFReq = new EmailSalePDFReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EmailSalePDFRes$Type extends MessageType<EmailSalePDFRes> {
    constructor() {
        super("rd.api.sale.EmailSalePDFRes", []);
    }
    create(value?: PartialMessage<EmailSalePDFRes>): EmailSalePDFRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<EmailSalePDFRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EmailSalePDFRes): EmailSalePDFRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EmailSalePDFRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.EmailSalePDFRes
 */
export const EmailSalePDFRes = new EmailSalePDFRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSalePDFReq$Type extends MessageType<GetSalePDFReq> {
    constructor() {
        super("rd.api.sale.GetSalePDFReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "show_prices", kind: "enum", T: () => ["rd.api.sale.ShowPricesOption", ShowPricesOption, "SHOW_PRICES_OPTION_"] },
            { no: 3, name: "show_linked_products", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "show_account_balance", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<GetSalePDFReq>): GetSalePDFReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.showPrices = 0;
        message.showLinkedProducts = false;
        message.showAccountBalance = false;
        if (value !== undefined)
            reflectionMergePartial<GetSalePDFReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetSalePDFReq): GetSalePDFReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* rd.api.sale.ShowPricesOption show_prices */ 2:
                    message.showPrices = reader.int32();
                    break;
                case /* bool show_linked_products */ 3:
                    message.showLinkedProducts = reader.bool();
                    break;
                case /* bool show_account_balance */ 4:
                    message.showAccountBalance = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetSalePDFReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.api.sale.ShowPricesOption show_prices = 2; */
        if (message.showPrices !== 0)
            writer.tag(2, WireType.Varint).int32(message.showPrices);
        /* bool show_linked_products = 3; */
        if (message.showLinkedProducts !== false)
            writer.tag(3, WireType.Varint).bool(message.showLinkedProducts);
        /* bool show_account_balance = 4; */
        if (message.showAccountBalance !== false)
            writer.tag(4, WireType.Varint).bool(message.showAccountBalance);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.GetSalePDFReq
 */
export const GetSalePDFReq = new GetSalePDFReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSalePDFRes$Type extends MessageType<GetSalePDFRes> {
    constructor() {
        super("rd.api.sale.GetSalePDFRes", [
            { no: 1, name: "bytes", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
    create(value?: PartialMessage<GetSalePDFRes>): GetSalePDFRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.bytes = new Uint8Array(0);
        if (value !== undefined)
            reflectionMergePartial<GetSalePDFRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetSalePDFRes): GetSalePDFRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bytes bytes */ 1:
                    message.bytes = reader.bytes();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetSalePDFRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bytes bytes = 1; */
        if (message.bytes.length)
            writer.tag(1, WireType.LengthDelimited).bytes(message.bytes);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.GetSalePDFRes
 */
export const GetSalePDFRes = new GetSalePDFRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AuthorizeCardPaymentReq$Type extends MessageType<AuthorizeCardPaymentReq> {
    constructor() {
        super("rd.api.sale.AuthorizeCardPaymentReq", [
            { no: 3, name: "customer_id", kind: "message", T: () => UUID },
            { no: 8, name: "location_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 14, name: "tsm", kind: "message", T: () => TenderSubmissionMetadata, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<AuthorizeCardPaymentReq>): AuthorizeCardPaymentReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AuthorizeCardPaymentReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AuthorizeCardPaymentReq): AuthorizeCardPaymentReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID customer_id */ 3:
                    message.customerId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.customerId);
                    break;
                case /* rd.proto.uuid.UUID location_id */ 8:
                    message.locationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.locationId);
                    break;
                case /* rd.txn.TenderSubmissionMetadata tsm */ 14:
                    message.tsm = TenderSubmissionMetadata.internalBinaryRead(reader, reader.uint32(), options, message.tsm);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AuthorizeCardPaymentReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID customer_id = 3; */
        if (message.customerId)
            UUID.internalBinaryWrite(message.customerId, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID location_id = 8; */
        if (message.locationId)
            UUID.internalBinaryWrite(message.locationId, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* rd.txn.TenderSubmissionMetadata tsm = 14; */
        if (message.tsm)
            TenderSubmissionMetadata.internalBinaryWrite(message.tsm, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.AuthorizeCardPaymentReq
 */
export const AuthorizeCardPaymentReq = new AuthorizeCardPaymentReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AuthorizeCardPaymentRes$Type extends MessageType<AuthorizeCardPaymentRes> {
    constructor() {
        super("rd.api.sale.AuthorizeCardPaymentRes", [
            { no: 1, name: "stripe_payment_intent_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AuthorizeCardPaymentRes>): AuthorizeCardPaymentRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.stripePaymentIntentId = "";
        if (value !== undefined)
            reflectionMergePartial<AuthorizeCardPaymentRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AuthorizeCardPaymentRes): AuthorizeCardPaymentRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string stripe_payment_intent_id */ 1:
                    message.stripePaymentIntentId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AuthorizeCardPaymentRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string stripe_payment_intent_id = 1; */
        if (message.stripePaymentIntentId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.stripePaymentIntentId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.AuthorizeCardPaymentRes
 */
export const AuthorizeCardPaymentRes = new AuthorizeCardPaymentRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetCardReaderDisplayReq$Type extends MessageType<SetCardReaderDisplayReq> {
    constructor() {
        super("rd.api.sale.SetCardReaderDisplayReq", [
            { no: 1, name: "stripe_reader_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } },
            { no: 2, name: "sales_tax", kind: "message", T: () => Money },
            { no: 3, name: "sale_total", kind: "message", T: () => Money },
            { no: 4, name: "card_surcharge", kind: "message", T: () => Money },
            { no: 5, name: "card_surcharge_tax", kind: "message", T: () => Money },
            { no: 6, name: "card_surcharge_rate", kind: "message", T: () => Decimal },
            { no: 8, name: "cart", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SetCardReaderDisplayReq_CartProduct },
            { no: 9, name: "customer_id", kind: "message", T: () => UUID },
            { no: 10, name: "sale_id", kind: "message", T: () => UUID },
            { no: 11, name: "location_id", kind: "message", T: () => UUID },
            { no: 12, name: "address", kind: "message", T: () => Address }
        ]);
    }
    create(value?: PartialMessage<SetCardReaderDisplayReq>): SetCardReaderDisplayReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.stripeReaderId = "";
        message.cart = [];
        if (value !== undefined)
            reflectionMergePartial<SetCardReaderDisplayReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SetCardReaderDisplayReq): SetCardReaderDisplayReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string stripe_reader_id */ 1:
                    message.stripeReaderId = reader.string();
                    break;
                case /* rd.proto.money.Money sales_tax */ 2:
                    message.salesTax = Money.internalBinaryRead(reader, reader.uint32(), options, message.salesTax);
                    break;
                case /* rd.proto.money.Money sale_total */ 3:
                    message.saleTotal = Money.internalBinaryRead(reader, reader.uint32(), options, message.saleTotal);
                    break;
                case /* rd.proto.money.Money card_surcharge */ 4:
                    message.cardSurcharge = Money.internalBinaryRead(reader, reader.uint32(), options, message.cardSurcharge);
                    break;
                case /* rd.proto.money.Money card_surcharge_tax */ 5:
                    message.cardSurchargeTax = Money.internalBinaryRead(reader, reader.uint32(), options, message.cardSurchargeTax);
                    break;
                case /* rd.proto.decimal.Decimal card_surcharge_rate */ 6:
                    message.cardSurchargeRate = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.cardSurchargeRate);
                    break;
                case /* repeated rd.api.sale.SetCardReaderDisplayReq.CartProduct cart */ 8:
                    message.cart.push(SetCardReaderDisplayReq_CartProduct.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.proto.uuid.UUID customer_id */ 9:
                    message.customerId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.customerId);
                    break;
                case /* rd.proto.uuid.UUID sale_id */ 10:
                    message.saleId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.saleId);
                    break;
                case /* rd.proto.uuid.UUID location_id */ 11:
                    message.locationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.locationId);
                    break;
                case /* rd.proto.address.Address address */ 12:
                    message.address = Address.internalBinaryRead(reader, reader.uint32(), options, message.address);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SetCardReaderDisplayReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string stripe_reader_id = 1; */
        if (message.stripeReaderId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.stripeReaderId);
        /* rd.proto.money.Money sales_tax = 2; */
        if (message.salesTax)
            Money.internalBinaryWrite(message.salesTax, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money sale_total = 3; */
        if (message.saleTotal)
            Money.internalBinaryWrite(message.saleTotal, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money card_surcharge = 4; */
        if (message.cardSurcharge)
            Money.internalBinaryWrite(message.cardSurcharge, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money card_surcharge_tax = 5; */
        if (message.cardSurchargeTax)
            Money.internalBinaryWrite(message.cardSurchargeTax, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal card_surcharge_rate = 6; */
        if (message.cardSurchargeRate)
            Decimal.internalBinaryWrite(message.cardSurchargeRate, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.api.sale.SetCardReaderDisplayReq.CartProduct cart = 8; */
        for (let i = 0; i < message.cart.length; i++)
            SetCardReaderDisplayReq_CartProduct.internalBinaryWrite(message.cart[i], writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID customer_id = 9; */
        if (message.customerId)
            UUID.internalBinaryWrite(message.customerId, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID sale_id = 10; */
        if (message.saleId)
            UUID.internalBinaryWrite(message.saleId, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID location_id = 11; */
        if (message.locationId)
            UUID.internalBinaryWrite(message.locationId, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.address.Address address = 12; */
        if (message.address)
            Address.internalBinaryWrite(message.address, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.SetCardReaderDisplayReq
 */
export const SetCardReaderDisplayReq = new SetCardReaderDisplayReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetCardReaderDisplayReq_CartProduct$Type extends MessageType<SetCardReaderDisplayReq_CartProduct> {
    constructor() {
        super("rd.api.sale.SetCardReaderDisplayReq.CartProduct", [
            { no: 1, name: "product_id", kind: "message", T: () => UUID },
            { no: 3, name: "product_edited_price", kind: "message", T: () => Money },
            { no: 4, name: "id", kind: "message", T: () => UUID },
            { no: 5, name: "sale_product_type", kind: "enum", T: () => ["rd.txn.SaleProduct.Type", SaleProduct_Type, "TYPE_"] },
            { no: 6, name: "returned_from_sale_product_id", kind: "message", T: () => UUID },
            { no: 8, name: "quantity_v2", kind: "message", T: () => Decimal },
            { no: 9, name: "quantity_returned_v2", kind: "message", T: () => Decimal },
            { no: 10, name: "uom_id", kind: "message", T: () => UUID },
            { no: 11, name: "quantity_uom", kind: "message", T: () => Decimal },
            { no: 12, name: "uom_id_returned", kind: "message", T: () => UUID },
            { no: 13, name: "quantity_returned_uom", kind: "message", T: () => Decimal },
            { no: 14, name: "is_taxed", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 15, name: "is_taxed_edited", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 16, name: "disabled_additional_fee_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 17, name: "is_price_edited", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<SetCardReaderDisplayReq_CartProduct>): SetCardReaderDisplayReq_CartProduct {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.saleProductType = 0;
        message.isTaxed = false;
        message.isTaxedEdited = false;
        message.disabledAdditionalFeeIds = [];
        message.isPriceEdited = false;
        if (value !== undefined)
            reflectionMergePartial<SetCardReaderDisplayReq_CartProduct>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SetCardReaderDisplayReq_CartProduct): SetCardReaderDisplayReq_CartProduct {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID product_id */ 1:
                    message.productId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.productId);
                    break;
                case /* rd.proto.money.Money product_edited_price */ 3:
                    message.productEditedPrice = Money.internalBinaryRead(reader, reader.uint32(), options, message.productEditedPrice);
                    break;
                case /* rd.proto.uuid.UUID id */ 4:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* rd.txn.SaleProduct.Type sale_product_type */ 5:
                    message.saleProductType = reader.int32();
                    break;
                case /* rd.proto.uuid.UUID returned_from_sale_product_id */ 6:
                    message.returnedFromSaleProductId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.returnedFromSaleProductId);
                    break;
                case /* rd.proto.decimal.Decimal quantity_v2 */ 8:
                    message.quantityV2 = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.quantityV2);
                    break;
                case /* rd.proto.decimal.Decimal quantity_returned_v2 */ 9:
                    message.quantityReturnedV2 = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.quantityReturnedV2);
                    break;
                case /* rd.proto.uuid.UUID uom_id */ 10:
                    message.uomId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.uomId);
                    break;
                case /* rd.proto.decimal.Decimal quantity_uom */ 11:
                    message.quantityUom = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.quantityUom);
                    break;
                case /* rd.proto.uuid.UUID uom_id_returned */ 12:
                    message.uomIdReturned = UUID.internalBinaryRead(reader, reader.uint32(), options, message.uomIdReturned);
                    break;
                case /* rd.proto.decimal.Decimal quantity_returned_uom */ 13:
                    message.quantityReturnedUom = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.quantityReturnedUom);
                    break;
                case /* bool is_taxed */ 14:
                    message.isTaxed = reader.bool();
                    break;
                case /* bool is_taxed_edited */ 15:
                    message.isTaxedEdited = reader.bool();
                    break;
                case /* repeated string disabled_additional_fee_ids */ 16:
                    message.disabledAdditionalFeeIds.push(reader.string());
                    break;
                case /* bool is_price_edited */ 17:
                    message.isPriceEdited = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SetCardReaderDisplayReq_CartProduct, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID product_id = 1; */
        if (message.productId)
            UUID.internalBinaryWrite(message.productId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money product_edited_price = 3; */
        if (message.productEditedPrice)
            Money.internalBinaryWrite(message.productEditedPrice, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID id = 4; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.txn.SaleProduct.Type sale_product_type = 5; */
        if (message.saleProductType !== 0)
            writer.tag(5, WireType.Varint).int32(message.saleProductType);
        /* rd.proto.uuid.UUID returned_from_sale_product_id = 6; */
        if (message.returnedFromSaleProductId)
            UUID.internalBinaryWrite(message.returnedFromSaleProductId, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal quantity_v2 = 8; */
        if (message.quantityV2)
            Decimal.internalBinaryWrite(message.quantityV2, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal quantity_returned_v2 = 9; */
        if (message.quantityReturnedV2)
            Decimal.internalBinaryWrite(message.quantityReturnedV2, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID uom_id = 10; */
        if (message.uomId)
            UUID.internalBinaryWrite(message.uomId, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal quantity_uom = 11; */
        if (message.quantityUom)
            Decimal.internalBinaryWrite(message.quantityUom, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID uom_id_returned = 12; */
        if (message.uomIdReturned)
            UUID.internalBinaryWrite(message.uomIdReturned, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal quantity_returned_uom = 13; */
        if (message.quantityReturnedUom)
            Decimal.internalBinaryWrite(message.quantityReturnedUom, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* bool is_taxed = 14; */
        if (message.isTaxed !== false)
            writer.tag(14, WireType.Varint).bool(message.isTaxed);
        /* bool is_taxed_edited = 15; */
        if (message.isTaxedEdited !== false)
            writer.tag(15, WireType.Varint).bool(message.isTaxedEdited);
        /* repeated string disabled_additional_fee_ids = 16; */
        for (let i = 0; i < message.disabledAdditionalFeeIds.length; i++)
            writer.tag(16, WireType.LengthDelimited).string(message.disabledAdditionalFeeIds[i]);
        /* bool is_price_edited = 17; */
        if (message.isPriceEdited !== false)
            writer.tag(17, WireType.Varint).bool(message.isPriceEdited);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.SetCardReaderDisplayReq.CartProduct
 */
export const SetCardReaderDisplayReq_CartProduct = new SetCardReaderDisplayReq_CartProduct$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetCardReaderDisplayRes$Type extends MessageType<SetCardReaderDisplayRes> {
    constructor() {
        super("rd.api.sale.SetCardReaderDisplayRes", []);
    }
    create(value?: PartialMessage<SetCardReaderDisplayRes>): SetCardReaderDisplayRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<SetCardReaderDisplayRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SetCardReaderDisplayRes): SetCardReaderDisplayRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SetCardReaderDisplayRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.SetCardReaderDisplayRes
 */
export const SetCardReaderDisplayRes = new SetCardReaderDisplayRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CanEditPriceDuringSaleReq$Type extends MessageType<CanEditPriceDuringSaleReq> {
    constructor() {
        super("rd.api.sale.CanEditPriceDuringSaleReq", []);
    }
    create(value?: PartialMessage<CanEditPriceDuringSaleReq>): CanEditPriceDuringSaleReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<CanEditPriceDuringSaleReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CanEditPriceDuringSaleReq): CanEditPriceDuringSaleReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CanEditPriceDuringSaleReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.CanEditPriceDuringSaleReq
 */
export const CanEditPriceDuringSaleReq = new CanEditPriceDuringSaleReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CanEditPriceDuringSaleRes$Type extends MessageType<CanEditPriceDuringSaleRes> {
    constructor() {
        super("rd.api.sale.CanEditPriceDuringSaleRes", []);
    }
    create(value?: PartialMessage<CanEditPriceDuringSaleRes>): CanEditPriceDuringSaleRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<CanEditPriceDuringSaleRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CanEditPriceDuringSaleRes): CanEditPriceDuringSaleRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CanEditPriceDuringSaleRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.CanEditPriceDuringSaleRes
 */
export const CanEditPriceDuringSaleRes = new CanEditPriceDuringSaleRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateSaleProductAdditionalFeesReq$Type extends MessageType<UpdateSaleProductAdditionalFeesReq> {
    constructor() {
        super("rd.api.sale.UpdateSaleProductAdditionalFeesReq", []);
    }
    create(value?: PartialMessage<UpdateSaleProductAdditionalFeesReq>): UpdateSaleProductAdditionalFeesReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateSaleProductAdditionalFeesReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateSaleProductAdditionalFeesReq): UpdateSaleProductAdditionalFeesReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateSaleProductAdditionalFeesReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.UpdateSaleProductAdditionalFeesReq
 */
export const UpdateSaleProductAdditionalFeesReq = new UpdateSaleProductAdditionalFeesReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateSaleProductAdditionalFeesRes$Type extends MessageType<UpdateSaleProductAdditionalFeesRes> {
    constructor() {
        super("rd.api.sale.UpdateSaleProductAdditionalFeesRes", []);
    }
    create(value?: PartialMessage<UpdateSaleProductAdditionalFeesRes>): UpdateSaleProductAdditionalFeesRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateSaleProductAdditionalFeesRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateSaleProductAdditionalFeesRes): UpdateSaleProductAdditionalFeesRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateSaleProductAdditionalFeesRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.UpdateSaleProductAdditionalFeesRes
 */
export const UpdateSaleProductAdditionalFeesRes = new UpdateSaleProductAdditionalFeesRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateSaleProductCostReq$Type extends MessageType<UpdateSaleProductCostReq> {
    constructor() {
        super("rd.api.sale.UpdateSaleProductCostReq", [
            { no: 1, name: "sale_product_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "cost", kind: "message", T: () => FractionalMoney, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<UpdateSaleProductCostReq>): UpdateSaleProductCostReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateSaleProductCostReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateSaleProductCostReq): UpdateSaleProductCostReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID sale_product_id */ 1:
                    message.saleProductId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.saleProductId);
                    break;
                case /* rd.proto.money.FractionalMoney cost */ 2:
                    message.cost = FractionalMoney.internalBinaryRead(reader, reader.uint32(), options, message.cost);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateSaleProductCostReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID sale_product_id = 1; */
        if (message.saleProductId)
            UUID.internalBinaryWrite(message.saleProductId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.FractionalMoney cost = 2; */
        if (message.cost)
            FractionalMoney.internalBinaryWrite(message.cost, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.UpdateSaleProductCostReq
 */
export const UpdateSaleProductCostReq = new UpdateSaleProductCostReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateSaleProductCostRes$Type extends MessageType<UpdateSaleProductCostRes> {
    constructor() {
        super("rd.api.sale.UpdateSaleProductCostRes", []);
    }
    create(value?: PartialMessage<UpdateSaleProductCostRes>): UpdateSaleProductCostRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateSaleProductCostRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateSaleProductCostRes): UpdateSaleProductCostRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateSaleProductCostRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.UpdateSaleProductCostRes
 */
export const UpdateSaleProductCostRes = new UpdateSaleProductCostRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateSaleProductCostsFromCCPRebatesReq$Type extends MessageType<UpdateSaleProductCostsFromCCPRebatesReq> {
    constructor() {
        super("rd.api.sale.UpdateSaleProductCostsFromCCPRebatesReq", [
            { no: 1, name: "csv_data", kind: "scalar", T: 12 /*ScalarType.BYTES*/, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<UpdateSaleProductCostsFromCCPRebatesReq>): UpdateSaleProductCostsFromCCPRebatesReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.csvData = new Uint8Array(0);
        if (value !== undefined)
            reflectionMergePartial<UpdateSaleProductCostsFromCCPRebatesReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateSaleProductCostsFromCCPRebatesReq): UpdateSaleProductCostsFromCCPRebatesReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bytes csv_data */ 1:
                    message.csvData = reader.bytes();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateSaleProductCostsFromCCPRebatesReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bytes csv_data = 1; */
        if (message.csvData.length)
            writer.tag(1, WireType.LengthDelimited).bytes(message.csvData);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.UpdateSaleProductCostsFromCCPRebatesReq
 */
export const UpdateSaleProductCostsFromCCPRebatesReq = new UpdateSaleProductCostsFromCCPRebatesReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateSaleProductCostsFromCCPRebatesRes$Type extends MessageType<UpdateSaleProductCostsFromCCPRebatesRes> {
    constructor() {
        super("rd.api.sale.UpdateSaleProductCostsFromCCPRebatesRes", [
            { no: 1, name: "upload", kind: "message", T: () => CCPRebateReportUpload }
        ]);
    }
    create(value?: PartialMessage<UpdateSaleProductCostsFromCCPRebatesRes>): UpdateSaleProductCostsFromCCPRebatesRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateSaleProductCostsFromCCPRebatesRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateSaleProductCostsFromCCPRebatesRes): UpdateSaleProductCostsFromCCPRebatesRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.txn.CCPRebateReportUpload upload */ 1:
                    message.upload = CCPRebateReportUpload.internalBinaryRead(reader, reader.uint32(), options, message.upload);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateSaleProductCostsFromCCPRebatesRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.txn.CCPRebateReportUpload upload = 1; */
        if (message.upload)
            CCPRebateReportUpload.internalBinaryWrite(message.upload, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.UpdateSaleProductCostsFromCCPRebatesRes
 */
export const UpdateSaleProductCostsFromCCPRebatesRes = new UpdateSaleProductCostsFromCCPRebatesRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListCCPRebateReportUploadsReq$Type extends MessageType<ListCCPRebateReportUploadsReq> {
    constructor() {
        super("rd.api.sale.ListCCPRebateReportUploadsReq", []);
    }
    create(value?: PartialMessage<ListCCPRebateReportUploadsReq>): ListCCPRebateReportUploadsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ListCCPRebateReportUploadsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListCCPRebateReportUploadsReq): ListCCPRebateReportUploadsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListCCPRebateReportUploadsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.ListCCPRebateReportUploadsReq
 */
export const ListCCPRebateReportUploadsReq = new ListCCPRebateReportUploadsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListCCPRebateReportUploadsRes$Type extends MessageType<ListCCPRebateReportUploadsRes> {
    constructor() {
        super("rd.api.sale.ListCCPRebateReportUploadsRes", [
            { no: 1, name: "uploads", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => CCPRebateReportUpload }
        ]);
    }
    create(value?: PartialMessage<ListCCPRebateReportUploadsRes>): ListCCPRebateReportUploadsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.uploads = [];
        if (value !== undefined)
            reflectionMergePartial<ListCCPRebateReportUploadsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListCCPRebateReportUploadsRes): ListCCPRebateReportUploadsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.txn.CCPRebateReportUpload uploads */ 1:
                    message.uploads.push(CCPRebateReportUpload.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListCCPRebateReportUploadsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.txn.CCPRebateReportUpload uploads = 1; */
        for (let i = 0; i < message.uploads.length; i++)
            CCPRebateReportUpload.internalBinaryWrite(message.uploads[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.ListCCPRebateReportUploadsRes
 */
export const ListCCPRebateReportUploadsRes = new ListCCPRebateReportUploadsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DuplicateSaleReq$Type extends MessageType<DuplicateSaleReq> {
    constructor() {
        super("rd.api.sale.DuplicateSaleReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "location_id", kind: "message", T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<DuplicateSaleReq>): DuplicateSaleReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<DuplicateSaleReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DuplicateSaleReq): DuplicateSaleReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* rd.proto.uuid.UUID location_id */ 2:
                    message.locationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.locationId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DuplicateSaleReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID location_id = 2; */
        if (message.locationId)
            UUID.internalBinaryWrite(message.locationId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.DuplicateSaleReq
 */
export const DuplicateSaleReq = new DuplicateSaleReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DuplicateSaleRes$Type extends MessageType<DuplicateSaleRes> {
    constructor() {
        super("rd.api.sale.DuplicateSaleRes", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "warnings", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<DuplicateSaleRes>): DuplicateSaleRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.warnings = [];
        if (value !== undefined)
            reflectionMergePartial<DuplicateSaleRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DuplicateSaleRes): DuplicateSaleRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* repeated string warnings */ 2:
                    message.warnings.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DuplicateSaleRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated string warnings = 2; */
        for (let i = 0; i < message.warnings.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.warnings[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.DuplicateSaleRes
 */
export const DuplicateSaleRes = new DuplicateSaleRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateUnpaidChargeAccountSaleDateReq$Type extends MessageType<UpdateUnpaidChargeAccountSaleDateReq> {
    constructor() {
        super("rd.api.sale.UpdateUnpaidChargeAccountSaleDateReq", []);
    }
    create(value?: PartialMessage<UpdateUnpaidChargeAccountSaleDateReq>): UpdateUnpaidChargeAccountSaleDateReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateUnpaidChargeAccountSaleDateReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateUnpaidChargeAccountSaleDateReq): UpdateUnpaidChargeAccountSaleDateReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateUnpaidChargeAccountSaleDateReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.UpdateUnpaidChargeAccountSaleDateReq
 */
export const UpdateUnpaidChargeAccountSaleDateReq = new UpdateUnpaidChargeAccountSaleDateReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateUnpaidChargeAccountSaleDateRes$Type extends MessageType<UpdateUnpaidChargeAccountSaleDateRes> {
    constructor() {
        super("rd.api.sale.UpdateUnpaidChargeAccountSaleDateRes", []);
    }
    create(value?: PartialMessage<UpdateUnpaidChargeAccountSaleDateRes>): UpdateUnpaidChargeAccountSaleDateRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateUnpaidChargeAccountSaleDateRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateUnpaidChargeAccountSaleDateRes): UpdateUnpaidChargeAccountSaleDateRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateUnpaidChargeAccountSaleDateRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.UpdateUnpaidChargeAccountSaleDateRes
 */
export const UpdateUnpaidChargeAccountSaleDateRes = new UpdateUnpaidChargeAccountSaleDateRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReturnSaleReq$Type extends MessageType<ReturnSaleReq> {
    constructor() {
        super("rd.api.sale.ReturnSaleReq", [
            { no: 1, name: "sale_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "returned_location_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 7, name: "customer_purchase_order_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "customer_contact_id_string", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "return_products_by_return_from_sale_product_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => ReturnSaleReq_ReturnProduct }, options: { "rd.validator.require": true } },
            { no: 10, name: "printer_id", kind: "message", T: () => UUID },
            { no: 11, name: "address", kind: "message", T: () => Address },
            { no: 12, name: "restock_fee_percentage", kind: "message", oneof: "restockFee", T: () => Decimal },
            { no: 13, name: "restock_fee_amount", kind: "message", oneof: "restockFee", T: () => Money },
            { no: 15, name: "cash_register_id", kind: "message", T: () => UUID },
            { no: 24, name: "fulfillment_location_id", kind: "message", T: () => UUID },
            { no: 25, name: "is_delivery_fulfillment", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 27, name: "tender_submission", kind: "message", T: () => TenderSubmissionMetadata },
            { no: 28, name: "delivery_date", kind: "message", T: () => Timestamp },
            { no: 29, name: "customer_contact_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ReturnSaleReq>): ReturnSaleReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.notes = "";
        message.customerPurchaseOrderName = "";
        message.customerContactIdString = "";
        message.returnProductsByReturnFromSaleProductId = {};
        message.restockFee = { oneofKind: undefined };
        message.isDeliveryFulfillment = false;
        message.customerContactName = "";
        if (value !== undefined)
            reflectionMergePartial<ReturnSaleReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ReturnSaleReq): ReturnSaleReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID sale_id */ 1:
                    message.saleId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.saleId);
                    break;
                case /* string notes */ 2:
                    message.notes = reader.string();
                    break;
                case /* rd.proto.uuid.UUID returned_location_id */ 3:
                    message.returnedLocationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.returnedLocationId);
                    break;
                case /* string customer_purchase_order_name */ 7:
                    message.customerPurchaseOrderName = reader.string();
                    break;
                case /* string customer_contact_id_string */ 8:
                    message.customerContactIdString = reader.string();
                    break;
                case /* map<string, rd.api.sale.ReturnSaleReq.ReturnProduct> return_products_by_return_from_sale_product_id */ 9:
                    this.binaryReadMap9(message.returnProductsByReturnFromSaleProductId, reader, options);
                    break;
                case /* rd.proto.uuid.UUID printer_id */ 10:
                    message.printerId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.printerId);
                    break;
                case /* rd.proto.address.Address address */ 11:
                    message.address = Address.internalBinaryRead(reader, reader.uint32(), options, message.address);
                    break;
                case /* rd.proto.decimal.Decimal restock_fee_percentage */ 12:
                    message.restockFee = {
                        oneofKind: "restockFeePercentage",
                        restockFeePercentage: Decimal.internalBinaryRead(reader, reader.uint32(), options, (message.restockFee as any).restockFeePercentage)
                    };
                    break;
                case /* rd.proto.money.Money restock_fee_amount */ 13:
                    message.restockFee = {
                        oneofKind: "restockFeeAmount",
                        restockFeeAmount: Money.internalBinaryRead(reader, reader.uint32(), options, (message.restockFee as any).restockFeeAmount)
                    };
                    break;
                case /* rd.proto.uuid.UUID cash_register_id */ 15:
                    message.cashRegisterId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.cashRegisterId);
                    break;
                case /* rd.proto.uuid.UUID fulfillment_location_id */ 24:
                    message.fulfillmentLocationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.fulfillmentLocationId);
                    break;
                case /* bool is_delivery_fulfillment */ 25:
                    message.isDeliveryFulfillment = reader.bool();
                    break;
                case /* rd.txn.TenderSubmissionMetadata tender_submission */ 27:
                    message.tenderSubmission = TenderSubmissionMetadata.internalBinaryRead(reader, reader.uint32(), options, message.tenderSubmission);
                    break;
                case /* google.protobuf.Timestamp delivery_date */ 28:
                    message.deliveryDate = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.deliveryDate);
                    break;
                case /* string customer_contact_name */ 29:
                    message.customerContactName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap9(map: ReturnSaleReq["returnProductsByReturnFromSaleProductId"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof ReturnSaleReq["returnProductsByReturnFromSaleProductId"] | undefined, val: ReturnSaleReq["returnProductsByReturnFromSaleProductId"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = ReturnSaleReq_ReturnProduct.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.api.sale.ReturnSaleReq.return_products_by_return_from_sale_product_id");
            }
        }
        map[key ?? ""] = val ?? ReturnSaleReq_ReturnProduct.create();
    }
    internalBinaryWrite(message: ReturnSaleReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID sale_id = 1; */
        if (message.saleId)
            UUID.internalBinaryWrite(message.saleId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string notes = 2; */
        if (message.notes !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.notes);
        /* rd.proto.uuid.UUID returned_location_id = 3; */
        if (message.returnedLocationId)
            UUID.internalBinaryWrite(message.returnedLocationId, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* string customer_purchase_order_name = 7; */
        if (message.customerPurchaseOrderName !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.customerPurchaseOrderName);
        /* string customer_contact_id_string = 8; */
        if (message.customerContactIdString !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.customerContactIdString);
        /* map<string, rd.api.sale.ReturnSaleReq.ReturnProduct> return_products_by_return_from_sale_product_id = 9; */
        for (let k of globalThis.Object.keys(message.returnProductsByReturnFromSaleProductId)) {
            writer.tag(9, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            ReturnSaleReq_ReturnProduct.internalBinaryWrite(message.returnProductsByReturnFromSaleProductId[k], writer, options);
            writer.join().join();
        }
        /* rd.proto.uuid.UUID printer_id = 10; */
        if (message.printerId)
            UUID.internalBinaryWrite(message.printerId, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.address.Address address = 11; */
        if (message.address)
            Address.internalBinaryWrite(message.address, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal restock_fee_percentage = 12; */
        if (message.restockFee.oneofKind === "restockFeePercentage")
            Decimal.internalBinaryWrite(message.restockFee.restockFeePercentage, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money restock_fee_amount = 13; */
        if (message.restockFee.oneofKind === "restockFeeAmount")
            Money.internalBinaryWrite(message.restockFee.restockFeeAmount, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID cash_register_id = 15; */
        if (message.cashRegisterId)
            UUID.internalBinaryWrite(message.cashRegisterId, writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID fulfillment_location_id = 24; */
        if (message.fulfillmentLocationId)
            UUID.internalBinaryWrite(message.fulfillmentLocationId, writer.tag(24, WireType.LengthDelimited).fork(), options).join();
        /* bool is_delivery_fulfillment = 25; */
        if (message.isDeliveryFulfillment !== false)
            writer.tag(25, WireType.Varint).bool(message.isDeliveryFulfillment);
        /* rd.txn.TenderSubmissionMetadata tender_submission = 27; */
        if (message.tenderSubmission)
            TenderSubmissionMetadata.internalBinaryWrite(message.tenderSubmission, writer.tag(27, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp delivery_date = 28; */
        if (message.deliveryDate)
            Timestamp.internalBinaryWrite(message.deliveryDate, writer.tag(28, WireType.LengthDelimited).fork(), options).join();
        /* string customer_contact_name = 29; */
        if (message.customerContactName !== "")
            writer.tag(29, WireType.LengthDelimited).string(message.customerContactName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.ReturnSaleReq
 */
export const ReturnSaleReq = new ReturnSaleReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReturnSaleReq_ReturnProduct$Type extends MessageType<ReturnSaleReq_ReturnProduct> {
    constructor() {
        super("rd.api.sale.ReturnSaleReq.ReturnProduct", [
            { no: 2, name: "quantity_to_return_v2", kind: "message", T: () => Decimal },
            { no: 3, name: "tally_rows", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SaleProduct_TallyRow }
        ]);
    }
    create(value?: PartialMessage<ReturnSaleReq_ReturnProduct>): ReturnSaleReq_ReturnProduct {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.tallyRows = [];
        if (value !== undefined)
            reflectionMergePartial<ReturnSaleReq_ReturnProduct>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ReturnSaleReq_ReturnProduct): ReturnSaleReq_ReturnProduct {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.decimal.Decimal quantity_to_return_v2 */ 2:
                    message.quantityToReturnV2 = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.quantityToReturnV2);
                    break;
                case /* repeated rd.txn.SaleProduct.TallyRow tally_rows */ 3:
                    message.tallyRows.push(SaleProduct_TallyRow.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ReturnSaleReq_ReturnProduct, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.decimal.Decimal quantity_to_return_v2 = 2; */
        if (message.quantityToReturnV2)
            Decimal.internalBinaryWrite(message.quantityToReturnV2, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.txn.SaleProduct.TallyRow tally_rows = 3; */
        for (let i = 0; i < message.tallyRows.length; i++)
            SaleProduct_TallyRow.internalBinaryWrite(message.tallyRows[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.ReturnSaleReq.ReturnProduct
 */
export const ReturnSaleReq_ReturnProduct = new ReturnSaleReq_ReturnProduct$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReturnSaleRes$Type extends MessageType<ReturnSaleRes> {
    constructor() {
        super("rd.api.sale.ReturnSaleRes", [
            { no: 2, name: "id", kind: "message", T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<ReturnSaleRes>): ReturnSaleRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ReturnSaleRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ReturnSaleRes): ReturnSaleRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 2:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ReturnSaleRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 2; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.ReturnSaleRes
 */
export const ReturnSaleRes = new ReturnSaleRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetReturnReq$Type extends MessageType<GetReturnReq> {
    constructor() {
        super("rd.api.sale.GetReturnReq", []);
    }
    create(value?: PartialMessage<GetReturnReq>): GetReturnReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetReturnReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetReturnReq): GetReturnReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetReturnReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.GetReturnReq
 */
export const GetReturnReq = new GetReturnReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetReturnRes$Type extends MessageType<GetReturnRes> {
    constructor() {
        super("rd.api.sale.GetReturnRes", []);
    }
    create(value?: PartialMessage<GetReturnRes>): GetReturnRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetReturnRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetReturnRes): GetReturnRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetReturnRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.GetReturnRes
 */
export const GetReturnRes = new GetReturnRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetReturnPDFReq$Type extends MessageType<GetReturnPDFReq> {
    constructor() {
        super("rd.api.sale.GetReturnPDFReq", []);
    }
    create(value?: PartialMessage<GetReturnPDFReq>): GetReturnPDFReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetReturnPDFReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetReturnPDFReq): GetReturnPDFReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetReturnPDFReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.GetReturnPDFReq
 */
export const GetReturnPDFReq = new GetReturnPDFReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetReturnPDFRes$Type extends MessageType<GetReturnPDFRes> {
    constructor() {
        super("rd.api.sale.GetReturnPDFRes", []);
    }
    create(value?: PartialMessage<GetReturnPDFRes>): GetReturnPDFRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetReturnPDFRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetReturnPDFRes): GetReturnPDFRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetReturnPDFRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.GetReturnPDFRes
 */
export const GetReturnPDFRes = new GetReturnPDFRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateReturnDetailsReq$Type extends MessageType<UpdateReturnDetailsReq> {
    constructor() {
        super("rd.api.sale.UpdateReturnDetailsReq", []);
    }
    create(value?: PartialMessage<UpdateReturnDetailsReq>): UpdateReturnDetailsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateReturnDetailsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateReturnDetailsReq): UpdateReturnDetailsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateReturnDetailsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.UpdateReturnDetailsReq
 */
export const UpdateReturnDetailsReq = new UpdateReturnDetailsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateReturnDetailsRes$Type extends MessageType<UpdateReturnDetailsRes> {
    constructor() {
        super("rd.api.sale.UpdateReturnDetailsRes", []);
    }
    create(value?: PartialMessage<UpdateReturnDetailsRes>): UpdateReturnDetailsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateReturnDetailsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateReturnDetailsRes): UpdateReturnDetailsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateReturnDetailsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.UpdateReturnDetailsRes
 */
export const UpdateReturnDetailsRes = new UpdateReturnDetailsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EmailReturnPDFReq$Type extends MessageType<EmailReturnPDFReq> {
    constructor() {
        super("rd.api.sale.EmailReturnPDFReq", []);
    }
    create(value?: PartialMessage<EmailReturnPDFReq>): EmailReturnPDFReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<EmailReturnPDFReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EmailReturnPDFReq): EmailReturnPDFReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EmailReturnPDFReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.EmailReturnPDFReq
 */
export const EmailReturnPDFReq = new EmailReturnPDFReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EmailReturnPDFRes$Type extends MessageType<EmailReturnPDFRes> {
    constructor() {
        super("rd.api.sale.EmailReturnPDFRes", []);
    }
    create(value?: PartialMessage<EmailReturnPDFRes>): EmailReturnPDFRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<EmailReturnPDFRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EmailReturnPDFRes): EmailReturnPDFRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EmailReturnPDFRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.EmailReturnPDFRes
 */
export const EmailReturnPDFRes = new EmailReturnPDFRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateSaleProductReturnedReq$Type extends MessageType<UpdateSaleProductReturnedReq> {
    constructor() {
        super("rd.api.sale.UpdateSaleProductReturnedReq", []);
    }
    create(value?: PartialMessage<UpdateSaleProductReturnedReq>): UpdateSaleProductReturnedReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateSaleProductReturnedReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateSaleProductReturnedReq): UpdateSaleProductReturnedReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateSaleProductReturnedReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.UpdateSaleProductReturnedReq
 */
export const UpdateSaleProductReturnedReq = new UpdateSaleProductReturnedReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateSaleProductReturnedReq_Product$Type extends MessageType<UpdateSaleProductReturnedReq_Product> {
    constructor() {
        super("rd.api.sale.UpdateSaleProductReturnedReq.Product", []);
    }
    create(value?: PartialMessage<UpdateSaleProductReturnedReq_Product>): UpdateSaleProductReturnedReq_Product {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateSaleProductReturnedReq_Product>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateSaleProductReturnedReq_Product): UpdateSaleProductReturnedReq_Product {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateSaleProductReturnedReq_Product, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.UpdateSaleProductReturnedReq.Product
 */
export const UpdateSaleProductReturnedReq_Product = new UpdateSaleProductReturnedReq_Product$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateSaleProductReturnedRes$Type extends MessageType<UpdateSaleProductReturnedRes> {
    constructor() {
        super("rd.api.sale.UpdateSaleProductReturnedRes", []);
    }
    create(value?: PartialMessage<UpdateSaleProductReturnedRes>): UpdateSaleProductReturnedRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateSaleProductReturnedRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateSaleProductReturnedRes): UpdateSaleProductReturnedRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateSaleProductReturnedRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.UpdateSaleProductReturnedRes
 */
export const UpdateSaleProductReturnedRes = new UpdateSaleProductReturnedRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateSaleProductReturnedCostReq$Type extends MessageType<UpdateSaleProductReturnedCostReq> {
    constructor() {
        super("rd.api.sale.UpdateSaleProductReturnedCostReq", []);
    }
    create(value?: PartialMessage<UpdateSaleProductReturnedCostReq>): UpdateSaleProductReturnedCostReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateSaleProductReturnedCostReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateSaleProductReturnedCostReq): UpdateSaleProductReturnedCostReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateSaleProductReturnedCostReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.UpdateSaleProductReturnedCostReq
 */
export const UpdateSaleProductReturnedCostReq = new UpdateSaleProductReturnedCostReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateSaleProductReturnedCostRes$Type extends MessageType<UpdateSaleProductReturnedCostRes> {
    constructor() {
        super("rd.api.sale.UpdateSaleProductReturnedCostRes", []);
    }
    create(value?: PartialMessage<UpdateSaleProductReturnedCostRes>): UpdateSaleProductReturnedCostRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateSaleProductReturnedCostRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateSaleProductReturnedCostRes): UpdateSaleProductReturnedCostRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateSaleProductReturnedCostRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.UpdateSaleProductReturnedCostRes
 */
export const UpdateSaleProductReturnedCostRes = new UpdateSaleProductReturnedCostRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CalculateReturnTotalsReq$Type extends MessageType<CalculateReturnTotalsReq> {
    constructor() {
        super("rd.api.sale.CalculateReturnTotalsReq", [
            { no: 1, name: "return_from_sale_id", kind: "message", T: () => UUID },
            { no: 2, name: "quantities_to_return_from_sale_product_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 5 /*ScalarType.INT32*/ } },
            { no: 3, name: "quantities_to_return_from_sale_product_id_v2", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Decimal } },
            { no: 12, name: "restock_fee_percentage", kind: "message", oneof: "restockFee", T: () => Decimal },
            { no: 13, name: "restock_fee_amount", kind: "message", oneof: "restockFee", T: () => Money }
        ]);
    }
    create(value?: PartialMessage<CalculateReturnTotalsReq>): CalculateReturnTotalsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.quantitiesToReturnFromSaleProductId = {};
        message.quantitiesToReturnFromSaleProductIdV2 = {};
        message.restockFee = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<CalculateReturnTotalsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CalculateReturnTotalsReq): CalculateReturnTotalsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID return_from_sale_id */ 1:
                    message.returnFromSaleId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.returnFromSaleId);
                    break;
                case /* map<string, int32> quantities_to_return_from_sale_product_id = 2 [deprecated = true] */ 2:
                    this.binaryReadMap2(message.quantitiesToReturnFromSaleProductId, reader, options);
                    break;
                case /* map<string, rd.proto.decimal.Decimal> quantities_to_return_from_sale_product_id_v2 */ 3:
                    this.binaryReadMap3(message.quantitiesToReturnFromSaleProductIdV2, reader, options);
                    break;
                case /* rd.proto.decimal.Decimal restock_fee_percentage */ 12:
                    message.restockFee = {
                        oneofKind: "restockFeePercentage",
                        restockFeePercentage: Decimal.internalBinaryRead(reader, reader.uint32(), options, (message.restockFee as any).restockFeePercentage)
                    };
                    break;
                case /* rd.proto.money.Money restock_fee_amount */ 13:
                    message.restockFee = {
                        oneofKind: "restockFeeAmount",
                        restockFeeAmount: Money.internalBinaryRead(reader, reader.uint32(), options, (message.restockFee as any).restockFeeAmount)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap2(map: CalculateReturnTotalsReq["quantitiesToReturnFromSaleProductId"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof CalculateReturnTotalsReq["quantitiesToReturnFromSaleProductId"] | undefined, val: CalculateReturnTotalsReq["quantitiesToReturnFromSaleProductId"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.int32();
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.api.sale.CalculateReturnTotalsReq.quantities_to_return_from_sale_product_id");
            }
        }
        map[key ?? ""] = val ?? 0;
    }
    private binaryReadMap3(map: CalculateReturnTotalsReq["quantitiesToReturnFromSaleProductIdV2"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof CalculateReturnTotalsReq["quantitiesToReturnFromSaleProductIdV2"] | undefined, val: CalculateReturnTotalsReq["quantitiesToReturnFromSaleProductIdV2"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Decimal.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.api.sale.CalculateReturnTotalsReq.quantities_to_return_from_sale_product_id_v2");
            }
        }
        map[key ?? ""] = val ?? Decimal.create();
    }
    internalBinaryWrite(message: CalculateReturnTotalsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID return_from_sale_id = 1; */
        if (message.returnFromSaleId)
            UUID.internalBinaryWrite(message.returnFromSaleId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* map<string, int32> quantities_to_return_from_sale_product_id = 2 [deprecated = true]; */
        for (let k of globalThis.Object.keys(message.quantitiesToReturnFromSaleProductId))
            writer.tag(2, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.Varint).int32(message.quantitiesToReturnFromSaleProductId[k]).join();
        /* map<string, rd.proto.decimal.Decimal> quantities_to_return_from_sale_product_id_v2 = 3; */
        for (let k of globalThis.Object.keys(message.quantitiesToReturnFromSaleProductIdV2)) {
            writer.tag(3, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Decimal.internalBinaryWrite(message.quantitiesToReturnFromSaleProductIdV2[k], writer, options);
            writer.join().join();
        }
        /* rd.proto.decimal.Decimal restock_fee_percentage = 12; */
        if (message.restockFee.oneofKind === "restockFeePercentage")
            Decimal.internalBinaryWrite(message.restockFee.restockFeePercentage, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money restock_fee_amount = 13; */
        if (message.restockFee.oneofKind === "restockFeeAmount")
            Money.internalBinaryWrite(message.restockFee.restockFeeAmount, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.CalculateReturnTotalsReq
 */
export const CalculateReturnTotalsReq = new CalculateReturnTotalsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CalculateReturnTotalsRes$Type extends MessageType<CalculateReturnTotalsRes> {
    constructor() {
        super("rd.api.sale.CalculateReturnTotalsRes", [
            { no: 1, name: "total", kind: "message", T: () => Money },
            { no: 2, name: "subtotal", kind: "message", T: () => Money },
            { no: 3, name: "sales_tax_total", kind: "message", T: () => Money },
            { no: 4, name: "card_surcharge", kind: "message", T: () => Money },
            { no: 5, name: "card_surcharge_tax", kind: "message", T: () => Money },
            { no: 7, name: "tax_rate", kind: "message", T: () => TaxRate },
            { no: 8, name: "card_surcharge_rate", kind: "message", T: () => Decimal },
            { no: 10, name: "final_total", kind: "message", T: () => Money },
            { no: 11, name: "restock_fee_total", kind: "message", T: () => Money },
            { no: 12, name: "current_restock_fee", kind: "message", T: () => Money },
            { no: 13, name: "discount_applied", kind: "message", T: () => Money },
            { no: 14, name: "discount_rate", kind: "message", T: () => Decimal },
            { no: 16, name: "additional_fees_by_name_v2", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Sale_Totals_AdditionalFee } },
            { no: 17, name: "sale_taxes", kind: "message", T: () => SaleTaxes }
        ]);
    }
    create(value?: PartialMessage<CalculateReturnTotalsRes>): CalculateReturnTotalsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.additionalFeesByNameV2 = {};
        if (value !== undefined)
            reflectionMergePartial<CalculateReturnTotalsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CalculateReturnTotalsRes): CalculateReturnTotalsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.money.Money total */ 1:
                    message.total = Money.internalBinaryRead(reader, reader.uint32(), options, message.total);
                    break;
                case /* rd.proto.money.Money subtotal */ 2:
                    message.subtotal = Money.internalBinaryRead(reader, reader.uint32(), options, message.subtotal);
                    break;
                case /* rd.proto.money.Money sales_tax_total */ 3:
                    message.salesTaxTotal = Money.internalBinaryRead(reader, reader.uint32(), options, message.salesTaxTotal);
                    break;
                case /* rd.proto.money.Money card_surcharge */ 4:
                    message.cardSurcharge = Money.internalBinaryRead(reader, reader.uint32(), options, message.cardSurcharge);
                    break;
                case /* rd.proto.money.Money card_surcharge_tax */ 5:
                    message.cardSurchargeTax = Money.internalBinaryRead(reader, reader.uint32(), options, message.cardSurchargeTax);
                    break;
                case /* rd.company.TaxRate tax_rate */ 7:
                    message.taxRate = TaxRate.internalBinaryRead(reader, reader.uint32(), options, message.taxRate);
                    break;
                case /* rd.proto.decimal.Decimal card_surcharge_rate */ 8:
                    message.cardSurchargeRate = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.cardSurchargeRate);
                    break;
                case /* rd.proto.money.Money final_total */ 10:
                    message.finalTotal = Money.internalBinaryRead(reader, reader.uint32(), options, message.finalTotal);
                    break;
                case /* rd.proto.money.Money restock_fee_total */ 11:
                    message.restockFeeTotal = Money.internalBinaryRead(reader, reader.uint32(), options, message.restockFeeTotal);
                    break;
                case /* rd.proto.money.Money current_restock_fee */ 12:
                    message.currentRestockFee = Money.internalBinaryRead(reader, reader.uint32(), options, message.currentRestockFee);
                    break;
                case /* rd.proto.money.Money discount_applied */ 13:
                    message.discountApplied = Money.internalBinaryRead(reader, reader.uint32(), options, message.discountApplied);
                    break;
                case /* rd.proto.decimal.Decimal discount_rate */ 14:
                    message.discountRate = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.discountRate);
                    break;
                case /* map<string, rd.txn.Sale.Totals.AdditionalFee> additional_fees_by_name_v2 */ 16:
                    this.binaryReadMap16(message.additionalFeesByNameV2, reader, options);
                    break;
                case /* rd.txn.SaleTaxes sale_taxes */ 17:
                    message.saleTaxes = SaleTaxes.internalBinaryRead(reader, reader.uint32(), options, message.saleTaxes);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap16(map: CalculateReturnTotalsRes["additionalFeesByNameV2"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof CalculateReturnTotalsRes["additionalFeesByNameV2"] | undefined, val: CalculateReturnTotalsRes["additionalFeesByNameV2"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Sale_Totals_AdditionalFee.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.api.sale.CalculateReturnTotalsRes.additional_fees_by_name_v2");
            }
        }
        map[key ?? ""] = val ?? Sale_Totals_AdditionalFee.create();
    }
    internalBinaryWrite(message: CalculateReturnTotalsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.money.Money total = 1; */
        if (message.total)
            Money.internalBinaryWrite(message.total, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money subtotal = 2; */
        if (message.subtotal)
            Money.internalBinaryWrite(message.subtotal, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money sales_tax_total = 3; */
        if (message.salesTaxTotal)
            Money.internalBinaryWrite(message.salesTaxTotal, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money card_surcharge = 4; */
        if (message.cardSurcharge)
            Money.internalBinaryWrite(message.cardSurcharge, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money card_surcharge_tax = 5; */
        if (message.cardSurchargeTax)
            Money.internalBinaryWrite(message.cardSurchargeTax, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.company.TaxRate tax_rate = 7; */
        if (message.taxRate)
            TaxRate.internalBinaryWrite(message.taxRate, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal card_surcharge_rate = 8; */
        if (message.cardSurchargeRate)
            Decimal.internalBinaryWrite(message.cardSurchargeRate, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money final_total = 10; */
        if (message.finalTotal)
            Money.internalBinaryWrite(message.finalTotal, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money restock_fee_total = 11; */
        if (message.restockFeeTotal)
            Money.internalBinaryWrite(message.restockFeeTotal, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money current_restock_fee = 12; */
        if (message.currentRestockFee)
            Money.internalBinaryWrite(message.currentRestockFee, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money discount_applied = 13; */
        if (message.discountApplied)
            Money.internalBinaryWrite(message.discountApplied, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal discount_rate = 14; */
        if (message.discountRate)
            Decimal.internalBinaryWrite(message.discountRate, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* map<string, rd.txn.Sale.Totals.AdditionalFee> additional_fees_by_name_v2 = 16; */
        for (let k of globalThis.Object.keys(message.additionalFeesByNameV2)) {
            writer.tag(16, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Sale_Totals_AdditionalFee.internalBinaryWrite(message.additionalFeesByNameV2[k], writer, options);
            writer.join().join();
        }
        /* rd.txn.SaleTaxes sale_taxes = 17; */
        if (message.saleTaxes)
            SaleTaxes.internalBinaryWrite(message.saleTaxes, writer.tag(17, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.CalculateReturnTotalsRes
 */
export const CalculateReturnTotalsRes = new CalculateReturnTotalsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UnlinkedReturnsReq$Type extends MessageType<UnlinkedReturnsReq> {
    constructor() {
        super("rd.api.sale.UnlinkedReturnsReq", []);
    }
    create(value?: PartialMessage<UnlinkedReturnsReq>): UnlinkedReturnsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UnlinkedReturnsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UnlinkedReturnsReq): UnlinkedReturnsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UnlinkedReturnsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.UnlinkedReturnsReq
 */
export const UnlinkedReturnsReq = new UnlinkedReturnsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UnlinkedReturnsRes$Type extends MessageType<UnlinkedReturnsRes> {
    constructor() {
        super("rd.api.sale.UnlinkedReturnsRes", []);
    }
    create(value?: PartialMessage<UnlinkedReturnsRes>): UnlinkedReturnsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UnlinkedReturnsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UnlinkedReturnsRes): UnlinkedReturnsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UnlinkedReturnsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.UnlinkedReturnsRes
 */
export const UnlinkedReturnsRes = new UnlinkedReturnsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VoidCompletedSaleReq$Type extends MessageType<VoidCompletedSaleReq> {
    constructor() {
        super("rd.api.sale.VoidCompletedSaleReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "is_inventory_returned", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "void_reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<VoidCompletedSaleReq>): VoidCompletedSaleReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isInventoryReturned = false;
        message.voidReason = "";
        if (value !== undefined)
            reflectionMergePartial<VoidCompletedSaleReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VoidCompletedSaleReq): VoidCompletedSaleReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* bool is_inventory_returned */ 2:
                    message.isInventoryReturned = reader.bool();
                    break;
                case /* string void_reason */ 3:
                    message.voidReason = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VoidCompletedSaleReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* bool is_inventory_returned = 2; */
        if (message.isInventoryReturned !== false)
            writer.tag(2, WireType.Varint).bool(message.isInventoryReturned);
        /* string void_reason = 3; */
        if (message.voidReason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.voidReason);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.VoidCompletedSaleReq
 */
export const VoidCompletedSaleReq = new VoidCompletedSaleReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VoidCompletedSaleRes$Type extends MessageType<VoidCompletedSaleRes> {
    constructor() {
        super("rd.api.sale.VoidCompletedSaleRes", []);
    }
    create(value?: PartialMessage<VoidCompletedSaleRes>): VoidCompletedSaleRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<VoidCompletedSaleRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VoidCompletedSaleRes): VoidCompletedSaleRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VoidCompletedSaleRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.VoidCompletedSaleRes
 */
export const VoidCompletedSaleRes = new VoidCompletedSaleRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetIsEditingCompletedSaleAllowedReq$Type extends MessageType<GetIsEditingCompletedSaleAllowedReq> {
    constructor() {
        super("rd.api.sale.GetIsEditingCompletedSaleAllowedReq", [
            { no: 1, name: "sale_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<GetIsEditingCompletedSaleAllowedReq>): GetIsEditingCompletedSaleAllowedReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetIsEditingCompletedSaleAllowedReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetIsEditingCompletedSaleAllowedReq): GetIsEditingCompletedSaleAllowedReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID sale_id */ 1:
                    message.saleId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.saleId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetIsEditingCompletedSaleAllowedReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID sale_id = 1; */
        if (message.saleId)
            UUID.internalBinaryWrite(message.saleId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.GetIsEditingCompletedSaleAllowedReq
 */
export const GetIsEditingCompletedSaleAllowedReq = new GetIsEditingCompletedSaleAllowedReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetIsEditingCompletedSaleAllowedRes$Type extends MessageType<GetIsEditingCompletedSaleAllowedRes> {
    constructor() {
        super("rd.api.sale.GetIsEditingCompletedSaleAllowedRes", [
            { no: 1, name: "is_voiding_allowed", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "allowed_date_range", kind: "message", T: () => TimestampRange },
            { no: 3, name: "is_editing_allowed", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "voiding_blocked_reasons", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "editing_blocked_reasons", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetIsEditingCompletedSaleAllowedRes>): GetIsEditingCompletedSaleAllowedRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isVoidingAllowed = false;
        message.isEditingAllowed = false;
        message.voidingBlockedReasons = [];
        message.editingBlockedReasons = [];
        if (value !== undefined)
            reflectionMergePartial<GetIsEditingCompletedSaleAllowedRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetIsEditingCompletedSaleAllowedRes): GetIsEditingCompletedSaleAllowedRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool is_voiding_allowed */ 1:
                    message.isVoidingAllowed = reader.bool();
                    break;
                case /* rd.proto.timestamprange.TimestampRange allowed_date_range */ 2:
                    message.allowedDateRange = TimestampRange.internalBinaryRead(reader, reader.uint32(), options, message.allowedDateRange);
                    break;
                case /* bool is_editing_allowed */ 3:
                    message.isEditingAllowed = reader.bool();
                    break;
                case /* repeated string voiding_blocked_reasons */ 4:
                    message.voidingBlockedReasons.push(reader.string());
                    break;
                case /* repeated string editing_blocked_reasons */ 5:
                    message.editingBlockedReasons.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetIsEditingCompletedSaleAllowedRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool is_voiding_allowed = 1; */
        if (message.isVoidingAllowed !== false)
            writer.tag(1, WireType.Varint).bool(message.isVoidingAllowed);
        /* rd.proto.timestamprange.TimestampRange allowed_date_range = 2; */
        if (message.allowedDateRange)
            TimestampRange.internalBinaryWrite(message.allowedDateRange, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* bool is_editing_allowed = 3; */
        if (message.isEditingAllowed !== false)
            writer.tag(3, WireType.Varint).bool(message.isEditingAllowed);
        /* repeated string voiding_blocked_reasons = 4; */
        for (let i = 0; i < message.voidingBlockedReasons.length; i++)
            writer.tag(4, WireType.LengthDelimited).string(message.voidingBlockedReasons[i]);
        /* repeated string editing_blocked_reasons = 5; */
        for (let i = 0; i < message.editingBlockedReasons.length; i++)
            writer.tag(5, WireType.LengthDelimited).string(message.editingBlockedReasons[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.GetIsEditingCompletedSaleAllowedRes
 */
export const GetIsEditingCompletedSaleAllowedRes = new GetIsEditingCompletedSaleAllowedRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EditSaleDateReq$Type extends MessageType<EditSaleDateReq> {
    constructor() {
        super("rd.api.sale.EditSaleDateReq", [
            { no: 1, name: "sale_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "sale_date", kind: "message", T: () => Timestamp, options: { "rd.validator.require": true } },
            { no: 3, name: "client_time_zone", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<EditSaleDateReq>): EditSaleDateReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.clientTimeZone = "";
        if (value !== undefined)
            reflectionMergePartial<EditSaleDateReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EditSaleDateReq): EditSaleDateReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID sale_id */ 1:
                    message.saleId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.saleId);
                    break;
                case /* google.protobuf.Timestamp sale_date */ 2:
                    message.saleDate = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.saleDate);
                    break;
                case /* string client_time_zone */ 3:
                    message.clientTimeZone = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EditSaleDateReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID sale_id = 1; */
        if (message.saleId)
            UUID.internalBinaryWrite(message.saleId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp sale_date = 2; */
        if (message.saleDate)
            Timestamp.internalBinaryWrite(message.saleDate, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string client_time_zone = 3; */
        if (message.clientTimeZone !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.clientTimeZone);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.EditSaleDateReq
 */
export const EditSaleDateReq = new EditSaleDateReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EditSaleDateRes$Type extends MessageType<EditSaleDateRes> {
    constructor() {
        super("rd.api.sale.EditSaleDateRes", []);
    }
    create(value?: PartialMessage<EditSaleDateRes>): EditSaleDateRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<EditSaleDateRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EditSaleDateRes): EditSaleDateRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EditSaleDateRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.EditSaleDateRes
 */
export const EditSaleDateRes = new EditSaleDateRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EditSaleDueDateReq$Type extends MessageType<EditSaleDueDateReq> {
    constructor() {
        super("rd.api.sale.EditSaleDueDateReq", [
            { no: 1, name: "sale_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "due_date", kind: "message", T: () => Timestamp, options: { "rd.validator.require": true } },
            { no: 3, name: "client_time_zone", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<EditSaleDueDateReq>): EditSaleDueDateReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.clientTimeZone = "";
        if (value !== undefined)
            reflectionMergePartial<EditSaleDueDateReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EditSaleDueDateReq): EditSaleDueDateReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID sale_id */ 1:
                    message.saleId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.saleId);
                    break;
                case /* google.protobuf.Timestamp due_date */ 2:
                    message.dueDate = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.dueDate);
                    break;
                case /* string client_time_zone */ 3:
                    message.clientTimeZone = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EditSaleDueDateReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID sale_id = 1; */
        if (message.saleId)
            UUID.internalBinaryWrite(message.saleId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp due_date = 2; */
        if (message.dueDate)
            Timestamp.internalBinaryWrite(message.dueDate, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string client_time_zone = 3; */
        if (message.clientTimeZone !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.clientTimeZone);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.EditSaleDueDateReq
 */
export const EditSaleDueDateReq = new EditSaleDueDateReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EditSaleDueDateRes$Type extends MessageType<EditSaleDueDateRes> {
    constructor() {
        super("rd.api.sale.EditSaleDueDateRes", []);
    }
    create(value?: PartialMessage<EditSaleDueDateRes>): EditSaleDueDateRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<EditSaleDueDateRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EditSaleDueDateRes): EditSaleDueDateRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EditSaleDueDateRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.EditSaleDueDateRes
 */
export const EditSaleDueDateRes = new EditSaleDueDateRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EditSaleDiscountDateReq$Type extends MessageType<EditSaleDiscountDateReq> {
    constructor() {
        super("rd.api.sale.EditSaleDiscountDateReq", [
            { no: 1, name: "sale_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "discount_date", kind: "message", T: () => Timestamp, options: { "rd.validator.require": true } },
            { no: 3, name: "client_time_zone", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<EditSaleDiscountDateReq>): EditSaleDiscountDateReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.clientTimeZone = "";
        if (value !== undefined)
            reflectionMergePartial<EditSaleDiscountDateReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EditSaleDiscountDateReq): EditSaleDiscountDateReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID sale_id */ 1:
                    message.saleId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.saleId);
                    break;
                case /* google.protobuf.Timestamp discount_date */ 2:
                    message.discountDate = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.discountDate);
                    break;
                case /* string client_time_zone */ 3:
                    message.clientTimeZone = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EditSaleDiscountDateReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID sale_id = 1; */
        if (message.saleId)
            UUID.internalBinaryWrite(message.saleId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp discount_date = 2; */
        if (message.discountDate)
            Timestamp.internalBinaryWrite(message.discountDate, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string client_time_zone = 3; */
        if (message.clientTimeZone !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.clientTimeZone);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.EditSaleDiscountDateReq
 */
export const EditSaleDiscountDateReq = new EditSaleDiscountDateReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EditSaleDiscountDateRes$Type extends MessageType<EditSaleDiscountDateRes> {
    constructor() {
        super("rd.api.sale.EditSaleDiscountDateRes", []);
    }
    create(value?: PartialMessage<EditSaleDiscountDateRes>): EditSaleDiscountDateRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<EditSaleDiscountDateRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EditSaleDiscountDateRes): EditSaleDiscountDateRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EditSaleDiscountDateRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.EditSaleDiscountDateRes
 */
export const EditSaleDiscountDateRes = new EditSaleDiscountDateRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EditSaleDesignatedClerkReq$Type extends MessageType<EditSaleDesignatedClerkReq> {
    constructor() {
        super("rd.api.sale.EditSaleDesignatedClerkReq", [
            { no: 1, name: "sale_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "staff_id", kind: "message", T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<EditSaleDesignatedClerkReq>): EditSaleDesignatedClerkReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<EditSaleDesignatedClerkReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EditSaleDesignatedClerkReq): EditSaleDesignatedClerkReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID sale_id */ 1:
                    message.saleId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.saleId);
                    break;
                case /* rd.proto.uuid.UUID staff_id */ 2:
                    message.staffId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.staffId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EditSaleDesignatedClerkReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID sale_id = 1; */
        if (message.saleId)
            UUID.internalBinaryWrite(message.saleId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID staff_id = 2; */
        if (message.staffId)
            UUID.internalBinaryWrite(message.staffId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.EditSaleDesignatedClerkReq
 */
export const EditSaleDesignatedClerkReq = new EditSaleDesignatedClerkReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EditSaleDesignatedClerkRes$Type extends MessageType<EditSaleDesignatedClerkRes> {
    constructor() {
        super("rd.api.sale.EditSaleDesignatedClerkRes", []);
    }
    create(value?: PartialMessage<EditSaleDesignatedClerkRes>): EditSaleDesignatedClerkRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<EditSaleDesignatedClerkRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EditSaleDesignatedClerkRes): EditSaleDesignatedClerkRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EditSaleDesignatedClerkRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.EditSaleDesignatedClerkRes
 */
export const EditSaleDesignatedClerkRes = new EditSaleDesignatedClerkRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CalculateCardSurchargeReq$Type extends MessageType<CalculateCardSurchargeReq> {
    constructor() {
        super("rd.api.sale.CalculateCardSurchargeReq", [
            { no: 1, name: "total", kind: "message", T: () => Money },
            { no: 2, name: "payment_method", kind: "enum", T: () => ["rd.api.sale.CalculateCardSurchargeReq.PaymentMethod", CalculateCardSurchargeReq_PaymentMethod, "PAYMENT_METHOD_"] },
            { no: 3, name: "customer_id", kind: "message", T: () => UUID },
            { no: 4, name: "tax_rate", kind: "message", T: () => Decimal },
            { no: 5, name: "is_card_surcharge_disabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "tax_rate_id", kind: "message", T: () => UUID },
            { no: 7, name: "tax_rates_by_rate_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Decimal } }
        ]);
    }
    create(value?: PartialMessage<CalculateCardSurchargeReq>): CalculateCardSurchargeReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.paymentMethod = 0;
        message.isCardSurchargeDisabled = false;
        message.taxRatesByRateId = {};
        if (value !== undefined)
            reflectionMergePartial<CalculateCardSurchargeReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CalculateCardSurchargeReq): CalculateCardSurchargeReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.money.Money total */ 1:
                    message.total = Money.internalBinaryRead(reader, reader.uint32(), options, message.total);
                    break;
                case /* rd.api.sale.CalculateCardSurchargeReq.PaymentMethod payment_method */ 2:
                    message.paymentMethod = reader.int32();
                    break;
                case /* rd.proto.uuid.UUID customer_id */ 3:
                    message.customerId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.customerId);
                    break;
                case /* rd.proto.decimal.Decimal tax_rate */ 4:
                    message.taxRate = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.taxRate);
                    break;
                case /* bool is_card_surcharge_disabled */ 5:
                    message.isCardSurchargeDisabled = reader.bool();
                    break;
                case /* rd.proto.uuid.UUID tax_rate_id */ 6:
                    message.taxRateId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.taxRateId);
                    break;
                case /* map<string, rd.proto.decimal.Decimal> tax_rates_by_rate_id */ 7:
                    this.binaryReadMap7(message.taxRatesByRateId, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap7(map: CalculateCardSurchargeReq["taxRatesByRateId"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof CalculateCardSurchargeReq["taxRatesByRateId"] | undefined, val: CalculateCardSurchargeReq["taxRatesByRateId"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Decimal.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.api.sale.CalculateCardSurchargeReq.tax_rates_by_rate_id");
            }
        }
        map[key ?? ""] = val ?? Decimal.create();
    }
    internalBinaryWrite(message: CalculateCardSurchargeReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.money.Money total = 1; */
        if (message.total)
            Money.internalBinaryWrite(message.total, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.api.sale.CalculateCardSurchargeReq.PaymentMethod payment_method = 2; */
        if (message.paymentMethod !== 0)
            writer.tag(2, WireType.Varint).int32(message.paymentMethod);
        /* rd.proto.uuid.UUID customer_id = 3; */
        if (message.customerId)
            UUID.internalBinaryWrite(message.customerId, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal tax_rate = 4; */
        if (message.taxRate)
            Decimal.internalBinaryWrite(message.taxRate, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* bool is_card_surcharge_disabled = 5; */
        if (message.isCardSurchargeDisabled !== false)
            writer.tag(5, WireType.Varint).bool(message.isCardSurchargeDisabled);
        /* rd.proto.uuid.UUID tax_rate_id = 6; */
        if (message.taxRateId)
            UUID.internalBinaryWrite(message.taxRateId, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* map<string, rd.proto.decimal.Decimal> tax_rates_by_rate_id = 7; */
        for (let k of globalThis.Object.keys(message.taxRatesByRateId)) {
            writer.tag(7, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Decimal.internalBinaryWrite(message.taxRatesByRateId[k], writer, options);
            writer.join().join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.CalculateCardSurchargeReq
 */
export const CalculateCardSurchargeReq = new CalculateCardSurchargeReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CalculateCardSurchargeRes$Type extends MessageType<CalculateCardSurchargeRes> {
    constructor() {
        super("rd.api.sale.CalculateCardSurchargeRes", [
            { no: 1, name: "surcharge", kind: "message", T: () => Money },
            { no: 2, name: "surcharge_tax", kind: "message", T: () => Money },
            { no: 3, name: "surcharge_taxes_by_rate_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Money } }
        ]);
    }
    create(value?: PartialMessage<CalculateCardSurchargeRes>): CalculateCardSurchargeRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.surchargeTaxesByRateId = {};
        if (value !== undefined)
            reflectionMergePartial<CalculateCardSurchargeRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CalculateCardSurchargeRes): CalculateCardSurchargeRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.money.Money surcharge */ 1:
                    message.surcharge = Money.internalBinaryRead(reader, reader.uint32(), options, message.surcharge);
                    break;
                case /* rd.proto.money.Money surcharge_tax */ 2:
                    message.surchargeTax = Money.internalBinaryRead(reader, reader.uint32(), options, message.surchargeTax);
                    break;
                case /* map<string, rd.proto.money.Money> surcharge_taxes_by_rate_id */ 3:
                    this.binaryReadMap3(message.surchargeTaxesByRateId, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap3(map: CalculateCardSurchargeRes["surchargeTaxesByRateId"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof CalculateCardSurchargeRes["surchargeTaxesByRateId"] | undefined, val: CalculateCardSurchargeRes["surchargeTaxesByRateId"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Money.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.api.sale.CalculateCardSurchargeRes.surcharge_taxes_by_rate_id");
            }
        }
        map[key ?? ""] = val ?? Money.create();
    }
    internalBinaryWrite(message: CalculateCardSurchargeRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.money.Money surcharge = 1; */
        if (message.surcharge)
            Money.internalBinaryWrite(message.surcharge, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money surcharge_tax = 2; */
        if (message.surchargeTax)
            Money.internalBinaryWrite(message.surchargeTax, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* map<string, rd.proto.money.Money> surcharge_taxes_by_rate_id = 3; */
        for (let k of globalThis.Object.keys(message.surchargeTaxesByRateId)) {
            writer.tag(3, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Money.internalBinaryWrite(message.surchargeTaxesByRateId[k], writer, options);
            writer.join().join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.CalculateCardSurchargeRes
 */
export const CalculateCardSurchargeRes = new CalculateCardSurchargeRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CalculateCardSurchargeDisplayInfoReq$Type extends MessageType<CalculateCardSurchargeDisplayInfoReq> {
    constructor() {
        super("rd.api.sale.CalculateCardSurchargeDisplayInfoReq", [
            { no: 2, name: "card_surcharge_amount", kind: "message", T: () => Money },
            { no: 3, name: "card_surcharge_tax", kind: "message", T: () => Money },
            { no: 4, name: "customer_id", kind: "message", T: () => UUID },
            { no: 6, name: "split_tender_submissions", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TenderSubmissionMetadata },
            { no: 7, name: "card_surcharge_taxes_by_rate_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Money } }
        ]);
    }
    create(value?: PartialMessage<CalculateCardSurchargeDisplayInfoReq>): CalculateCardSurchargeDisplayInfoReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.splitTenderSubmissions = [];
        message.cardSurchargeTaxesByRateId = {};
        if (value !== undefined)
            reflectionMergePartial<CalculateCardSurchargeDisplayInfoReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CalculateCardSurchargeDisplayInfoReq): CalculateCardSurchargeDisplayInfoReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.money.Money card_surcharge_amount */ 2:
                    message.cardSurchargeAmount = Money.internalBinaryRead(reader, reader.uint32(), options, message.cardSurchargeAmount);
                    break;
                case /* rd.proto.money.Money card_surcharge_tax */ 3:
                    message.cardSurchargeTax = Money.internalBinaryRead(reader, reader.uint32(), options, message.cardSurchargeTax);
                    break;
                case /* rd.proto.uuid.UUID customer_id */ 4:
                    message.customerId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.customerId);
                    break;
                case /* repeated rd.txn.TenderSubmissionMetadata split_tender_submissions */ 6:
                    message.splitTenderSubmissions.push(TenderSubmissionMetadata.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* map<string, rd.proto.money.Money> card_surcharge_taxes_by_rate_id */ 7:
                    this.binaryReadMap7(message.cardSurchargeTaxesByRateId, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap7(map: CalculateCardSurchargeDisplayInfoReq["cardSurchargeTaxesByRateId"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof CalculateCardSurchargeDisplayInfoReq["cardSurchargeTaxesByRateId"] | undefined, val: CalculateCardSurchargeDisplayInfoReq["cardSurchargeTaxesByRateId"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Money.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.api.sale.CalculateCardSurchargeDisplayInfoReq.card_surcharge_taxes_by_rate_id");
            }
        }
        map[key ?? ""] = val ?? Money.create();
    }
    internalBinaryWrite(message: CalculateCardSurchargeDisplayInfoReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.money.Money card_surcharge_amount = 2; */
        if (message.cardSurchargeAmount)
            Money.internalBinaryWrite(message.cardSurchargeAmount, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money card_surcharge_tax = 3; */
        if (message.cardSurchargeTax)
            Money.internalBinaryWrite(message.cardSurchargeTax, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID customer_id = 4; */
        if (message.customerId)
            UUID.internalBinaryWrite(message.customerId, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.txn.TenderSubmissionMetadata split_tender_submissions = 6; */
        for (let i = 0; i < message.splitTenderSubmissions.length; i++)
            TenderSubmissionMetadata.internalBinaryWrite(message.splitTenderSubmissions[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* map<string, rd.proto.money.Money> card_surcharge_taxes_by_rate_id = 7; */
        for (let k of globalThis.Object.keys(message.cardSurchargeTaxesByRateId)) {
            writer.tag(7, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Money.internalBinaryWrite(message.cardSurchargeTaxesByRateId[k], writer, options);
            writer.join().join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.CalculateCardSurchargeDisplayInfoReq
 */
export const CalculateCardSurchargeDisplayInfoReq = new CalculateCardSurchargeDisplayInfoReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CalculateCardSurchargeDisplayInfoRes$Type extends MessageType<CalculateCardSurchargeDisplayInfoRes> {
    constructor() {
        super("rd.api.sale.CalculateCardSurchargeDisplayInfoRes", [
            { no: 1, name: "is_tax_exempt", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "surcharge_rate", kind: "message", T: () => Decimal },
            { no: 4, name: "all_card_surcharges_total", kind: "message", T: () => Money },
            { no: 5, name: "all_card_surcharges_pre_tax_total", kind: "message", T: () => Money },
            { no: 6, name: "surcharge_tax_lines", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TaxLine }
        ]);
    }
    create(value?: PartialMessage<CalculateCardSurchargeDisplayInfoRes>): CalculateCardSurchargeDisplayInfoRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isTaxExempt = false;
        message.surchargeTaxLines = [];
        if (value !== undefined)
            reflectionMergePartial<CalculateCardSurchargeDisplayInfoRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CalculateCardSurchargeDisplayInfoRes): CalculateCardSurchargeDisplayInfoRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool is_tax_exempt */ 1:
                    message.isTaxExempt = reader.bool();
                    break;
                case /* rd.proto.decimal.Decimal surcharge_rate */ 2:
                    message.surchargeRate = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.surchargeRate);
                    break;
                case /* rd.proto.money.Money all_card_surcharges_total */ 4:
                    message.allCardSurchargesTotal = Money.internalBinaryRead(reader, reader.uint32(), options, message.allCardSurchargesTotal);
                    break;
                case /* rd.proto.money.Money all_card_surcharges_pre_tax_total */ 5:
                    message.allCardSurchargesPreTaxTotal = Money.internalBinaryRead(reader, reader.uint32(), options, message.allCardSurchargesPreTaxTotal);
                    break;
                case /* repeated rd.txn.TaxLine surcharge_tax_lines */ 6:
                    message.surchargeTaxLines.push(TaxLine.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CalculateCardSurchargeDisplayInfoRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool is_tax_exempt = 1; */
        if (message.isTaxExempt !== false)
            writer.tag(1, WireType.Varint).bool(message.isTaxExempt);
        /* rd.proto.decimal.Decimal surcharge_rate = 2; */
        if (message.surchargeRate)
            Decimal.internalBinaryWrite(message.surchargeRate, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money all_card_surcharges_total = 4; */
        if (message.allCardSurchargesTotal)
            Money.internalBinaryWrite(message.allCardSurchargesTotal, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money all_card_surcharges_pre_tax_total = 5; */
        if (message.allCardSurchargesPreTaxTotal)
            Money.internalBinaryWrite(message.allCardSurchargesPreTaxTotal, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.txn.TaxLine surcharge_tax_lines = 6; */
        for (let i = 0; i < message.surchargeTaxLines.length; i++)
            TaxLine.internalBinaryWrite(message.surchargeTaxLines[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.CalculateCardSurchargeDisplayInfoRes
 */
export const CalculateCardSurchargeDisplayInfoRes = new CalculateCardSurchargeDisplayInfoRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateSpecialOrderProductPriceAndCostReq$Type extends MessageType<UpdateSpecialOrderProductPriceAndCostReq> {
    constructor() {
        super("rd.api.sale.UpdateSpecialOrderProductPriceAndCostReq", [
            { no: 1, name: "sale_product_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "price", kind: "message", T: () => Money, options: { "rd.validator.require": true } },
            { no: 3, name: "cost", kind: "message", T: () => FractionalMoney, options: { "rd.validator.require": true } },
            { no: 4, name: "is_taxed", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "retail_price", kind: "message", T: () => Money }
        ]);
    }
    create(value?: PartialMessage<UpdateSpecialOrderProductPriceAndCostReq>): UpdateSpecialOrderProductPriceAndCostReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isTaxed = false;
        if (value !== undefined)
            reflectionMergePartial<UpdateSpecialOrderProductPriceAndCostReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateSpecialOrderProductPriceAndCostReq): UpdateSpecialOrderProductPriceAndCostReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID sale_product_id */ 1:
                    message.saleProductId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.saleProductId);
                    break;
                case /* rd.proto.money.Money price */ 2:
                    message.price = Money.internalBinaryRead(reader, reader.uint32(), options, message.price);
                    break;
                case /* rd.proto.money.FractionalMoney cost */ 3:
                    message.cost = FractionalMoney.internalBinaryRead(reader, reader.uint32(), options, message.cost);
                    break;
                case /* bool is_taxed */ 4:
                    message.isTaxed = reader.bool();
                    break;
                case /* rd.proto.money.Money retail_price */ 5:
                    message.retailPrice = Money.internalBinaryRead(reader, reader.uint32(), options, message.retailPrice);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateSpecialOrderProductPriceAndCostReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID sale_product_id = 1; */
        if (message.saleProductId)
            UUID.internalBinaryWrite(message.saleProductId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money price = 2; */
        if (message.price)
            Money.internalBinaryWrite(message.price, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.FractionalMoney cost = 3; */
        if (message.cost)
            FractionalMoney.internalBinaryWrite(message.cost, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* bool is_taxed = 4; */
        if (message.isTaxed !== false)
            writer.tag(4, WireType.Varint).bool(message.isTaxed);
        /* rd.proto.money.Money retail_price = 5; */
        if (message.retailPrice)
            Money.internalBinaryWrite(message.retailPrice, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.UpdateSpecialOrderProductPriceAndCostReq
 */
export const UpdateSpecialOrderProductPriceAndCostReq = new UpdateSpecialOrderProductPriceAndCostReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateSpecialOrderProductPriceAndCostRes$Type extends MessageType<UpdateSpecialOrderProductPriceAndCostRes> {
    constructor() {
        super("rd.api.sale.UpdateSpecialOrderProductPriceAndCostRes", []);
    }
    create(value?: PartialMessage<UpdateSpecialOrderProductPriceAndCostRes>): UpdateSpecialOrderProductPriceAndCostRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateSpecialOrderProductPriceAndCostRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateSpecialOrderProductPriceAndCostRes): UpdateSpecialOrderProductPriceAndCostRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateSpecialOrderProductPriceAndCostRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.UpdateSpecialOrderProductPriceAndCostRes
 */
export const UpdateSpecialOrderProductPriceAndCostRes = new UpdateSpecialOrderProductPriceAndCostRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RefundDepositReq$Type extends MessageType<RefundDepositReq> {
    constructor() {
        super("rd.api.sale.RefundDepositReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "purchase_order_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "address", kind: "message", T: () => Address },
            { no: 4, name: "internal_notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "sale_notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "fulfillment_location_id", kind: "message", T: () => UUID },
            { no: 7, name: "is_delivery_fulfillment", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 8, name: "tax_rate_id", kind: "message", T: () => UUID },
            { no: 9, name: "idempotency_key", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "printer_id", kind: "message", T: () => UUID },
            { no: 11, name: "tender_submission_metadata", kind: "message", T: () => TenderSubmissionMetadata },
            { no: 12, name: "customer_contact_id_string", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "tax_rate_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<RefundDepositReq>): RefundDepositReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.purchaseOrderName = "";
        message.internalNotes = "";
        message.saleNotes = "";
        message.isDeliveryFulfillment = false;
        message.idempotencyKey = "";
        message.customerContactIdString = "";
        message.taxRateIds = [];
        if (value !== undefined)
            reflectionMergePartial<RefundDepositReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RefundDepositReq): RefundDepositReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* string purchase_order_name */ 2:
                    message.purchaseOrderName = reader.string();
                    break;
                case /* rd.proto.address.Address address */ 3:
                    message.address = Address.internalBinaryRead(reader, reader.uint32(), options, message.address);
                    break;
                case /* string internal_notes */ 4:
                    message.internalNotes = reader.string();
                    break;
                case /* string sale_notes */ 5:
                    message.saleNotes = reader.string();
                    break;
                case /* rd.proto.uuid.UUID fulfillment_location_id */ 6:
                    message.fulfillmentLocationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.fulfillmentLocationId);
                    break;
                case /* bool is_delivery_fulfillment */ 7:
                    message.isDeliveryFulfillment = reader.bool();
                    break;
                case /* rd.proto.uuid.UUID tax_rate_id */ 8:
                    message.taxRateId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.taxRateId);
                    break;
                case /* string idempotency_key */ 9:
                    message.idempotencyKey = reader.string();
                    break;
                case /* rd.proto.uuid.UUID printer_id */ 10:
                    message.printerId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.printerId);
                    break;
                case /* rd.txn.TenderSubmissionMetadata tender_submission_metadata */ 11:
                    message.tenderSubmissionMetadata = TenderSubmissionMetadata.internalBinaryRead(reader, reader.uint32(), options, message.tenderSubmissionMetadata);
                    break;
                case /* string customer_contact_id_string */ 12:
                    message.customerContactIdString = reader.string();
                    break;
                case /* repeated rd.proto.uuid.UUID tax_rate_ids */ 13:
                    message.taxRateIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RefundDepositReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string purchase_order_name = 2; */
        if (message.purchaseOrderName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.purchaseOrderName);
        /* rd.proto.address.Address address = 3; */
        if (message.address)
            Address.internalBinaryWrite(message.address, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* string internal_notes = 4; */
        if (message.internalNotes !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.internalNotes);
        /* string sale_notes = 5; */
        if (message.saleNotes !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.saleNotes);
        /* rd.proto.uuid.UUID fulfillment_location_id = 6; */
        if (message.fulfillmentLocationId)
            UUID.internalBinaryWrite(message.fulfillmentLocationId, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* bool is_delivery_fulfillment = 7; */
        if (message.isDeliveryFulfillment !== false)
            writer.tag(7, WireType.Varint).bool(message.isDeliveryFulfillment);
        /* rd.proto.uuid.UUID tax_rate_id = 8; */
        if (message.taxRateId)
            UUID.internalBinaryWrite(message.taxRateId, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* string idempotency_key = 9; */
        if (message.idempotencyKey !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.idempotencyKey);
        /* rd.proto.uuid.UUID printer_id = 10; */
        if (message.printerId)
            UUID.internalBinaryWrite(message.printerId, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* rd.txn.TenderSubmissionMetadata tender_submission_metadata = 11; */
        if (message.tenderSubmissionMetadata)
            TenderSubmissionMetadata.internalBinaryWrite(message.tenderSubmissionMetadata, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* string customer_contact_id_string = 12; */
        if (message.customerContactIdString !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.customerContactIdString);
        /* repeated rd.proto.uuid.UUID tax_rate_ids = 13; */
        for (let i = 0; i < message.taxRateIds.length; i++)
            UUID.internalBinaryWrite(message.taxRateIds[i], writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.RefundDepositReq
 */
export const RefundDepositReq = new RefundDepositReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RefundDepositRes$Type extends MessageType<RefundDepositRes> {
    constructor() {
        super("rd.api.sale.RefundDepositRes", [
            { no: 1, name: "email_error", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<RefundDepositRes>): RefundDepositRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.emailError = false;
        if (value !== undefined)
            reflectionMergePartial<RefundDepositRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RefundDepositRes): RefundDepositRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool email_error */ 1:
                    message.emailError = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RefundDepositRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool email_error = 1; */
        if (message.emailError !== false)
            writer.tag(1, WireType.Varint).bool(message.emailError);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.RefundDepositRes
 */
export const RefundDepositRes = new RefundDepositRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RefundInteracPaymentReq$Type extends MessageType<RefundInteracPaymentReq> {
    constructor() {
        super("rd.api.sale.RefundInteracPaymentReq", [
            { no: 1, name: "stripe_payment_intent_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } },
            { no: 2, name: "stripe_reader_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } },
            { no: 3, name: "idempotency_key", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<RefundInteracPaymentReq>): RefundInteracPaymentReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.stripePaymentIntentId = "";
        message.stripeReaderId = "";
        message.idempotencyKey = "";
        if (value !== undefined)
            reflectionMergePartial<RefundInteracPaymentReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RefundInteracPaymentReq): RefundInteracPaymentReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string stripe_payment_intent_id */ 1:
                    message.stripePaymentIntentId = reader.string();
                    break;
                case /* string stripe_reader_id */ 2:
                    message.stripeReaderId = reader.string();
                    break;
                case /* string idempotency_key */ 3:
                    message.idempotencyKey = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RefundInteracPaymentReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string stripe_payment_intent_id = 1; */
        if (message.stripePaymentIntentId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.stripePaymentIntentId);
        /* string stripe_reader_id = 2; */
        if (message.stripeReaderId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.stripeReaderId);
        /* string idempotency_key = 3; */
        if (message.idempotencyKey !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.idempotencyKey);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.RefundInteracPaymentReq
 */
export const RefundInteracPaymentReq = new RefundInteracPaymentReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RefundInteracPaymentRes$Type extends MessageType<RefundInteracPaymentRes> {
    constructor() {
        super("rd.api.sale.RefundInteracPaymentRes", []);
    }
    create(value?: PartialMessage<RefundInteracPaymentRes>): RefundInteracPaymentRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<RefundInteracPaymentRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RefundInteracPaymentRes): RefundInteracPaymentRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RefundInteracPaymentRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.RefundInteracPaymentRes
 */
export const RefundInteracPaymentRes = new RefundInteracPaymentRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SaleFanBuilderCoupon$Type extends MessageType<SaleFanBuilderCoupon> {
    constructor() {
        super("rd.api.sale.SaleFanBuilderCoupon", [
            { no: 1, name: "coupon_barcode", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "discount_amount", kind: "message", T: () => Money },
            { no: 4, name: "taxable", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "discount_type", kind: "enum", T: () => ["rd.api.sale.SaleFanBuilderCoupon.DiscountType", SaleFanBuilderCoupon_DiscountType, "DISCOUNT_TYPE_"] },
            { no: 6, name: "amount", kind: "message", T: () => Decimal }
        ]);
    }
    create(value?: PartialMessage<SaleFanBuilderCoupon>): SaleFanBuilderCoupon {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.couponBarcode = "";
        message.description = "";
        message.taxable = false;
        message.discountType = 0;
        if (value !== undefined)
            reflectionMergePartial<SaleFanBuilderCoupon>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SaleFanBuilderCoupon): SaleFanBuilderCoupon {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string coupon_barcode */ 1:
                    message.couponBarcode = reader.string();
                    break;
                case /* string description */ 2:
                    message.description = reader.string();
                    break;
                case /* rd.proto.money.Money discount_amount */ 3:
                    message.discountAmount = Money.internalBinaryRead(reader, reader.uint32(), options, message.discountAmount);
                    break;
                case /* bool taxable */ 4:
                    message.taxable = reader.bool();
                    break;
                case /* rd.api.sale.SaleFanBuilderCoupon.DiscountType discount_type */ 5:
                    message.discountType = reader.int32();
                    break;
                case /* rd.proto.decimal.Decimal amount */ 6:
                    message.amount = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.amount);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SaleFanBuilderCoupon, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string coupon_barcode = 1; */
        if (message.couponBarcode !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.couponBarcode);
        /* string description = 2; */
        if (message.description !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.description);
        /* rd.proto.money.Money discount_amount = 3; */
        if (message.discountAmount)
            Money.internalBinaryWrite(message.discountAmount, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* bool taxable = 4; */
        if (message.taxable !== false)
            writer.tag(4, WireType.Varint).bool(message.taxable);
        /* rd.api.sale.SaleFanBuilderCoupon.DiscountType discount_type = 5; */
        if (message.discountType !== 0)
            writer.tag(5, WireType.Varint).int32(message.discountType);
        /* rd.proto.decimal.Decimal amount = 6; */
        if (message.amount)
            Decimal.internalBinaryWrite(message.amount, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.SaleFanBuilderCoupon
 */
export const SaleFanBuilderCoupon = new SaleFanBuilderCoupon$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SaleFanBuilderCoupons$Type extends MessageType<SaleFanBuilderCoupons> {
    constructor() {
        super("rd.api.sale.SaleFanBuilderCoupons", [
            { no: 1, name: "coupons", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SaleFanBuilderCoupon }
        ]);
    }
    create(value?: PartialMessage<SaleFanBuilderCoupons>): SaleFanBuilderCoupons {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.coupons = [];
        if (value !== undefined)
            reflectionMergePartial<SaleFanBuilderCoupons>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SaleFanBuilderCoupons): SaleFanBuilderCoupons {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.api.sale.SaleFanBuilderCoupon coupons */ 1:
                    message.coupons.push(SaleFanBuilderCoupon.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SaleFanBuilderCoupons, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.api.sale.SaleFanBuilderCoupon coupons = 1; */
        for (let i = 0; i < message.coupons.length; i++)
            SaleFanBuilderCoupon.internalBinaryWrite(message.coupons[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.sale.SaleFanBuilderCoupons
 */
export const SaleFanBuilderCoupons = new SaleFanBuilderCoupons$Type();
/**
 * @generated ServiceType for protobuf service rd.api.sale.SaleService
 */
export const SaleService = new ServiceType("rd.api.sale.SaleService", [
    { name: "GetSaleCountsByStatus", options: {}, I: GetSaleCountsByStatusReq, O: GetSaleCountsByStatusRes },
    { name: "GetSale", options: {}, I: GetSaleReq, O: GetSaleRes },
    { name: "GetScannedSale", options: {}, I: GetScannedSaleReq, O: GetScannedSaleRes },
    { name: "UpsertSaleV3", options: {}, I: UpsertSaleV3Req, O: UpsertSaleV3Res },
    { name: "SyncCartPrices", options: {}, I: SyncCartPricesReq, O: SyncCartPricesRes },
    { name: "GetCartPrices", options: {}, I: GetCartPricesReq, O: GetCartPricesRes },
    { name: "UpdateSoldSaleProduct", options: {}, I: UpdateSoldSaleProductReq, O: UpdateSoldSaleProductRes },
    { name: "UpdateSoldSaleDetails", options: {}, I: UpdateSoldSaleDetailsReq, O: UpdateSoldSaleDetailsRes },
    { name: "EmailSalePDF", options: {}, I: EmailSalePDFReq, O: EmailSalePDFRes },
    { name: "GetSalePDF", options: {}, I: GetSalePDFReq, O: GetSalePDFRes },
    { name: "AuthorizeCardPayment", options: {}, I: AuthorizeCardPaymentReq, O: AuthorizeCardPaymentRes },
    { name: "SetCardReaderDisplay", options: {}, I: SetCardReaderDisplayReq, O: SetCardReaderDisplayRes },
    { name: "CanEditPriceDuringSale", options: {}, I: CanEditPriceDuringSaleReq, O: CanEditPriceDuringSaleRes },
    { name: "UpdateSaleProductAdditionalFees", options: {}, I: UpdateSaleProductAdditionalFeesReq, O: UpdateSaleProductAdditionalFeesRes },
    { name: "UpdateSaleProductCost", options: {}, I: UpdateSaleProductCostReq, O: UpdateSaleProductCostRes },
    { name: "UpdateSaleProductCostsFromCCPRebates", options: {}, I: UpdateSaleProductCostsFromCCPRebatesReq, O: UpdateSaleProductCostsFromCCPRebatesRes },
    { name: "ListCCPRebateReportUploads", options: {}, I: ListCCPRebateReportUploadsReq, O: ListCCPRebateReportUploadsRes },
    { name: "DuplicateSale", options: {}, I: DuplicateSaleReq, O: DuplicateSaleRes },
    { name: "UpdateUnpaidChargeAccountSaleDate", options: {}, I: UpdateUnpaidChargeAccountSaleDateReq, O: UpdateUnpaidChargeAccountSaleDateRes },
    { name: "VoidCompletedSale", options: {}, I: VoidCompletedSaleReq, O: VoidCompletedSaleRes },
    { name: "GetIsEditingCompletedSaleAllowed", options: {}, I: GetIsEditingCompletedSaleAllowedReq, O: GetIsEditingCompletedSaleAllowedRes },
    { name: "EditSaleDate", options: {}, I: EditSaleDateReq, O: EditSaleDateRes },
    { name: "EditSaleDueDate", options: {}, I: EditSaleDueDateReq, O: EditSaleDueDateRes },
    { name: "EditSaleDiscountDate", options: {}, I: EditSaleDiscountDateReq, O: EditSaleDiscountDateRes },
    { name: "EditSaleDesignatedClerk", options: {}, I: EditSaleDesignatedClerkReq, O: EditSaleDesignatedClerkRes },
    { name: "CalculateCardSurcharge", options: {}, I: CalculateCardSurchargeReq, O: CalculateCardSurchargeRes },
    { name: "CalculateCardSurchargeDisplayInfo", options: {}, I: CalculateCardSurchargeDisplayInfoReq, O: CalculateCardSurchargeDisplayInfoRes },
    { name: "GetReturn", options: {}, I: GetReturnReq, O: GetReturnRes },
    { name: "ReturnSale", options: {}, I: ReturnSaleReq, O: ReturnSaleRes },
    { name: "GetReturnPDF", options: {}, I: GetReturnPDFReq, O: GetReturnPDFRes },
    { name: "UpdateReturnDetails", options: {}, I: UpdateReturnDetailsReq, O: UpdateReturnDetailsRes },
    { name: "EmailReturnPDF", options: {}, I: EmailReturnPDFReq, O: EmailReturnPDFRes },
    { name: "UpdateSaleProductReturned", options: {}, I: UpdateSaleProductReturnedReq, O: UpdateSaleProductReturnedRes },
    { name: "UpdateSaleProductReturnedCost", options: {}, I: UpdateSaleProductReturnedCostReq, O: UpdateSaleProductReturnedCostRes },
    { name: "CalculateReturnTotals", options: {}, I: CalculateReturnTotalsReq, O: CalculateReturnTotalsRes },
    { name: "UnlinkedReturns", options: {}, I: UnlinkedReturnsReq, O: UnlinkedReturnsRes },
    { name: "RefundInteracPayment", options: {}, I: RefundInteracPaymentReq, O: RefundInteracPaymentRes },
    { name: "UpdateSpecialOrderProductPriceAndCost", options: {}, I: UpdateSpecialOrderProductPriceAndCostReq, O: UpdateSpecialOrderProductPriceAndCostRes },
    { name: "RefundDeposit", options: {}, I: RefundDepositReq, O: RefundDepositRes },
    { name: "CloseOutSale", options: {}, I: CloseOutSaleReq, O: CloseOutSaleRes },
    { name: "CalculatePartialCloseoutTotals", options: {}, I: CalculatePartialCloseoutTotalsReq, O: CalculatePartialCloseoutTotalsRes }
]);
